/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const AboutUsFour = ({ width, height }) => {
  return (
    <svg
      id="freepik_stories-good-team"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-good-team:not(.animated) .animable {opacity: 0;}svg#freepik_stories-good-team.animated #freepik--background-complete--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--Hand--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--character-1--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--character-3--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--character-2--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--Floor--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--speech-bubble--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-good-team.animated #freepik--Desk--inject-8 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ',
        }}
      />
      <g
        id="freepik--background-complete--inject-8"
        style={{ transformOrigin: '243.79493713378906px 258.08398818969727px' }}
        className="animable"
      >
        <path
          d="M51.52,406.92A24.74,24.74,0,0,0,41,403.29a7,7,0,0,0-5,.92,1,1,0,0,0-.52.91,1.11,1.11,0,0,0,.49.62,15.11,15.11,0,0,0,15.6,1.18"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '43.5247278213501px 405.85684633255005px',
          }}
          id="elmilq43n67h"
          className="animable"
        />
        <path
          d="M51.25,406.63a52.1,52.1,0,0,1-6.83-6,17.32,17.32,0,0,1-4.28-7.92,3.21,3.21,0,0,1,.34-2.65c5.44,4.25,9.72,9.75,10.77,16.58"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '45.62254333496094px 398.34999084472656px',
          }}
          id="eluooh63a08jo"
          className="animable"
        />
        <path
          d="M51.47,406.88a24.75,24.75,0,0,1,.12-9,12.15,12.15,0,0,1,4.78-7.4c.94,2.2.53,4.73-.13,7a34.21,34.21,0,0,1-4.73,10"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '54.018357038497925px 398.9800262451172px',
          }}
          id="eliefibusqenn"
          className="animable"
        />
        <path
          d="M56.8,416.45a15.6,15.6,0,0,0-8.48,4.29,16.08,16.08,0,0,0-4.85,8.32c3.18-.19,5.88-2.43,7.83-4.95s3.31-5.27,5.46-7.62"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '50.13499641418457px 422.7550048828125px',
          }}
          id="elfanvgbue16w"
          className="animable"
        />
        <path
          d="M58,418a20.91,20.91,0,0,1,2.42-19.78A25.21,25.21,0,0,1,58,418"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '58.99064087867737px 408.1099853515625px',
          }}
          id="elty38zlj5k5"
          className="animable"
        />
        <path
          d="M65,426.37a15.14,15.14,0,0,0-14.46,8.32,1.12,1.12,0,0,0-.09,1.14,1.06,1.06,0,0,0,.95.28c2.85-.19,5.38-1.9,7.46-3.85s3.9-4.21,6.21-5.9"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '57.70253038406372px 431.2361922264099px',
          }}
          id="el24v2mbxopz3"
          className="animable"
        />
        <path
          d="M64.79,425.91a26.9,26.9,0,0,1-.27-15c.53-1.94,1.42-4,3.21-4.88a.62.62,0,0,1,.49-.09.65.65,0,0,1,.31.36,9.1,9.1,0,0,1,.76,4.32,27.19,27.19,0,0,1-.68,4.37c-.56,2.67-.86,5.53-2.33,7.84a15,15,0,0,0-.93,1.72c-.28.59-.28.79-.53,1.26"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '66.44779658317566px 415.91669845581055px',
          }}
          id="eljevqrhbje9"
          className="animable"
        />
        <path
          d="M83.45,428.69a19.4,19.4,0,0,1,3.4-15.94c.24-.32.57-.66,1-.62.61.05.76.86.74,1.48a28.84,28.84,0,0,1-5.11,15.08"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '85.77980661392212px 420.4083786010742px',
          }}
          id="el10aim82zvnh"
          className="animable"
        />
        <path
          d="M85.13,429.84a23.18,23.18,0,0,0,19-3.87,15.44,15.44,0,0,0-10.31-1.26,14.72,14.72,0,0,0-8.73,5.13"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '94.60998916625977px 427.39330530166626px',
          }}
          id="elirnbkg133zj"
          className="animable"
        />
        <path
          d="M86.55,426.34a22,22,0,0,1,17.28-10,10.66,10.66,0,0,1-5.65,6.25,31.2,31.2,0,0,1-8.3,2.42c-1.1.22-2.61.45-3.33,1.32"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '95.19000244140625px 421.33998107910156px',
          }}
          id="eldjlb1kyjsjk"
          className="animable"
        />
        <path
          d="M83.81,409.35A51.09,51.09,0,0,0,86,399.23a16.9,16.9,0,0,0-2-10,22,22,0,0,0-.29,20.48"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '83.71228122711182px 399.47003173828125px',
          }}
          id="elmongvtavsj"
          className="animable"
        />
        <path
          d="M95.06,403.66c3.91-7.11,11.89-12.78,20-13.58-3.12,7.76-11.61,13.75-20,13.58"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '105.05999755859375px 396.87177562713623px',
          }}
          id="el06ugeix527fg"
          className="animable"
        />
        <path
          d="M92.6,405.05c5.83.89,10.8,4.61,16.25,6.87a7.22,7.22,0,0,0,3.67.7,2.87,2.87,0,0,0,1.8-5.08,7.75,7.75,0,0,0-2.67-1.62c-5.93-2.47-12.3-2.53-18.55-1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '103.97963905334473px 408.26639318466187px',
          }}
          id="eluhuyo2pcype"
          className="animable"
        />
        <path
          d="M89.23,409.14c1.32.38,1.77,1.06,2.81,1.95a30.38,30.38,0,0,0,12.32,6.33c.47.12,1.09.17,1.32-.26s-.05-.82-.31-1.15A17,17,0,0,0,97.93,411c-2.85-1.06-5.31-2.34-8.7-2.06"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '97.49764633178711px 413.2025442123413px',
          }}
          id="eltqcw077nzf9"
          className="animable"
        />
        <path
          d="M85.42,384.44a23.33,23.33,0,0,0,17.88,6.09,1.23,1.23,0,0,0,.81-.3c.45-.49-.09-1.24-.62-1.65-5.25-4.1-11.62-5.8-18.07-4.14"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '94.84889602661133px 387.2154839038849px',
          }}
          id="elhpdq3q4cap4"
          className="animable"
        />
        <path
          d="M89.93,382.79a24.94,24.94,0,0,1,22.31-3.68,17.72,17.72,0,0,1-10.63,4.67,33.62,33.62,0,0,1-11.68-1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '101.08499908447266px 380.9296441078186px',
          }}
          id="eluclu4dbhxfh"
          className="animable"
        />
        <path
          d="M88.14,371.44c-.52-5.24-.18-9.38-.55-14.65,0-.42-.11-.93-.51-1.08s-1,.46-1.18,1a16.79,16.79,0,0,0,2.23,14.6"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '86.63541781902313px 363.5634775161743px',
          }}
          id="elpz4u3ddv7dd"
          className="animable"
        />
        <path
          d="M87.76,372a30.77,30.77,0,0,0,8.69-8.44c1.72-2.35,3.16-5.16,2.77-8.05A8.3,8.3,0,0,0,93,358.65a17.54,17.54,0,0,0-3.2,6.42c-.69,2.31-1.18,4.68-2,6.95"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '93.52217817306519px 363.7650146484375px',
          }}
          id="elioaeaonx47"
          className="animable"
        />
        <path
          d="M96.3,369.65A70,70,0,0,0,117.68,357c-2.55-1-5.48-.41-8,.62a25.32,25.32,0,0,0-13.46,11.93"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '106.95000839233398px 363.067262172699px',
          }}
          id="elp4qqu0fsr1"
          className="animable"
        />
        <path
          d="M90.16,374.89A43.77,43.77,0,0,0,102,375a50.41,50.41,0,0,0,11.08-3.68,1.3,1.3,0,0,0,.75-.58.82.82,0,0,0-.27-.94,2.28,2.28,0,0,0-.94-.45,20.54,20.54,0,0,0-12,.72,56.07,56.07,0,0,0-10.52,4.87"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '101.99120426177979px 372.06234645843506px',
          }}
          id="elamot9wlx56b"
          className="animable"
        />
        <path
          d="M67.62,384.62a21,21,0,0,1-.19-17.38c1.64,2.5,1.84,5.67,1.54,8.64s-1.2,6-1.26,9"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '67.36394882202148px 376.0600128173828px',
          }}
          id="elr7n6ad8gcp"
          className="animable"
        />
        <path
          d="M56.86,379.2a24.21,24.21,0,0,0-18,7.67A16.81,16.81,0,0,0,48.71,385a49.74,49.74,0,0,0,8.46-5.66"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '48.01498794555664px 383.0896792411804px',
          }}
          id="elwas650miged"
          className="animable"
        />
        <path
          d="M49.63,376.78c-3.29-.27-6.45-.68-9.62.29a11.54,11.54,0,0,0-7.33,6.22,17.43,17.43,0,0,0,9-1.7,52.2,52.2,0,0,0,7.93-4.81"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '41.154998779296875px 379.90179228782654px',
          }}
          id="el2vvnpsw1h7b"
          className="animable"
        />
        <path
          d="M60.34,376.89c-3-1.94-6-3.92-9.44-4.72s-7.44-.21-9.84,2.39c2.78,1.64,6.17,1.83,9.4,1.83s7.2,0,10.25,1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '50.885000228881836px 374.6140990257263px',
          }}
          id="elh9di1o16ypd"
          className="animable"
        />
        <path
          d="M60.36,377c-5.06-5-7-13.89-4.94-20.68A31.59,31.59,0,0,1,60.36,377"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '57.57763719558716px 366.6600036621094px',
          }}
          id="els3d6pmnzgim"
          className="animable"
        />
        <path
          d="M74.27,363c1-2.22,1.62-4.55,2.48-6.8a19.68,19.68,0,0,1,3.54-6.28,9.27,9.27,0,0,1,6.26-3.24A25.22,25.22,0,0,1,74.39,363"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '80.40999984741211px 354.8400115966797px',
          }}
          id="eljpjgpi9g4wm"
          className="animable"
        />
        <path
          d="M71.75,365.9c-1.58-2.17-3.4-5.12-5.54-6.74a9.22,9.22,0,0,0-7.54-2,17.51,17.51,0,0,0,13.08,8.72"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '65.20999908447266px 361.4575209617615px',
          }}
          id="elznvyco5av9g"
          className="animable"
        />
        <path
          d="M72.26,363.15a37.4,37.4,0,0,1-2.5-8.08A12.66,12.66,0,0,1,71,346.85c2.78,5.25,3.68,10.88,1.38,16.36"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '71.61678576469421px 355.03001403808594px',
          }}
          id="el79ibhujo8xc"
          className="animable"
        />
        <path
          d="M74.29,346.85c1.58-5.2,6.34-9,11.49-10.79a4.23,4.23,0,0,1,2-.31A1.75,1.75,0,0,1,89.27,337c.19.89-.54,1.68-1.23,2.27a39.14,39.14,0,0,1-13.75,7.59"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '81.79528903961182px 341.29687547683716px',
          }}
          id="el2mv1c0dvzjg"
          className="animable"
        />
        <path
          d="M74.35,342.59a37.37,37.37,0,0,1,1.5-9.94,12.58,12.58,0,0,1,6.26-7.55c.52,3.39-1,6.76-2.78,9.68s-4,5.67-5.06,8.92"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '78.24172377586365px 334.40000915527344px',
          }}
          id="eltoih0s1fnb"
          className="animable"
        />
        <path
          d="M74.27,344.9c-1.3-3.79-1.44-8.61-3.71-11.91-1.58-2.31-4.13-3.88-5.49-6.33a9.61,9.61,0,0,0,.32,7.18,20.86,20.86,0,0,0,4.2,6c1.68,1.79,3.12,3.14,4.68,5"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '69.39698791503906px 335.7799987792969px',
          }}
          id="ele4ecolpyu8"
          className="animable"
        />
        <path
          d="M74.29,456.59c-.1,0-.18-25.3-.19-56.5s.07-56.51.17-56.51.19,25.3.19,56.51S74.4,456.59,74.29,456.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '74.27957494556904px 400.0849914550781px',
          }}
          id="elbvspmafnc3w"
          className="animable"
        />
        <path
          d="M96.4,380.81a5.37,5.37,0,0,1-1,.35l-2.61.89c-2.21.75-5.24,1.84-8.54,3.19s-6.33,2.53-8.08,4a6,6,0,0,0-1.62,2.15c-.25.6-.3,1-.33.95a.74.74,0,0,1,0-.26,3.64,3.64,0,0,1,.19-.74,5.71,5.71,0,0,1,1.58-2.29,14.29,14.29,0,0,1,3.51-2.18c1.4-.65,3-1.33,4.61-2,3.3-1.36,6.35-2.41,8.58-3.1,1.12-.35,2-.6,2.66-.77A4.48,4.48,0,0,1,96.4,380.81Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '85.3042459487915px 386.57710123062134px',
          }}
          id="elmqudbdo54yq"
          className="animable"
        />
        <path
          d="M103.65,363s-.08.11-.27.29l-.81.76-3,2.75c-2.62,2.34-6.16,5.5-10.09,9s-7.34,6.85-9.69,9.37c-1.19,1.26-2.12,2.31-2.75,3l-.73.84c-.17.19-.27.29-.28.28a1.82,1.82,0,0,1,.22-.33l.68-.88c.6-.76,1.51-1.83,2.67-3.11a127.69,127.69,0,0,1,9.64-9.48c4-3.49,7.55-6.63,10.16-8.9l3.11-2.67.86-.71A1.84,1.84,0,0,1,103.65,363Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '89.84000778198242px 376.1453466415405px',
          }}
          id="el4vaqdgztlh5"
          className="animable"
        />
        <path
          d="M85.2,379.35c-.1-.05.72-1.94,1.54-4.35s1.22-4.43,1.32-4.41a14.47,14.47,0,0,1-1,4.53,28.14,28.14,0,0,1-1.23,3A4.25,4.25,0,0,1,85.2,379.35Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '86.62584185600281px 374.96992206573486px',
          }}
          id="elv1vdovsapda"
          className="animable"
        />
        <path
          d="M74.32,394.66a3.81,3.81,0,0,1-.61-.7l-1.55-2c-1.31-1.69-3.11-4-5.14-6.57s-3.88-4.84-5.23-6.49l-1.59-2a5.56,5.56,0,0,1-.55-.75,4,4,0,0,1,.66.66c.41.44,1,1.08,1.68,1.89,1.4,1.61,3.29,3.88,5.32,6.43s3.8,4.91,5,6.64c.63.87,1.13,1.57,1.47,2.07A5.3,5.3,0,0,1,74.32,394.66Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '66.98500061035156px 385.4049987792969px',
          }}
          id="el1f12wgyrqdb"
          className="animable"
        />
        <path
          d="M69.47,388.44a9,9,0,0,1-2-3.8,10.88,10.88,0,0,1-.46-3.83h.16c-.07.29-.12.45-.15.44s0-.17,0-.47l.16,0a17.2,17.2,0,0,0,.65,3.72A28.08,28.08,0,0,0,69.47,388.44Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '68.23063826560974px 384.6100158691406px',
          }}
          id="el9pn3va8ly4s"
          className="animable"
        />
        <path
          d="M63.21,380.57a6.35,6.35,0,0,0-1.42-.83,9.63,9.63,0,0,0-3.93-.31,25.54,25.54,0,0,0-4,.64,11.63,11.63,0,0,1-1.63.39,6,6,0,0,1,1.56-.64,18.06,18.06,0,0,1,4-.75,8.59,8.59,0,0,1,4.06.43A2.52,2.52,0,0,1,63.21,380.57Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '57.71999740600586px 379.78127402067184px',
          }}
          id="el3pz23sq5jhx"
          className="animable"
        />
        <path
          d="M61.73,378.66c0,.06-.83-.33-2.17-.79a21.82,21.82,0,0,0-11-.84c-1.4.25-2.25.52-2.27.46s.2-.11.58-.25a13.58,13.58,0,0,1,1.64-.46,19.3,19.3,0,0,1,11.08.85,13.27,13.27,0,0,1,1.56.7A2.2,2.2,0,0,1,61.73,378.66Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '54.0093731880188px 377.4999089241028px',
          }}
          id="elsl9ohr544i8"
          className="animable"
        />
        <path
          d="M74.27,370.59a43.31,43.31,0,0,1-1.58-5.5,44.36,44.36,0,0,1-1.23-5.59A46.91,46.91,0,0,1,73,365,44,44,0,0,1,74.27,370.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '72.86499786376953px 365.0450134277344px',
          }}
          id="el1qphuni5jwm"
          className="animable"
        />
        <path
          d="M74.37,370.59a25.86,25.86,0,0,0-1.76-3.29A14.31,14.31,0,0,0,70,364.63a2.37,2.37,0,0,1,1,.51,8.2,8.2,0,0,1,1.88,1.95A7.27,7.27,0,0,1,74.37,370.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '72.18500518798828px 367.6100158691406px',
          }}
          id="ellk3kpobzaxa"
          className="animable"
        />
        <path
          d="M74.29,443.1s-.11-.6-.39-1.68A25.29,25.29,0,0,0,72.21,437a60.63,60.63,0,0,0-9-12.64c-2-2.28-3.94-4.44-5.59-6.51a45.48,45.48,0,0,1-4-5.77,28.52,28.52,0,0,1-2-4.28c-.19-.53-.32-.94-.4-1.23a2,2,0,0,1-.1-.43s.22.58.63,1.61a32.58,32.58,0,0,0,2.11,4.2,48.9,48.9,0,0,0,4,5.69c1.66,2,3.6,4.19,5.61,6.48a57.55,57.55,0,0,1,8.93,12.77A21.87,21.87,0,0,1,74,441.39a12.33,12.33,0,0,1,.23,1.27A1.63,1.63,0,0,1,74.29,443.1Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '62.70500469207764px 424.62001037597656px',
          }}
          id="elhaisn417rbo"
          className="animable"
        />
        <path
          d="M94.27,420.54a8.19,8.19,0,0,1-1,.59,20.76,20.76,0,0,0-2.72,1.79,32.19,32.19,0,0,0-3.57,3.25c-1.25,1.33-2.54,2.86-3.85,4.51-2.64,3.3-5.1,6.22-6.57,8.55-.75,1.16-1.29,2.14-1.65,2.82a7.43,7.43,0,0,1-.58,1.05,1.72,1.72,0,0,1,.1-.29c.08-.19.19-.47.35-.82a27.42,27.42,0,0,1,1.56-2.89,93.69,93.69,0,0,1,6.5-8.65c1.32-1.65,2.62-3.19,3.9-4.51a28.73,28.73,0,0,1,3.66-3.23,18.48,18.48,0,0,1,2.8-1.71c.35-.17.63-.28.82-.36A1,1,0,0,1,94.27,420.54Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '84.29999160766602px 431.82000732421875px',
          }}
          id="eld8k4rgwhqg"
          className="animable"
        />
        <path
          d="M94.66,427.86a16.52,16.52,0,0,1-2.21.32,29.56,29.56,0,0,0-5.25,1,16,16,0,0,0-4.7,2.47c-1.08.84-1.59,1.53-1.64,1.49a1.72,1.72,0,0,1,.33-.51,8.07,8.07,0,0,1,1.15-1.18,14.15,14.15,0,0,1,4.75-2.61,23.4,23.4,0,0,1,5.34-.95A11.55,11.55,0,0,1,94.66,427.86Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '87.76000595092773px 430.48081374168396px',
          }}
          id="elfa6b05smtmu"
          className="animable"
        />
        <path
          d="M81.5,432.37c-.11-.07.89-1.59,1.66-3.64s.9-3.88,1-3.86a3.86,3.86,0,0,1,0,1.18,12.57,12.57,0,0,1-.65,2.8,13.3,13.3,0,0,1-1.28,2.57A3.5,3.5,0,0,1,81.5,432.37Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '82.84851169586182px 428.6199390888214px',
          }}
          id="elvcdhch9udw"
          className="animable"
        />
        <path
          d="M100.74,400.88s-.11.08-.35.19l-1,.48c-.46.19-1,.44-1.63.77s-1.36.65-2.12,1.11l-1.2.68c-.42.25-.84.53-1.28.81-.89.54-1.78,1.2-2.73,1.88a46.92,46.92,0,0,0-10.53,10.89c-.64,1-1.28,1.89-1.79,2.8-.26.45-.53.87-.76,1.3L76.67,423c-.43.78-.74,1.52-1,2.15s-.53,1.2-.71,1.66l-.44,1.05a1.36,1.36,0,0,1-.18.37,2,2,0,0,1,.11-.39l.37-1.08c.16-.47.37-1,.66-1.69s.58-1.4,1-2.18l.63-1.25c.22-.44.48-.87.74-1.32.5-.92,1.13-1.85,1.77-2.84a49.88,49.88,0,0,1,4.84-5.93,48.91,48.91,0,0,1,5.77-5c1-.68,1.87-1.34,2.77-1.87.45-.27.87-.55,1.29-.79l1.23-.67c.77-.44,1.51-.76,2.15-1.07s1.2-.54,1.66-.72l1.07-.41A2,2,0,0,1,100.74,400.88Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '87.53999328613281px 414.5549774169922px',
          }}
          id="elko7li58117d"
          className="animable"
        />
        <path
          d="M84.93,411.48a2.62,2.62,0,0,1,.87-1.3,5.49,5.49,0,0,1,3.5-1.34,9.61,9.61,0,0,1,3.69.72,4.86,4.86,0,0,1,1.39.68,8.46,8.46,0,0,1-1.47-.44,11.28,11.28,0,0,0-3.59-.59A5.66,5.66,0,0,0,86,410.38,10.15,10.15,0,0,0,84.93,411.48Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '89.65499877929688px 410.15995395183563px',
          }}
          id="el6or3cgw1mf"
          className="animable"
        />
        <path
          d="M82.57,413.92a13.31,13.31,0,0,0,1-3.24,12.9,12.9,0,0,0-.22-3.38,2.2,2.2,0,0,1,.41.94,6.76,6.76,0,0,1,.18,2.48,6.83,6.83,0,0,1-.74,2.37A2.34,2.34,0,0,1,82.57,413.92Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '83.27636653184891px 410.6100158691406px',
          }}
          id="elmkkriytisii"
          className="animable"
        />
        <path
          d="M56.82,446.73c.55,9.67,3.46,19.5,7.94,29.44H84.25c4.27-9.84,7-19.66,7.47-29.44Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '74.27000045776367px 461.45001220703125px',
          }}
          id="elmx4axp4jmro"
          className="animable"
        />
        <path
          d="M88.56,462.37c0,.11-6.42.19-14.33.19s-14.33-.08-14.33-.19,6.41-.18,14.33-.18S88.56,462.27,88.56,462.37Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '74.22999572753906px 462.375px',
          }}
          id="el3zxe208fre3"
          className="animable"
        />
        <path
          d="M88.12,465.88c0,.1-6,.18-13.43.18s-13.43-.08-13.43-.18,6-.19,13.43-.19S88.12,465.78,88.12,465.88Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '74.69000244140625px 465.875px',
          }}
          id="elxbkf0ake54c"
          className="animable"
        />
        <path
          d="M65.08,453.08a56.09,56.09,0,0,1,0,9,53.15,53.15,0,0,1,0-9Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '65.07498931884766px 457.5800018310547px',
          }}
          id="elgjvp5dw0cwj"
          className="animable"
        />
        <path
          d="M75.52,453.08a60,60,0,0,1,0,9.29,56.87,56.87,0,0,1,0-9.29Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '75.51502895355225px 457.7250061035156px',
          }}
          id="elnia9rlabe8o"
          className="animable"
        />
        <path
          d="M85.32,453a62.5,62.5,0,0,1,0,9.48,62.5,62.5,0,0,1,0-9.48Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '85.32000637054443px 457.7400207519531px',
          }}
          id="el5ci566qo6cd"
          className="animable"
        />
        <path
          d="M91.1,453.08c0,.1-7.53.18-16.81.18s-16.81-.08-16.81-.18,7.53-.19,16.81-.19S91.1,453,91.1,453.08Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '74.29000091552734px 453.0749816894531px',
          }}
          id="elfm8lbln2gg"
          className="animable"
        />
        <path
          d="M436,395.09c-.08.1-.78-.32-1.57-.94s-1.34-1.22-1.26-1.33.79.32,1.57.95S436.11,395,436,395.09Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '434.5877401828766px 393.95377123355865px',
          }}
          id="el8ty0liz81pr"
          className="animable"
        />
        <path
          d="M457.34,363.22a24.62,24.62,0,0,0-.73-8.86c-.94-2.83-3.12-5.43-6-6-3.33-.69-6.75,1.41-8.61,4.26s-2.51,6.29-3.06,9.65a341,341,0,0,0-4.18,70.06l13.63,1.91C454.34,409.75,456.25,388.38,457.34,363.22Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '445.94938945770264px 391.233943939209px',
          }}
          id="el7jtlvxdwi7a"
          className="animable"
        />
        <path
          d="M448.68,348.22s0,.08-.06.22l-.22.62c-.22.58-.53,1.36-.91,2.35-.19.52-.44,1.07-.65,1.71l-.66,2.06-.76,2.37c-.22.86-.46,1.76-.71,2.7a120.28,120.28,0,0,0-2.63,13.49c-.74,5.13-1.22,10.8-1.6,16.77-.7,11.94-.81,22.78-1.11,30.62-.15,3.92-.28,7.09-.43,9.28-.07,1.06-.13,1.9-.17,2.52,0,.26,0,.48-.06.65a.74.74,0,0,1,0,.22,1.76,1.76,0,0,1,0-.22c0-.18,0-.39,0-.66,0-.62,0-1.46.08-2.52.09-2.19.17-5.36.27-9.28.22-7.84.28-18.68,1-30.64.38-6,.88-11.66,1.65-16.8a114.2,114.2,0,0,1,2.74-13.51c.26-.95.51-1.85.74-2.71l.8-2.36c.25-.74.49-1.43.7-2.06s.49-1.19.69-1.7l1-2.32c.11-.24.19-.44.27-.6S448.68,348.22,448.68,348.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '443.7009844779968px 391.00999450683594px',
          }}
          id="eliz7qjz0s0xp"
          className="animable"
        />
        <path
          d="M450,348.23a9.88,9.88,0,0,1,1.66,2.82,20.74,20.74,0,0,1,1.24,8.82c-.36,7.53-1,17.91-1.93,29.36s-1.9,21.82-2.7,29.31c-.4,3.74-.75,6.77-1,8.86-.13,1-.23,1.82-.31,2.41l-.09.62a.53.53,0,0,1-.05.21s0-.07,0-.21,0-.38,0-.63c.06-.6.13-1.4.22-2.42.21-2.14.5-5.16.85-8.87.72-7.5,1.67-17.86,2.57-29.31s1.62-21.84,2.07-29.34a21.46,21.46,0,0,0-1.07-8.74A19.78,19.78,0,0,0,450,348.23Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '449.890517950058px 389.4350128173828px',
          }}
          id="el7oib4vb6emg"
          className="animable"
        />
        <path
          d="M459.4,383.51a7.82,7.82,0,0,1-2.59-.67,7.55,7.55,0,0,1-2.42-1.13,14.57,14.57,0,0,1,5,1.8Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '456.8949890136719px 382.6099853515625px',
          }}
          id="ely319ll7s3g"
          className="animable"
        />
        <path
          d="M461,369.62a8.52,8.52,0,0,1-2.46,1.36,8,8,0,0,1-2.66.92,8.52,8.52,0,0,1,2.46-1.36A8,8,0,0,1,461,369.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '458.44000244140625px 370.75999450683594px',
          }}
          id="elc9dkeq00o4c"
          className="animable"
        />
        <path
          d="M460.19,358.28a4.48,4.48,0,0,1-2,.1,4.33,4.33,0,0,1-2-.38,4.44,4.44,0,0,1,2-.1A4.25,4.25,0,0,1,460.19,358.28Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '458.19000244140625px 358.13949021697044px',
          }}
          id="elh9whjuzpe4"
          className="animable"
        />
        <path
          d="M446.12,351c-.11.08-.71-.67-1.33-1.66s-1-1.84-.92-1.92.71.68,1.33,1.66S446.24,350.94,446.12,351Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '444.99994122982025px 349.2100102901459px',
          }}
          id="elokire6jue1j"
          className="animable"
        />
        <path
          d="M441.47,357.87a7.89,7.89,0,0,1-3.86-.08c0-.14.87-.23,1.94-.21S441.48,357.73,441.47,357.87Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '439.540051817894px 357.8243518769741px',
          }}
          id="elpcuaucs0sum"
          className="animable"
        />
        <path
          d="M438.14,371.59a4.91,4.91,0,0,1-2-.56c-1.07-.44-1.9-.89-1.85-1a4.52,4.52,0,0,1,2,.56C437.36,371,438.19,371.46,438.14,371.59Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '436.21501994132996px 370.80999755859375px',
          }}
          id="elyymbcniwkdr"
          className="animable"
        />
        <path
          d="M437.78,383.12c0,.13-.75.41-1.73.61s-1.81.27-1.84.14.75-.41,1.74-.61S437.75,383,437.78,383.12Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '435.99458968639374px 383.4972162246704px',
          }}
          id="el1wrwhi2tdpo"
          className="animable"
        />
        <path
          d="M436.21,402c0,.13-.8.39-1.84.58s-1.9.23-1.93.09.8-.39,1.84-.57A4,4,0,0,1,436.21,402Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '434.3245975971222px 402.33991664648056px',
          }}
          id="el6271fkn9fnn"
          className="animable"
        />
        <path
          d="M435.17,412.4c.06.12-.63.61-1.54,1.09s-1.7.78-1.76.66.62-.61,1.54-1.09S435.11,412.29,435.17,412.4Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '433.51997005939484px 413.27659982442856px',
          }}
          id="eld09uxm7wpj6"
          className="animable"
        />
        <path
          d="M443.67,424.23a5.69,5.69,0,0,1-1.33-1.85,5.34,5.34,0,0,1-.92-2.09c.12-.07.72.76,1.34,1.85A5.35,5.35,0,0,1,443.67,424.23Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '442.54505920410156px 422.25795114040375px',
          }}
          id="el7ilcs8n11qg"
          className="animable"
        />
        <path
          d="M446.13,404.58c.09.1-.58.9-1.49,1.8s-1.74,1.55-1.83,1.46.57-.91,1.49-1.81S446,404.48,446.13,404.58Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '444.4699636697769px 406.2090497016907px',
          }}
          id="elr924dxo07zm"
          className="animable"
        />
        <path
          d="M445.58,394.27c-.09.09-.71-.41-1.38-1.13s-1.12-1.37-1-1.47.71.42,1.38,1.14S445.68,394.18,445.58,394.27Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '444.38749647140503px 392.9690537452698px',
          }}
          id="ele2zs33i5jx"
          className="animable"
        />
        <path
          d="M447.27,381.1c.1.09-.45.88-1.24,1.75s-1.51,1.52-1.61,1.43.46-.87,1.25-1.75S447.17,381,447.27,381.1Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '445.8450782299042px 382.68908536434174px',
          }}
          id="el7zc7av61tm4"
          className="animable"
        />
        <path
          d="M448.22,371.54c-.09.1-.87-.51-1.73-1.36s-1.49-1.61-1.39-1.71.87.52,1.73,1.36S448.32,371.45,448.22,371.54Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '446.65999031066895px 370.0050936937332px',
          }}
          id="elttceopviub"
          className="animable"
        />
        <path
          d="M450.09,358.62a5,5,0,0,1-.87,1.94c-.6,1-1.18,1.75-1.29,1.68s.27-.93.87-1.93S450,358.55,450.09,358.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '449.00053656101227px 360.43000745773315px',
          }}
          id="el5gapzb7l6jf"
          className="animable"
        />
        <path
          d="M453.6,346.65a4.69,4.69,0,0,1-.77,1.94c-.55,1-1.08,1.76-1.2,1.7a4.69,4.69,0,0,1,.77-1.94C452.94,347.35,453.48,346.59,453.6,346.65Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '452.61500549316406px 348.46999621391296px',
          }}
          id="elkcxvqwmvkzt"
          className="animable"
        />
        <path
          d="M457.58,352.09c.06.12-.49.5-1.22.85s-1.37.53-1.43.41.49-.5,1.22-.85S457.52,352,457.58,352.09Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '456.2549819946289px 352.7257744073868px',
          }}
          id="el6kf0cctd18l"
          className="animable"
        />
        <path
          d="M457.68,395.09a5.4,5.4,0,0,1-2.67-.65A5.53,5.53,0,0,1,452.7,393a116.19,116.19,0,0,1,5,2.12Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '455.1999816894531px 394.0600280761719px',
          }}
          id="elk1kerm5fgc"
          className="animable"
        />
        <path
          d="M456.05,404.2c0,.13-.8.4-1.84.6a4,4,0,0,1-1.92.12c0-.13.79-.4,1.83-.6A4,4,0,0,1,456.05,404.2Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '454.16998291015625px 404.55943435430527px',
          }}
          id="elnag454kahlj"
          className="animable"
        />
        <path
          d="M454.05,419.81c-.08.11-1.12-.61-2.08-1.82a5.22,5.22,0,0,1-1.3-2.43,14.57,14.57,0,0,1,1.68,2.13A17.39,17.39,0,0,1,454.05,419.81Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '452.3600158691406px 417.6905138492584px',
          }}
          id="elsegzv0sqmg"
          className="animable"
        />
        <path
          d="M432.14,427c-.09-.11.47-.72,1.24-1.38s1.46-1.11,1.55-1-.47.72-1.24,1.38S432.23,427.06,432.14,427Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '433.53500950336456px 425.80469477176666px',
          }}
          id="elxt5spfn2cs"
          className="animable"
        />
        <path
          d="M425.84,392.87c-.89-2.77-2.55-6-5.46-6a4.84,4.84,0,0,0-4.09,2.74,10.1,10.1,0,0,0-1.1,5,130.26,130.26,0,0,0,6.25,36.3h10.64A126.61,126.61,0,0,0,425.84,392.87Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '423.63103199005127px 408.8899841308594px',
          }}
          id="el3s4g34bfw74"
          className="animable"
        />
        <path
          d="M406.6,375.44c-1.49-5.95-5.93-9.17-11.08-9.47-4.71.83-6.53,5.46-7.09,10.2s.92,9.47,2.37,14l14,43.82,13.24-1.45C413.86,413,411.45,394.85,406.6,375.44Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '403.1743574142456px 399.9800109863281px',
          }}
          id="el2an2w5awl69"
          className="animable"
        />
        <path
          d="M420.38,386.83a13.25,13.25,0,0,0-.9,1.51,10,10,0,0,0-.5,4.7c.21,2,.44,4.46.78,7.13s.83,5.6,1.43,8.66c1.2,6.11,2.55,11.6,3.41,15.59.44,2,.77,3.63,1,4.75.09.52.16.95.22,1.3a1.6,1.6,0,0,1,0,.46,2.57,2.57,0,0,1-.14-.44c-.08-.35-.18-.77-.31-1.28-.28-1.19-.66-2.78-1.12-4.71-.95-4-2.36-9.45-3.56-15.58-.6-3.06-1.07-6-1.4-8.7-.17-1.34-.28-2.62-.39-3.82s-.22-2.31-.28-3.34a9.6,9.6,0,0,1,.67-4.8A4.32,4.32,0,0,1,420.38,386.83Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '422.1957576274872px 408.87998962402344px',
          }}
          id="elzql999d57x"
          className="animable"
        />
        <path
          d="M395.71,365.6a18.87,18.87,0,0,0-1.6,2.15,15.06,15.06,0,0,0-2,6.92,31.91,31.91,0,0,0,1.63,10.66c1.17,3.94,2.44,8.27,3.78,12.8,2.64,9.08,5,17.29,6.78,23.29.83,2.95,1.51,5.36,2,7.08.21.8.39,1.44.52,1.93a5.49,5.49,0,0,1,.15.68,3.36,3.36,0,0,1-.25-.65l-.6-1.91c-.53-1.71-1.26-4.1-2.15-7-1.79-6-4.22-14.19-6.92-23.25-1.32-4.54-2.59-8.87-3.74-12.82a31.78,31.78,0,0,1-1.55-10.8,14.74,14.74,0,0,1,2.2-7A8.21,8.21,0,0,1,395.71,365.6Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '399.35782957077026px 398.35498046875px',
          }}
          id="elw5jkis2og4k"
          className="animable"
        />
        <path
          d="M415.16,431.14a3.87,3.87,0,0,1-.3-.64c-.17-.42-.46-1-.75-1.86-.64-1.63-1.44-4-2.28-7s-1.67-6.63-2.47-10.68-1.61-8.5-2.49-13.17-1.95-9.07-3.14-13a70.25,70.25,0,0,0-3.86-10.2,52.58,52.58,0,0,0-3.57-6.43c-.45-.75-.86-1.28-1.11-1.67a3.82,3.82,0,0,1-.37-.59,3.64,3.64,0,0,1,.45.53c.27.37.71.89,1.19,1.62a47.13,47.13,0,0,1,3.72,6.39,68.32,68.32,0,0,1,4,10.22,131.9,131.9,0,0,1,3.19,13c.87,4.67,1.7,9.12,2.45,13.18s1.57,7.66,2.36,10.67,1.55,5.41,2.12,7.05c.27.83.53,1.46.67,1.89A5,5,0,0,1,415.16,431.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '404.99005126953125px 398.52000427246094px',
          }}
          id="elya5hf7nrvma"
          className="animable"
        />
        <path
          d="M391,388c0,.13-.69.42-1.61.64s-1.69.3-1.72.17.68-.42,1.6-.64S391,387.87,391,388Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '389.33454942703247px 388.404996663332px',
          }}
          id="elic4i1sec20n"
          className="animable"
        />
        <path
          d="M389.63,379a6.39,6.39,0,0,1-2.23.24,6.66,6.66,0,0,1-2.24-.06,4.45,4.45,0,0,1,2.22-.42A4.63,4.63,0,0,1,389.63,379Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '387.39501953125px 379.0107629597187px',
          }}
          id="elq5k47j96ass"
          className="animable"
        />
        <path
          d="M391.13,370.71c-.09.1-.81-.36-1.61-1s-1.38-1.31-1.29-1.42.8.37,1.6,1.05S391.21,370.61,391.13,370.71Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '389.67908132076263px 369.49896562099457px',
          }}
          id="eltvlnunsnx1"
          className="animable"
        />
        <path
          d="M395.16,363.07c.14,0,.1.67.08,1.45s0,1.43-.16,1.45-.35-.63-.33-1.46S395,363,395.16,363.07Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '395.00476509332657px 364.51775193214417px',
          }}
          id="el6bolft2c6me"
          className="animable"
        />
        <path
          d="M403.42,366.67c.11.08-.22.73-.73,1.46s-1,1.25-1.12,1.17.22-.72.73-1.45S403.31,366.59,403.42,366.67Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '402.49350160360336px 367.9850744009018px',
          }}
          id="eldrpmavsxayb"
          className="animable"
        />
        <path
          d="M408.77,376c.05.13-.63.53-1.53.89s-1.66.56-1.71.44.63-.52,1.53-.89S408.72,375.85,408.77,376Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '407.1499880552292px 376.6586283445358px',
          }}
          id="ela8757e05hhf"
          className="animable"
        />
        <path
          d="M412,385.55a4.05,4.05,0,0,1-2.1.91,4,4,0,0,1-2.29.08,8.65,8.65,0,0,1,2.18-.55A8.51,8.51,0,0,1,412,385.55Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '409.80499267578125px 386.1099543571472px',
          }}
          id="elfl62uy8wywc"
          className="animable"
        />
        <path
          d="M397.1,382.83c-.12,0,0-.7.21-1.48s.55-1.37.67-1.33,0,.7-.2,1.48S397.23,382.87,397.1,382.83Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '397.5401189029217px 381.4249850511551px',
          }}
          id="el53o1wqb3l5s"
          className="animable"
        />
        <path
          d="M399.19,394.85c-.13-.06.14-1,.59-2s.93-1.85,1.05-1.8a4.75,4.75,0,0,1-.6,2C399.78,394.09,399.31,394.9,399.19,394.85Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '399.99363058805466px 392.95005452632904px',
          }}
          id="elrljkvvcs5bd"
          className="animable"
        />
        <path
          d="M394,398.14a5.05,5.05,0,0,1-1.9-.42c-1-.32-1.84-.61-1.81-.75a3.66,3.66,0,0,1,1.95.28C393.32,397.58,394.1,398,394,398.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '392.14891719818115px 397.53960371017456px',
          }}
          id="ely2j50hfqdw"
          className="animable"
        />
        <path
          d="M397,407.93c.08.11-.49.65-1.27,1.21s-1.47.91-1.55.8.49-.64,1.27-1.2S396.93,407.82,397,407.93Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '395.5900231599808px 408.93517911434174px',
          }}
          id="elyzsb1musdun"
          className="animable"
        />
        <path
          d="M399.38,417.7c0,.13-.66.42-1.56.64s-1.65.28-1.68.15.67-.41,1.56-.63S399.35,417.57,399.38,417.7Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '397.7595589160919px 418.09638753533363px',
          }}
          id="elvdp997zes9s"
          className="animable"
        />
        <path
          d="M412.28,393.71c.07.11-.53.59-1.4.92s-1.64.36-1.67.23.67-.37,1.5-.69S412.21,393.59,412.28,393.71Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '410.7473167181015px 394.30594450235367px',
          }}
          id="el25z9081klvz"
          className="animable"
        />
        <path
          d="M414.13,408.91c-.06.12-.78-.1-1.6-.49s-1.45-.8-1.39-.92.77.1,1.6.48S414.18,408.78,414.13,408.91Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '412.63443660736084px 408.20496690273285px',
          }}
          id="el98yz91hb2u"
          className="animable"
        />
        <path
          d="M417.38,419.78a5,5,0,0,1-2.11-.56c-1.11-.44-2-.89-1.93-1a5,5,0,0,1,2.11.56A5.2,5.2,0,0,1,417.38,419.78Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '415.3580729961395px 419px',
          }}
          id="ell2ru61hc5e8"
          className="animable"
        />
        <path
          d="M399.91,428.3c-.07-.12.8-.7,1.8-1.5s1.78-1.49,1.88-1.39-.53,1-1.58,1.78A4.32,4.32,0,0,1,399.91,428.3Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '401.7531977891922px 426.85017144680023px',
          }}
          id="eliga1o62bb6r"
          className="animable"
        />
        <path
          d="M408.51,422.77c-.14,0-.33-.71-.66-1.56s-.68-1.52-.57-1.6.67.5,1,1.42S408.64,422.76,408.51,422.77Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '407.9205387830734px 421.1863065958023px',
          }}
          id="eli5g5j4rphu"
          className="animable"
        />
        <path
          d="M406.23,409.69c-.08.11-.64-.15-1.24-.59s-1-.88-1-1,.63.16,1.24.6S406.3,409.58,406.23,409.69Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '405.11353743076324px 408.8936685323715px',
          }}
          id="eld3wiqn5zy0j"
          className="animable"
        />
        <path
          d="M426.27,389.19c.08.11-.46.65-1.21,1.2s-1.41.91-1.49.8.46-.64,1.2-1.19S426.19,389.09,426.27,389.19Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '424.92001008987427px 390.19156897068024px',
          }}
          id="el6yi6ys5e5pm"
          className="animable"
        />
        <path
          d="M429.29,397.45c0,.13-.83.31-1.88.2s-1.84-.47-1.8-.59.85,0,1.85.1A5.58,5.58,0,0,1,429.29,397.45Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '427.4492746591568px 397.34695902466774px',
          }}
          id="ellnd333g8hl"
          className="animable"
        />
        <path
          d="M416.31,399.31c0,.12-.76.4-1.77.47s-1.83-.1-1.82-.24.81-.18,1.79-.25S416.28,399.17,416.31,399.31Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '414.5149528980255px 399.508562207222px',
          }}
          id="elmchfv311amd"
          className="animable"
        />
        <path
          d="M417.42,391.5c0,.13-.8.15-1.67-.25s-1.37-1-1.28-1.11.69.3,1.49.66S417.44,391.36,417.42,391.5Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '415.94001376628876px 390.852687060833px',
          }}
          id="el57ct611mebn"
          className="animable"
        />
        <path
          d="M430.41,406.32c-.07.11-.89-.27-1.82-.85S427,404.31,427,404.2s.88.27,1.81.85S430.48,406.21,430.41,406.32Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '428.70729637145996px 405.26000714302063px',
          }}
          id="el5fpx6yb2h55"
          className="animable"
        />
        <rect
          x="392.81"
          y="429.5"
          width="69.28"
          height="12.28"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '427.45px 435.64px',
          }}
          id="elry1j244xf5p"
          className="animable"
        />
        <polygon
          points="397.99 439.34 406.41 476.04 447.7 476.04 456.92 439.34 397.99 439.34"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '427.4550018310547px 457.69000244140625px',
          }}
          id="el63rapkj8g9s"
          className="animable"
        />
        <path
          d="M462.06,441.79c0,.14-15.63.24-34.91.24s-34.9-.1-34.9-.24,15.62-.24,34.9-.24S462.06,441.66,462.06,441.79Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '427.1549987792969px 441.7900085449219px',
          }}
          id="elwbmgd30awlf"
          className="animable"
        />
        <path
          d="M423.53,399.57c-.12.07-.59-.48-1.06-1.23s-.76-1.42-.65-1.49.59.48,1.06,1.23S423.64,399.5,423.53,399.57Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '422.6750180721283px 398.2099986076355px',
          }}
          id="el26a9onvltl6"
          className="animable"
        />
        <path
          d="M423.55,409.45c-.13,0,0-.87.36-1.86s.7-1.75.83-1.71,0,.87-.36,1.86S423.68,409.5,423.55,409.45Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '424.14497393369675px 407.665434718132px',
          }}
          id="elqxzsge6nu6b"
          className="animable"
        />
        <path
          d="M426.93,419.83a5.17,5.17,0,0,1-1.15-1.86,5,5,0,0,1-.72-2.06c.12-.06.64.77,1.16,1.85A5.13,5.13,0,0,1,426.93,419.83Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '425.9949951171875px 417.86847257614136px',
          }}
          id="elx7c4qruzh0p"
          className="animable"
        />
        <path
          d="M419.61,428.17c-.1-.09.32-.73.93-1.44s1.19-1.2,1.29-1.11-.31.73-.92,1.43S419.72,428.26,419.61,428.17Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '420.7201187610626px 426.89484798908234px',
          }}
          id="el4442bvnwjwc"
          className="animable"
        />
        <path
          d="M418.08,413c0,.13-.69.12-1.49,0s-1.43-.36-1.4-.49.69-.13,1.48,0S418.1,412.89,418.08,413Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '416.6346997022629px 412.7531468272209px',
          }}
          id="elirs531063za"
          className="animable"
        />
        <g id="elrp6gy0idyq">
          <rect
            x="387.13"
            y="82.12"
            width="15.61"
            height="41.94"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '394.935px 103.09px',
              transform: 'rotate(-17.77deg)',
            }}
            className="animable"
            id="eltbtbp2xwcnn"
          />
        </g>
        <g id="elvmwzdevfuhs">
          <rect
            x="383.12"
            y="83.41"
            width="15.61"
            height="41.94"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '390.925px 104.38px',
              transform: 'rotate(-17.77deg)',
            }}
            className="animable"
            id="ele7emxjc828v"
          />
        </g>
        <path
          d="M390.59,93.13a3.52,3.52,0,1,1-4.43-2.28A3.53,3.53,0,0,1,390.59,93.13Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '387.2369225025177px 94.20248770713806px',
          }}
          id="elo1btvj9t1gf"
          className="animable"
        />
        <path
          d="M397.87,86.76a13.47,13.47,0,0,1-.83,3.6,13.32,13.32,0,0,1-1.33,3.44,13.47,13.47,0,0,1,.83-3.6A13.32,13.32,0,0,1,397.87,86.76Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '396.7900085449219px 90.28000259399414px',
          }}
          id="el3niwqqe040q"
          className="animable"
        />
        <path
          d="M399.28,91.18a13.1,13.1,0,0,1-.82,3.59,13.3,13.3,0,0,1-1.33,3.45,13,13,0,0,1,.83-3.6A13.53,13.53,0,0,1,399.28,91.18Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '398.2050018310547px 94.69999313354492px',
          }}
          id="eleln3ie6qux8"
          className="animable"
        />
        <path
          d="M400.7,95.6a12.92,12.92,0,0,1-.83,3.59,12.9,12.9,0,0,1-1.33,3.45,14,14,0,0,1,.83-3.6A13.13,13.13,0,0,1,400.7,95.6Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '399.6200256347656px 99.12000274658203px',
          }}
          id="el7g936guuwib"
          className="animable"
        />
        <path
          d="M402.12,100a13.78,13.78,0,0,1-.83,3.6,13.3,13.3,0,0,1-1.33,3.45,13,13,0,0,1,.83-3.6A13.08,13.08,0,0,1,402.12,100Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '401.0400085449219px 103.52499771118164px',
          }}
          id="el4ob4adkfxqx"
          className="animable"
        />
        <path
          d="M403.53,104.43a12.87,12.87,0,0,1-.83,3.6,13.51,13.51,0,0,1-1.32,3.45,12.87,12.87,0,0,1,.83-3.6A13.09,13.09,0,0,1,403.53,104.43Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '402.4550018310547px 107.95499801635742px',
          }}
          id="ely9x1aoyjf1m"
          className="animable"
        />
        <path
          d="M405,108.85a13.47,13.47,0,0,1-.83,3.6,13.13,13.13,0,0,1-1.33,3.44,13.84,13.84,0,0,1,.83-3.59A13.3,13.3,0,0,1,405,108.85Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '403.9199981689453px 112.36999130249023px',
          }}
          id="eluy7lxid6c4m"
          className="animable"
        />
        <path
          d="M406.36,113.27a13.21,13.21,0,0,1-.82,3.6,13.13,13.13,0,0,1-1.33,3.44,12.92,12.92,0,0,1,.83-3.59A13.51,13.51,0,0,1,406.36,113.27Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '405.2849884033203px 116.78999328613281px',
          }}
          id="elmjr6sgialm"
          className="animable"
        />
        <path
          d="M396.58,82.87a13.31,13.31,0,0,1-.83,3.6,13.3,13.3,0,0,1-1.33,3.45,13.87,13.87,0,0,1,.83-3.6A13.49,13.49,0,0,1,396.58,82.87Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '395.5px 86.39500427246094px',
          }}
          id="elzf90xytf31"
          className="animable"
        />
        <path
          d="M394.39,81.25a5,5,0,0,1-.39,2.16c-.35,1.15-.75,2-.89,2a4.79,4.79,0,0,1,.39-2.16C393.85,82.11,394.25,81.21,394.39,81.25Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '393.7489870786667px 83.32936191558838px',
          }}
          id="el8ffkq5el8i8"
          className="animable"
        />
        <path
          d="M415.27,115.14,404.76,79.59s7.37-4,10.95-17c2.37-8.55-1.74-15.49-1.84-18.88-.06-2.07,4.53-3.13,6.57-3.53s5.32-.33,7.55,2.2c4.14,4.68,5,18.78,5,18.78s-.61,3.12,3.11,1.93l13.25-4.24a7.58,7.58,0,0,1,5.25.17A5.63,5.63,0,0,1,458,63.11c1.22,5.17-.71,8.28-.37,9.34S460,74.9,460,78.29s-.83,3.34-.36,4.8a25.16,25.16,0,0,1,1.18,7.82,11.28,11.28,0,0,1-.92,4s2.11,4.68,1.49,7.86c-.81,4.17-8.81,9.33-12.95,8.83-1.93-.23-10.42.42-14.44.68S418.3,112.27,415.27,115.14Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '433.13201904296875px 77.5689811706543px',
          }}
          id="els8idzre7vl"
          className="animable"
        />
        <path
          d="M410.65,117.07l-11.44-35.7s7.37-4,11-17a62.65,62.65,0,0,0,2.53-18.32,4.25,4.25,0,0,1,3.37-4.34,6.5,6.5,0,0,1,6.63,2.16c4.13,4.68,4.72,19.07,4.72,19.07s-.61,3.12,3.11,1.93l13.25-4.25a7.59,7.59,0,0,1,5.25.18,5.63,5.63,0,0,1,3.44,4.06c1.22,5.17-.71,8.28-.37,9.34s2.39,2.45,2.31,5.84-.83,3.34-.36,4.8a25.16,25.16,0,0,1,1.18,7.82,11.28,11.28,0,0,1-.92,4s1.92,4.65,1.49,7.86-5.54,6.46-7.4,7-16,2.2-20,2.46S413.68,114.19,410.65,117.07Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '427.5563678741455px 79.28787231445312px',
          }}
          id="elv9h1rtzebh"
          className="animable"
        />
        <path
          d="M431.91,53.67a18.17,18.17,0,0,1-1.86,4.49,18.42,18.42,0,0,1-2.57,4.13,29.58,29.58,0,0,1,2.1-4.37A32,32,0,0,1,431.91,53.67Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '429.69500732421875px 57.97999382019043px',
          }}
          id="elfljvu8a2ghq"
          className="animable"
        />
        <path
          d="M431.1,48.67a12.38,12.38,0,0,1-1.85,4,21,21,0,0,1-2.54,3.63,18,18,0,0,1,2.09-3.9A41,41,0,0,1,431.1,48.67Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '428.90501403808594px 52.48500061035156px',
          }}
          id="elow3yndvqkpl"
          className="animable"
        />
        <path
          d="M429.35,44.48a7.37,7.37,0,0,1-1.55,3.27,20.82,20.82,0,0,1-2.21,2.83,9,9,0,0,1,1.78-3.13C428.53,45.87,429.21,44.42,429.35,44.48Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '427.4700164794922px 47.529101610183716px',
          }}
          id="el9gb5tpkih2w"
          className="animable"
        />
        <path
          d="M426.74,41.36a6.64,6.64,0,0,1-1.16,2.38c-.76,1.24-1.48,2.18-1.61,2.1a7,7,0,0,1,1.17-2.38C425.9,42.22,426.62,41.28,426.74,41.36Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '425.35499572753906px 43.60000157356262px',
          }}
          id="eli6uetlrnj8r"
          className="animable"
        />
        <path
          d="M423.37,40.1c.11.1-.23.71-.77,1.38s-1.06,1.13-1.17,1,.23-.7.77-1.37S423.27,40,423.37,40.1Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '422.3999813199043px 41.29393684864044px',
          }}
          id="el5yza50u5syl"
          className="animable"
        />
        <path
          d="M432.89,60.29a7.39,7.39,0,0,1-1.24,2.51A7.62,7.62,0,0,1,430,65a7.73,7.73,0,0,1,1.24-2.51A8,8,0,0,1,432.89,60.29Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '431.4450225830078px 62.64499855041504px',
          }}
          id="elbpxuq9q6oen"
          className="animable"
        />
        <path
          d="M458.45,65.83a26.72,26.72,0,0,1-3,4.24A25.36,25.36,0,0,1,452.11,74a26.2,26.2,0,0,1,3-4.24A25.68,25.68,0,0,1,458.45,65.83Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '455.2799987792969px 69.91498947143555px',
          }}
          id="eln8ffml9ginl"
          className="animable"
        />
        <path
          d="M456.3,59.84a9.23,9.23,0,0,1-1.68,2.6,9.09,9.09,0,0,1-2.09,2.28,9.52,9.52,0,0,1,1.68-2.6A9.3,9.3,0,0,1,456.3,59.84Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '454.41497802734375px 62.28000831604004px',
          }}
          id="eldjn23ch5fv4"
          className="animable"
        />
        <path
          d="M459.2,75.14a20.1,20.1,0,0,1-2.27,3.06,21.41,21.41,0,0,1-2.41,3,10.53,10.53,0,0,1,2-3.27A10.6,10.6,0,0,1,459.2,75.14Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '456.86000061035156px 78.16999053955078px',
          }}
          id="elpeea7g16spi"
          className="animable"
        />
        <path
          d="M459.47,82.63a13.86,13.86,0,0,1-2,3.24,14.21,14.21,0,0,1-2.39,2.93,13.65,13.65,0,0,1,2-3.23A14,14,0,0,1,459.47,82.63Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '457.2749938964844px 85.7149887084961px',
          }}
          id="eluyiv8pmkogo"
          className="animable"
        />
        <path
          d="M460.53,91.27a13.93,13.93,0,0,1-2.26,3.79,14.25,14.25,0,0,1-3,3.27,29.12,29.12,0,0,1,2.56-3.58A27.55,27.55,0,0,1,460.53,91.27Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '457.8999938964844px 94.79999923706055px',
          }}
          id="el7fwapegwfvc"
          className="animable"
        />
        <path
          d="M461,98.65a18.2,18.2,0,0,1-2.7,4.39,18.29,18.29,0,0,1-3.41,3.85,42,42,0,0,1,3-4.16A42,42,0,0,1,461,98.65Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '457.9449768066406px 102.7699966430664px',
          }}
          id="elrop7b1immwq"
          className="animable"
        />
        <g id="eldzmcvc6odwm">
          <rect
            x="62.17"
            y="120.85"
            width="34.76"
            height="12.93"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '79.55px 127.315px',
              transform: 'rotate(-61.69deg)',
            }}
            className="animable"
            id="elgmoq0vasd44"
          />
        </g>
        <g id="ellmfuny2ihs">
          <rect
            x="65.25"
            y="122.51"
            width="34.76"
            height="12.93"
            style={{
              fill: 'rgb(235, 235, 235)',
              transformOrigin: '82.63px 128.975px',
              transform: 'rotate(-61.69deg)',
            }}
            className="animable"
            id="elwsrm9m87kg"
          />
        </g>
        <path
          d="M84.6,119.86a2.92,2.92,0,1,0,4-1.19A2.92,2.92,0,0,0,84.6,119.86Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '87.18245029449463px 121.22310996055603px',
          }}
          id="elfalelgplbpp"
          className="animable"
        />
        <path
          d="M79.64,113.56a9.38,9.38,0,0,1,.6,3,9.34,9.34,0,0,1,.09,3.06,8.91,8.91,0,0,1-.61-3A8.92,8.92,0,0,1,79.64,113.56Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '79.97997614741325px 116.58999252319336px',
          }}
          id="elpqcgakcvfqc"
          className="animable"
        />
        <path
          d="M77.81,117a8.83,8.83,0,0,1,.61,3A8.84,8.84,0,0,1,78.5,123a9.19,9.19,0,0,1-.6-3A9.34,9.34,0,0,1,77.81,117Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '78.16044396162033px 119.99999618530273px',
          }}
          id="elehd9mi91vvc"
          className="animable"
        />
        <path
          d="M76,120.34a9.19,9.19,0,0,1,.6,3,9.34,9.34,0,0,1,.09,3.06,9.28,9.28,0,0,1-.6-3A9.32,9.32,0,0,1,76,120.34Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '76.34486132860184px 123.3699951171875px',
          }}
          id="elohhkgp1dss9"
          className="animable"
        />
        <path
          d="M74.17,123.72a9.28,9.28,0,0,1,.6,3,9.4,9.4,0,0,1,.09,3.07,8.93,8.93,0,0,1-.61-3A8.86,8.86,0,0,1,74.17,123.72Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '74.50911551713943px 126.7550048828125px',
          }}
          id="els2kqylppcgq"
          className="animable"
        />
        <path
          d="M72.34,127.11a8.75,8.75,0,0,1,.61,3,9.17,9.17,0,0,1,.08,3.06,9.28,9.28,0,0,1-.6-3A9.32,9.32,0,0,1,72.34,127.11Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '72.68809825181961px 130.13999938964844px',
          }}
          id="elax7gen0xy6q"
          className="animable"
        />
        <path
          d="M70.52,130.49a9.36,9.36,0,0,1,.6,3,9.4,9.4,0,0,1,.09,3.07,9.38,9.38,0,0,1-.6-3A9.34,9.34,0,0,1,70.52,130.49Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '70.86459401249886px 133.52500915527344px',
          }}
          id="elphv0o58rbq9"
          className="animable"
        />
        <path
          d="M68.7,133.88a9.28,9.28,0,0,1,.6,3,8.84,8.84,0,0,1,.08,3.06,9.28,9.28,0,0,1-.6-3A8.84,8.84,0,0,1,68.7,133.88Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '69.03999698162079px 136.91000366210938px',
          }}
          id="ello0dddo0d7m"
          className="animable"
        />
        <path
          d="M81.28,110.6a9.19,9.19,0,0,1,.6,3,9.34,9.34,0,0,1,.09,3.06,8.83,8.83,0,0,1-.61-3A8.84,8.84,0,0,1,81.28,110.6Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '81.61938926577568px 113.62999725341797px',
          }}
          id="el66933st66an"
          className="animable"
        />
        <path
          d="M83.31,109.6c.14,0,.35.78.46,1.77s.09,1.81,0,1.82-.35-.77-.47-1.76S83.17,109.62,83.31,109.6Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '83.52633988857269px 111.39504420757294px',
          }}
          id="eltfeus6oe9p"
          className="animable"
        />
        <path
          d="M61.16,134.05,75.1,106.68s-5.39-4.41-6.35-15.49c-.63-7.32,3.77-12.36,4.37-15.1.37-1.68-3.22-3.23-4.82-3.87a6.68,6.68,0,0,0-6.49.64c-4.08,3.19-6.89,14.55-6.89,14.55s0,2.64-2.82,1.11L41.94,83.05a6.26,6.26,0,0,0-4.3-.66,4.67,4.67,0,0,0-3.42,2.79c-1.78,4-.68,6.85-1.11,7.67s-2.33,1.63-2.77,4.41.17,2.84-.43,4a20.33,20.33,0,0,0-2.15,6.19,9.48,9.48,0,0,0,.15,3.36s-2.43,3.5-2.41,6.18c0,3.52,5.76,8.94,9.21,9.16,1.62.1,8.43,1.92,11.66,2.74S59.12,131.25,61.16,134.05Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '50.2999382019043px 102.85596084594727px',
          }}
          id="elr9ttddtmhns"
          className="animable"
        />
        <path
          d="M64.63,136.32,79.36,109S74,104.56,73,93.48a51.56,51.56,0,0,1,.72-15.31,3.54,3.54,0,0,0-2.09-4,5.38,5.38,0,0,0-5.73.75c-4.08,3.19-6.74,14.82-6.74,14.82s0,2.64-2.82,1.11L46.2,85.34a6.29,6.29,0,0,0-4.31-.66,4.7,4.7,0,0,0-3.42,2.79c-1.77,4-.67,6.85-1.11,7.67S35,96.77,34.59,99.55s.17,2.85-.43,4A20.88,20.88,0,0,0,32,109.7a9.48,9.48,0,0,0,.15,3.36s-2.27,3.5-2.41,6.18,3.54,6.1,5,6.87,12.69,4.21,15.92,5S62.59,133.52,64.63,136.32Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '54.54805946350098px 104.99239921569824px',
          }}
          id="ely9s0bklvhij"
          className="animable"
        />
        <path
          d="M56.91,81.44a19.58,19.58,0,0,1,1.3,3.81,20,20,0,0,1,1,3.89,13.21,13.21,0,0,1-1.51-3.74A13.44,13.44,0,0,1,56.91,81.44Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '58.06000328063965px 85.29000473022461px',
          }}
          id="el6p1k7mgu1fd"
          className="animable"
        />
        <path
          d="M58.34,77.49a25.17,25.17,0,0,1,1.34,3.4,12.48,12.48,0,0,1,1.07,3.5,14,14,0,0,1-1.56-3.32A8.94,8.94,0,0,1,58.34,77.49Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '59.545000076293945px 80.93999862670898px',
          }}
          id="eludv2fw28ou"
          className="animable"
        />
        <path
          d="M60.39,74.34a21,21,0,0,1,1.2,2.7,6.84,6.84,0,0,1,.95,2.84,11.77,11.77,0,0,1-1.42-2.62A5.55,5.55,0,0,1,60.39,74.34Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '61.46377766132355px 77.10999298095703px',
          }}
          id="el1fguk3b616n"
          className="animable"
        />
        <path
          d="M63,72.2c.14-.06.6.81,1,1.94a4.83,4.83,0,0,1,.55,2.13c-.14,0-.6-.82-1-1.94A4.86,4.86,0,0,1,63,72.2Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '63.775001525878906px 74.23353004455566px',
          }}
          id="elie3qzvs3efr"
          className="animable"
        />
        <path
          d="M65.93,71.68c.12-.07.5.38.84,1s.5,1.2.38,1.26-.51-.39-.84-1S65.8,71.76,65.93,71.68Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '66.53855776786804px 72.80909526348114px',
          }}
          id="elu767jxp762"
          className="animable"
        />
        <path
          d="M55.11,86.69a5.39,5.39,0,0,1,1.08,2.07A5.13,5.13,0,0,1,56.77,91a5.56,5.56,0,0,1-1.07-2.07A5.43,5.43,0,0,1,55.11,86.69Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '55.939998626708984px 88.84500503540039px',
          }}
          id="el996sstwbd9c"
          className="animable"
        />
        <path
          d="M33.45,87.33A17.38,17.38,0,0,1,35.64,91a17.19,17.19,0,0,1,1.73,3.93,18.51,18.51,0,0,1-2.19-3.69A18,18,0,0,1,33.45,87.33Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '35.40999984741211px 91.13000106811523px',
          }}
          id="el9y381t2k7f9"
          className="animable"
        />
        <path
          d="M36.11,82.78a6.44,6.44,0,0,1,1.39,2.15,6.33,6.33,0,0,1,.94,2.39A6.34,6.34,0,0,1,37,85.17,6.54,6.54,0,0,1,36.11,82.78Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '37.27499771118164px 85.04999542236328px',
          }}
          id="elhuhcegrn089"
          className="animable"
        />
        <path
          d="M31.43,94.8a7.74,7.74,0,0,1,1.8,2.62,7.64,7.64,0,0,1,1.1,3,13.84,13.84,0,0,1-1.56-2.75A13,13,0,0,1,31.43,94.8Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '32.879998207092285px 97.61000442504883px',
          }}
          id="el4cmm5ov7d7f"
          className="animable"
        />
        <path
          d="M30.07,100.87a9.46,9.46,0,0,1,1.55,2.73,9.57,9.57,0,0,1,1.08,3,9.74,9.74,0,0,1-1.55-2.73A9.57,9.57,0,0,1,30.07,100.87Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '31.38500213623047px 103.73500061035156px',
          }}
          id="el1ch0xk6rgko"
          className="animable"
        />
        <path
          d="M27.9,107.74A18,18,0,0,1,29.6,111a19.08,19.08,0,0,1,1.5,3.32,10.21,10.21,0,0,1-2-3.1A10.24,10.24,0,0,1,27.9,107.74Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '29.5px 111.02999877929688px',
          }}
          id="el5inmiacfd8b"
          className="animable"
        />
        <path
          d="M26.38,113.68a26.43,26.43,0,0,1,2,3.78,26.36,26.36,0,0,1,1.77,3.86,13.27,13.27,0,0,1-2.24-3.64A13.15,13.15,0,0,1,26.38,113.68Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '28.26499843597412px 117.50000381469727px',
          }}
          id="el37sgp8z52j5"
          className="animable"
        />
      </g>
      <g
        id="freepik--Hand--inject-8"
        style={{ transformOrigin: '289.86048889160156px 100.71999645233154px' }}
        className="animable"
      >
        <path
          d="M243.43,174.12,245,107.47s14.84-2.88,28.06-23c8.75-13.35,5.53-27.5,7.21-33.36,1-3.58,9.47-2.86,13.18-2.43,3.5.41,9.3,2.36,11.74,7.91,4.51,10.28-1.81,34.89-1.81,34.89s-2.75,5,4.26,5h25a13.61,13.61,0,0,1,8.9,3.19,10.11,10.11,0,0,1,3.66,8.84c-.75,9.53-5.76,13.79-5.76,15.79s2.75,5.51.75,11.28-3.26,5.26-3.26,8-.5,9.77-2.25,14a20.47,20.47,0,0,1-3.76,6.26s.75,9-1.76,14.29-13,8-16.54,8-28.56-5-35.58-6.76S250.2,170.86,243.43,174.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '294.34048080444336px 117.22297668457031px',
          }}
          id="ela0601r1atn7"
          className="animable"
        />
        <path
          d="M234.47,174.88V107.47s14.85-2.88,28.07-23c8.75-13.35,12.7-24.14,14.38-30a7.65,7.65,0,0,1,8.16-5.57c3.5.41,7.72,1.78,10.16,7.33,4.51,10.29-2.38,35.25-2.38,35.25s-2.76,5,4.26,5h25a13.63,13.63,0,0,1,8.9,3.19,10.11,10.11,0,0,1,3.66,8.84c-.75,9.53-5.77,13.79-5.77,15.79s2.76,5.51.76,11.28-3.26,5.26-3.26,8-.5,9.77-2.26,14a20.35,20.35,0,0,1-3.75,6.26s.75,9-1.76,14.29-13,8-16.54,8-28.56-5-35.58-6.76S241.24,171.62,234.47,174.88Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '284.6004829406738px 117.4945297241211px',
          }}
          id="elqp672vs2bb"
          className="animable"
        />
        <path
          d="M264.11,49.6a44.68,44.68,0,0,1-5.57-4.14,45.92,45.92,0,0,1-5.24-4.55,46.34,46.34,0,0,1,5.57,4.15A47.6,47.6,0,0,1,264.11,49.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '258.7049789428711px 45.2549934387207px',
          }}
          id="el72hv3vrawex"
          className="animable"
        />
        <path
          d="M274.77,42a18.45,18.45,0,0,1-1.95-2.5c-1.14-1.6-2.66-3.85-4.22-6.4s-2.88-4.92-3.78-6.66a17.17,17.17,0,0,1-1.35-2.87,19.48,19.48,0,0,1,1.67,2.7c1,1.69,2.35,4,3.9,6.56s3,4.82,4.08,6.46A21.26,21.26,0,0,1,274.77,42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '269.11997985839844px 32.785000801086426px',
          }}
          id="el1naw5wx1zsv"
          className="animable"
        />
        <path
          d="M284.55,15.31a89.06,89.06,0,0,1,.26,9.72,89.18,89.18,0,0,1-.26,9.73,92.31,92.31,0,0,1-.26-9.73A92.2,92.2,0,0,1,284.55,15.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '284.5516736805439px 25.034993171691895px',
          }}
          id="el4dbvx1o45y6"
          className="animable"
        />
        <path
          d="M307.11,30.53a39.66,39.66,0,0,1-4.33,4.7,37.2,37.2,0,0,1-4.7,4.32,40.07,40.07,0,0,1,4.33-4.69A38.77,38.77,0,0,1,307.11,30.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '302.594970703125px 35.03999900817871px',
          }}
          id="elfc589m6vm8m"
          className="animable"
        />
        <path
          d="M314.15,42.37a24.37,24.37,0,0,1-3.48,3.85,24.37,24.37,0,0,1-3.85,3.48,26.82,26.82,0,0,1,3.48-3.85A26.82,26.82,0,0,1,314.15,42.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '310.4849853515625px 46.03499984741211px',
          }}
          id="elkwmcwszqug"
          className="animable"
        />
        <path
          d="M305.68,78a11.54,11.54,0,0,1-1.59,2c-1,1.19-2.51,2.8-4.22,4.51s-3.31,3.18-4.51,4.22a12.44,12.44,0,0,1-2,1.58,13.16,13.16,0,0,1,1.76-1.85l4.39-4.32c1.62-1.65,3.09-3.13,4.32-4.39A14.07,14.07,0,0,1,305.68,78Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '299.5199890136719px 84.1550064086914px',
          }}
          id="el1ad7fc5o79i"
          className="animable"
        />
        <path
          d="M307,69a8.67,8.67,0,0,1-1.45,1.83,51.31,51.31,0,0,1-4.06,3.9c-1.66,1.43-3.2,2.67-4.32,3.58a11.55,11.55,0,0,1-1.87,1.39,51.88,51.88,0,0,1,5.85-5.37c1.65-1.43,3.11-2.76,4.14-3.76A13.73,13.73,0,0,1,307,69Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '301.1499938964844px 74.35000228881836px',
          }}
          id="eleho507pe3q"
          className="animable"
        />
        <path
          d="M306.34,60.83a5.78,5.78,0,0,1-1.16,1.51,23.28,23.28,0,0,1-3.42,3.07c-2.91,2.07-5.12,3.9-5.22,3.8A23.62,23.62,0,0,1,301.45,65C304.3,62.9,306.21,60.71,306.34,60.83Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '301.4399871826172px 65.01960277557373px',
          }}
          id="el48t05y03zar"
          className="animable"
        />
        <path
          d="M303.58,54.05a21.18,21.18,0,0,1-3.43,3.28,21.93,21.93,0,0,1-3.77,2.88,21.39,21.39,0,0,1,3.43-3.27A21.7,21.7,0,0,1,303.58,54.05Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '299.97999572753906px 57.1299991607666px',
          }}
          id="elczr2n6kw2fd"
          className="animable"
        />
        <path
          d="M298.5,50.05a7.83,7.83,0,0,1-2.19,1.76,7.61,7.61,0,0,1-2.47,1.32A7.75,7.75,0,0,1,296,51.38,7.74,7.74,0,0,1,298.5,50.05Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '296.1699981689453px 51.58999824523926px',
          }}
          id="el31t9qj0ty4"
          className="animable"
        />
        <path
          d="M303.72,89.86a23.5,23.5,0,0,1-3.64,3.46,24.16,24.16,0,0,1-4,3.07,25,25,0,0,1,3.64-3.47A24.7,24.7,0,0,1,303.72,89.86Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '299.8999938964844px 93.12499618530273px',
          }}
          id="el6q155oldlph"
          className="animable"
        />
        <path
          d="M344.45,113.36a81.66,81.66,0,0,1-7.51,5.46,84,84,0,0,1-7.82,5,83.34,83.34,0,0,1,7.52-5.47A81.76,81.76,0,0,1,344.45,113.36Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '336.7850036621094px 118.59000778198242px',
          }}
          id="el0i83yvm8ym7p"
          className="animable"
        />
        <path
          d="M344.06,101.93a30.14,30.14,0,0,1-4.42,3.36,29.71,29.71,0,0,1-4.71,2.92,29.07,29.07,0,0,1,4.42-3.35A29.36,29.36,0,0,1,344.06,101.93Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '339.49501037597656px 105.07000350952148px',
          }}
          id="eljbzppfw6tn"
          className="animable"
        />
        <path
          d="M340.63,129.72c.07.13-2.57,1.69-5.68,3.82s-5.54,4-5.64,3.9.5-.6,1.46-1.4,2.31-1.85,3.88-2.93,3.05-2,4.14-2.55A7.18,7.18,0,0,1,340.63,129.72Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '334.9652695655823px 133.58191990852356px',
          }}
          id="el3mrxv5zipmo"
          className="animable"
        />
        <path
          d="M337.71,142.15a50.2,50.2,0,0,1-5.65,4.56,48.84,48.84,0,0,1-6,4.15,102.59,102.59,0,0,1,11.61-8.71Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '331.88499450683594px 146.50497436523438px',
          }}
          id="ela7nb33jvvtd"
          className="animable"
        />
        <path
          d="M334.05,158.07a9.19,9.19,0,0,1-1.67,1.62c-1.08.94-2.63,2.19-4.41,3.47s-3.46,2.34-4.7,3.07a8.91,8.91,0,0,1-2.07,1.06,11.28,11.28,0,0,1,1.88-1.37c1.18-.8,2.81-1.91,4.59-3.19s3.34-2.46,4.48-3.32A10.81,10.81,0,0,1,334.05,158.07Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '327.6249694824219px 162.68000030517578px',
          }}
          id="el81v6mwvr1kk"
          className="animable"
        />
        <path
          d="M330.84,171a12.71,12.71,0,0,1-2,1.86c-1.28,1.08-3.1,2.51-5.17,4s-4,2.76-5.45,3.62a12.16,12.16,0,0,1-2.39,1.28,16.6,16.6,0,0,1,2.19-1.59c1.38-.94,3.28-2.25,5.34-3.73s3.92-2.86,5.25-3.87A16.52,16.52,0,0,1,330.84,171Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '323.33497619628906px 176.37999725341797px',
          }}
          id="elcodb99dvu0h"
          className="animable"
        />
        <path
          d="M324.67,64.08a26.72,26.72,0,0,1-5.21-.26,50.4,50.4,0,0,1,10.42,0A26.64,26.64,0,0,1,324.67,64.08Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '324.67002868652344px 63.83046272397041px',
          }}
          id="el5go05kb0sco"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-1--inject-8"
        style={{ transformOrigin: '150.21500396728516px 277.68150329589844px' }}
        className="animable"
      >
        <path
          d="M108,118.54a78.28,78.28,0,0,1-4-13,27.53,27.53,0,0,1,.51-13.47c.21-.65,2.08-5.06,2.76-5,.49,0-.6,4.11-.33,4.53a23.26,23.26,0,0,1,3.19,13.49A61,61,0,0,1,108,118.54"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '106.79285860061646px 102.80470085144043px',
          }}
          id="elmwvbei7lkgd"
          className="animable"
        />
        <path
          d="M134.4,142.61c-.1-3.2-.17-5.73-.14-5.73s10.94-1.57,11.2-12.49c.13-5.28-.49-16.16-1.17-26a20.35,20.35,0,0,0-20.07-19h-1c-11.38.53-17.28,10.48-16.43,21.83l1.69,39.81,8.11,8.87a10.28,10.28,0,0,0,17.86-7.33Z"
          style={{
            fill: 'rgb(189, 140, 131)',
            transformOrigin: '126.0933837890625px 116.3172492980957px',
          }}
          id="el2muh4fuqp1l"
          className="animable"
        />
        <path
          d="M134.32,136.87a26.31,26.31,0,0,1-14.17-4.37s3.26,8.37,14.17,7.51Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '127.2350082397461px 136.28600096702576px',
          }}
          id="elw3i9s2w9tgb"
          className="animable"
        />
        <path
          d="M141.52,107.34a1.55,1.55,0,0,1-1.52,1.55,1.5,1.5,0,0,1-1.6-1.42,1.57,1.57,0,0,1,1.52-1.56A1.5,1.5,0,0,1,141.52,107.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '139.96001434326172px 107.40001773834229px',
          }}
          id="ela4r5sghek47"
          className="animable"
        />
        <path
          d="M142,102.89c-.19.2-1.36-.69-3-.71s-2.92.81-3.1.61.11-.46.65-.85a4.31,4.31,0,0,1,2.49-.73,4.13,4.13,0,0,1,2.42.81C141.89,102.43,142.06,102.8,142,102.89Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '138.92915534973145px 102.06416350603104px',
          }}
          id="elnn6s5aws57g"
          className="animable"
        />
        <path
          d="M125.88,107.51a1.55,1.55,0,0,1-1.52,1.55,1.49,1.49,0,0,1-1.59-1.42,1.56,1.56,0,0,1,1.52-1.56A1.49,1.49,0,0,1,125.88,107.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '124.32500088214874px 107.57002222537994px',
          }}
          id="ela3msk4mvdbr"
          className="animable"
        />
        <path
          d="M125.51,103.37c-.19.2-1.36-.68-3-.7s-2.92.81-3.1.6.11-.45.65-.84a4.31,4.31,0,0,1,2.49-.73,4.13,4.13,0,0,1,2.42.81C125.44,102.91,125.61,103.28,125.51,103.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '122.44711828231812px 102.54931944608688px',
          }}
          id="elmlvty3dukvl"
          className="animable"
        />
        <path
          d="M131.39,116.34a10.89,10.89,0,0,1,2.73-.46c.43,0,.83-.12.91-.41a2.22,2.22,0,0,0-.27-1.27c-.39-1-.8-2.14-1.23-3.28-1.71-4.67-2.94-8.51-2.75-8.57s1.72,3.66,3.43,8.33l1.18,3.29a2.51,2.51,0,0,1,.2,1.69,1.08,1.08,0,0,1-.71.62,3,3,0,0,1-.73.09A10.66,10.66,0,0,1,131.39,116.34Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '133.20780515670776px 109.39730501174927px',
          }}
          id="elgbmnb541pt4"
          className="animable"
        />
        <path
          d="M126,97.71c-.17.45-1.85.22-3.82.44s-3.57.74-3.82.32c-.12-.19.16-.62.81-1.06a6.44,6.44,0,0,1,2.84-1,6.34,6.34,0,0,1,3,.38C125.69,97.13,126.05,97.49,126,97.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '122.16874933242798px 97.49864995479584px',
          }}
          id="el6tlwyut1cxq"
          className="animable"
        />
        <path
          d="M141.35,97.23c-.29.39-1.45,0-2.84,0s-2.56.29-2.84-.11c-.12-.19.06-.58.57-.94a4.12,4.12,0,0,1,4.58.09C141.31,96.66,141.48,97.05,141.35,97.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '138.5131459236145px 96.46616470813751px',
          }}
          id="el4wgqk2xkdg2"
          className="animable"
        />
        <path
          d="M107.6,109.36c-.19-.09-7.48-2.31-7.33,5.16s7.62,5.78,7.63,5.56S107.6,109.36,107.6,109.36Z"
          style={{
            fill: 'rgb(189, 140, 131)',
            transformOrigin: '104.0839741230011px 114.68985366821289px',
          }}
          id="elcpb9tbzi9v"
          className="animable"
        />
        <path
          d="M105.56,117.3s-.13.09-.34.2a1.32,1.32,0,0,1-1,0,3.26,3.26,0,0,1-1.55-2.86,4.33,4.33,0,0,1,.33-1.87,1.51,1.51,0,0,1,1-1,.65.65,0,0,1,.77.34c.11.21.06.36.1.37s.16-.13.1-.44a.9.9,0,0,0-.31-.46,1,1,0,0,0-.72-.17,1.84,1.84,0,0,0-1.34,1.18,4.57,4.57,0,0,0-.41,2.09c.08,1.51.88,2.9,2,3.19a1.37,1.37,0,0,0,1.18-.22C105.55,117.48,105.59,117.31,105.56,117.3Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '103.87755870819092px 114.65926027297974px',
          }}
          id="elwrjcqok79nc"
          className="animable"
        />
        <path
          d="M139.16,86.15c1.19-.7-2.55-4.51-5.56-5.77-4.55-1.91-11.44-3-15.55-1.67-4.94,1.56-9,4.16-11.38,8.77a29.44,29.44,0,0,0-2.86,15.09A8.84,8.84,0,0,0,105,107.1c1.09,1.62,3.12,2.61,3.1,4.89a3.1,3.1,0,0,0,.84,2.25c1.41,1.42,3,0,3.77-1.39,1.56-3,1.64-6.47,1.68-9.83a21.55,21.55,0,0,0-.68-7.08c-.4-1.24-1-2.4-1.35-3.65a4.5,4.5,0,0,1,.42-3.75,5.14,5.14,0,0,1,.59-.63,7.79,7.79,0,0,1,7.68-1.69c4.25,1.36,11.5,3.38,13.33,1.89a11.54,11.54,0,0,0,3.25-3.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '121.55513763427734px 96.47597694396973px',
          }}
          id="elu642674vjj"
          className="animable"
        />
        <path
          d="M133.67,121.54c0,.12-.27.39-.89.57a4.47,4.47,0,0,1-4.52-1.57c-.38-.53-.45-.93-.34-1s1.14.95,2.71,1.47S133.56,121.26,133.67,121.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '130.77139449119568px 120.8824657201767px',
          }}
          id="eli6wm65ltk3"
          className="animable"
        />
        <path
          d="M140.48,436.09l-4.17,22.36s21.32,11.75,20.95,16l-43.64-6.54,5.08-35.11Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '135.44237518310547px 453.625px',
          }}
          id="eltd0081d9gz"
          className="animable"
        />
        <g id="elb4frf76xzod">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '135.44237518310547px 453.625px',
            }}
            className="animable"
            id="elu170mbqazwl"
          >
            <path
              d="M140.48,436.09l-4.17,22.36s21.32,11.75,20.95,16l-43.64-6.54,5.08-35.11Z"
              id="elzz8jdfhivff"
              style={{ transformOrigin: '135.44237518310547px 453.625px' }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M123.09,454.53a1.8,1.8,0,0,0-1.53,1.85,1.73,1.73,0,0,0,1.82,1.54,1.89,1.89,0,0,0,1.61-2,1.8,1.8,0,0,0-2.07-1.4"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '123.27658152580261px 456.2080172300339px',
          }}
          id="el8kux72ac4ek"
          className="animable"
        />
        <path
          d="M113.62,467.87l.65-3.52,41.6,7.59s1.82,1.14,1.39,2.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '135.4728717803955px 469.3800048828125px',
          }}
          id="elstmyrl3r5f8"
          className="animable"
        />
        <path
          d="M137.05,458.33c0,.21-1.12.15-2.27.68s-1.85,1.34-2,1.23.32-1.3,1.72-1.92S137.12,458.14,137.05,458.33Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '134.90309405326843px 459.1252855062485px',
          }}
          id="el7d7rfcuaf4"
          className="animable"
        />
        <path
          d="M141.34,460.91c0,.22-1,.44-1.82,1.23s-1.21,1.72-1.42,1.68-.16-1.27.92-2.24S141.37,460.71,141.34,460.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '139.67106461524963px 462.2996999025345px',
          }}
          id="elklb6ljwb0s"
          className="animable"
        />
        <path
          d="M143.12,466.78c-.2,0-.34-1.09.39-2.18s1.78-1.4,1.85-1.21-.65.73-1.23,1.63S143.34,466.79,143.12,466.78Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '144.16220152378082px 465.0588661432266px',
          }}
          id="elremou1wcqk"
          className="animable"
        />
        <path
          d="M137.43,453.13c-.11.18-1.05-.26-2.26-.36s-2.22.14-2.3-.06.93-.82,2.36-.68S137.56,453,137.43,453.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '135.1539900302887px 452.5912107229233px',
          }}
          id="el7alvx11oefd"
          className="animable"
        />
        <path
          d="M126.23,441.44l-.4,22.74s23,8.05,23.32,12.26l-44.13.8-.82-35.46Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '126.67499160766602px 459.3399963378906px',
          }}
          id="el1ytunxbrq7g"
          className="animable"
        />
        <path
          d="M112.15,462.52a1.81,1.81,0,0,0-1.21,2.08,1.73,1.73,0,0,0,2,1.21,1.89,1.89,0,0,0,1.27-2.21,1.78,1.78,0,0,0-2.27-1"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '112.57940256595612px 464.16595673561096px',
          }}
          id="elajs0dcxiyqo"
          className="animable"
        />
        <path
          d="M105,477.24l.06-3.58,42.29.57s2,.82,1.78,2.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '127.07345581054688px 475.4499969482422px',
          }}
          id="elkoofap6gnls"
          className="animable"
        />
        <path
          d="M126.54,463.94c0,.22-1.08.34-2.12,1.05s-1.6,1.63-1.8,1.54.1-1.33,1.38-2.17S126.59,463.74,126.54,463.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '124.55238008499146px 465.14619612693787px',
          }}
          id="elckj3h03fa4m"
          className="animable"
        />
        <path
          d="M131.21,465.77c0,.21-.88.59-1.59,1.52s-.91,1.89-1.13,1.89-.37-1.23.54-2.36S131.2,465.57,131.21,465.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '129.76646721363068px 467.4353770017624px',
          }}
          id="elwo0vpdjiwjd"
          className="animable"
        />
        <path
          d="M133.94,471.26c-.2.05-.52-1,0-2.21s1.53-1.68,1.63-1.5-.52.82-.94,1.81S134.15,471.24,133.94,471.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '134.61925983428955px 469.38730478286743px',
          }}
          id="elg5c0cd7ngfk"
          className="animable"
        />
        <path
          d="M126.06,458.75c-.09.2-1.08-.08-2.3,0s-2.16.51-2.27.33.78-1,2.22-1.07S126.16,458.58,126.06,458.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '123.7738356590271px 458.56412518024445px',
          }}
          id="eloj468rwrlqn"
          className="animable"
        />
        <path
          d="M95.11,264.84l.58,22.51,6.65,69.85s-2.12,34-3.46,53.24c-1.17,16.68,2.2,45.6,2.2,45.6l28.08-.73,7.53-96.92,4.67-60.45,9.48-31.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '122.9749984741211px 360.44000244140625px',
          }}
          id="el23n5eh4diix"
          className="animable"
        />
        <path
          d="M164.51,270l1.77,91.36A38.35,38.35,0,0,1,164,375L139.91,442.2l-1.19,4.44L121.84,443,130,264.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '144.06235122680664px 355.74000549316406px',
          }}
          id="el0e5jxg93tn9d"
          className="animable"
        />
        <path
          d="M141,286.1s0,.15,0,.44,0,.74,0,1.29c0,1.16,0,2.82,0,4.95,0,4.29-.12,10.51-.32,18.19-.45,15.36-1.48,36.56-3.34,59.92s-4,44.46-5.51,59.73c-.8,7.61-1.45,13.77-1.9,18.07-.23,2.11-.41,3.76-.53,4.91-.07.54-.12,1-.16,1.28a3.15,3.15,0,0,1-.07.43,2.91,2.91,0,0,1,0-.44c0-.32.06-.74.1-1.28.1-1.16.25-2.81.44-4.92.41-4.31,1-10.48,1.73-18.1,1.47-15.27,3.54-36.37,5.36-59.73s2.94-44.54,3.49-59.88c.25-7.68.43-13.89.49-18.19.05-2.12.09-3.78.11-4.94,0-.55,0-1,0-1.29A3,3,0,0,1,141,286.1Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '135.0808334350586px 370.70501708984375px',
          }}
          id="elo6plnlt7nw"
          className="animable"
        />
        <path
          d="M116.47,270.61a3.86,3.86,0,0,1-.09,1,16.53,16.53,0,0,1-.73,2.74A18,18,0,0,1,102,286a15.25,15.25,0,0,1-2.82.26,3.46,3.46,0,0,1-1-.08c0-.1,1.48,0,3.78-.55a18.6,18.6,0,0,0,13.42-11.37C116.18,272.07,116.37,270.59,116.47,270.61Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '107.32659816741943px 278.43861389160156px',
          }}
          id="ely8ynaoo24bd"
          className="animable"
        />
        <path
          d="M142.45,274.2a1.45,1.45,0,1,1-1.49-1.41A1.45,1.45,0,0,1,142.45,274.2Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '141.00052642822266px 274.2394300699234px',
          }}
          id="elpp86c3p57ds"
          className="animable"
        />
        <path
          d="M165.23,285a9,9,0,0,1-2-1.8,22.37,22.37,0,0,1-5.61-11.7,9.23,9.23,0,0,1-.13-2.71c.08,0,.17,1,.5,2.64a25.88,25.88,0,0,0,5.52,11.52C164.54,284.22,165.29,284.93,165.23,285Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '161.3388249874115px 276.89500427246094px',
          }}
          id="el348qox5nr76"
          className="animable"
        />
        <polygon
          points="69.87 310.56 122.3 290.54 140.4 331.54 84.98 350.85 69.87 310.56"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '105.1349983215332px 320.69500732421875px',
          }}
          id="elmzdamkilm7"
          className="animable"
        />
        <path
          d="M108.34,311.87c-2.08-1.91-4.83-4.52-4.86-5s-.75-3.65-1.39-6.42a2.63,2.63,0,0,1,2.94-3.31l3.55-1.37a22.89,22.89,0,0,0-3.23-4.84c-1.7-1.73-6.46-4.22-6.46-4.22l-.54-6.19-14.18,2.84,2,14.24s3.52,13.37,5.09,14.64,6,1.9,6,1.9c1.77,2,5.36,1.17,5.36,1.17,4,2.34,3.81-.6,3.81-.6a.85.85,0,0,0,.42.22C108.56,315.3,109.59,313,108.34,311.87Z"
          style={{
            fill: 'rgb(189, 140, 131)',
            transformOrigin: '96.53143787384033px 298.36718368530273px',
          }}
          id="elolsztw3w7zr"
          className="animable"
        />
        <path
          d="M98,302a8.1,8.1,0,0,0,.06,2.43A12.64,12.64,0,0,0,99.8,310a11.25,11.25,0,0,0,4.51,3.66,7.67,7.67,0,0,0,2.22.88,11,11,0,0,0-2-1.27,12.65,12.65,0,0,1-4.2-3.63,14.34,14.34,0,0,1-1.84-5.31A10.8,10.8,0,0,0,98,302Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '102.2329363822937px 308.2699890136719px',
          }}
          id="elzdbljxkui3b"
          className="animable"
        />
        <path
          d="M95,303.59a4.54,4.54,0,0,0-.07,2.23,16,16,0,0,0,.46,2.37,7.32,7.32,0,0,0,1.26,2.72,12.77,12.77,0,0,0,2.21,1.93l1.91,1.36a7.44,7.44,0,0,0,1.86,1.13,7.46,7.46,0,0,0-1.59-1.49c-.51-.43-1.13-.93-1.83-1.47a14.34,14.34,0,0,1-2.08-1.87A7.23,7.23,0,0,1,95.89,308a22.27,22.27,0,0,1-.58-2.26C95.05,304.43,95,303.6,95,303.59Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '98.72683334350586px 309.4599914550781px',
          }}
          id="el76bes0vnch9"
          className="animable"
        />
        <path
          d="M91.58,305.75c-.25.06.37,2.45,1.3,5.26a2.4,2.4,0,0,0,.68,1,7.89,7.89,0,0,0,.78.68,8.91,8.91,0,0,0,1.45.95c.88.46,1.5.57,1.52.49s-.51-.33-1.29-.87a14.93,14.93,0,0,1-1.31-1,8.84,8.84,0,0,1-.71-.67,1.89,1.89,0,0,1-.52-.76c-.46-1.44-.93-2.69-1.27-3.61A7.17,7.17,0,0,0,91.58,305.75Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '94.4174427986145px 309.9519753456116px',
          }}
          id="elpdc1knu5i6f"
          className="animable"
        />
        <path
          d="M146.14,154.68s12.28,6.15,17.1,13.11,13.14,19.58,13.14,19.58l11.1-28.82,16.63,7.38s-9.5,34.42-11.25,38.19c-2.44,5.22-8.23,9.89-17.3,9.34s-6.17-.31-12.13-5.89l-8-9.38Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '175.12500762939453px 184.09207725524902px',
          }}
          id="elenpe879yah"
          className="animable"
        />
        <g id="elvpxvrss23r">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '158.91498565673828px 194.8199920654297px',
            }}
            className="animable"
            id="elbuz1p8aa0ql"
          >
            <path
              d="M153.77,181.53a90.2,90.2,0,0,0,10.29,26.58,65.07,65.07,0,0,1-5.24-5.92c-1.37-1.61-3.31-3.86-3.31-3.86-.53-5.65-1.74-16.8-1.74-16.8"
              id="elw8u3oinpjrl"
              style={{
                transformOrigin: '158.91498565673828px 194.8199920654297px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M178.34,200.59a7.54,7.54,0,0,1-.51-2c-.25-1.26-.53-3-.77-5s-.38-3.71-.45-5a7.92,7.92,0,0,1,0-2.07,70.33,70.33,0,0,1,1,7C178.05,197.44,178.48,200.57,178.34,200.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '177.4545089006424px 193.55499267578125px',
          }}
          id="elprhz3b3nfbk"
          className="animable"
        />
        <path
          d="M106.66,142.8l-.62-6a2,2,0,0,1,2.34-1.9c7.1,1.51,27.88,6,28.12,7.12.15.65,0,5-.06,8.62l-29.78-7.89"
          style={{
            fill: '#95BD51',
            transformOrigin: '121.30231761932373px 142.7553334236145px',
          }}
          id="el63nv7kwkev"
          className="animable"
        />
        <path
          d="M81.3,158.55s-7.36,5.22-8.62,19.29c-.78,8.64-1.85,64.66-1.85,64.66l12,46.67,19.08-4.83-6.77-49.16.66-42.7Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '86.37000274658203px 223.85999298095703px',
          }}
          id="elwtob4dn1c8"
          className="animable"
        />
        <path
          d="M82.8,289.17a1.38,1.38,0,0,1,.33-.12l1-.28,3.79-1,13.93-3.62-.15.23c-1.44-9.84-3.34-22.88-5.42-37.16-.49-3.4-1-6.72-1.42-9.91v0c.23-13.41.44-25.2.58-33.69.1-4.2.18-7.57.23-9.94,0-1.14.07-2,.09-2.68l0-.69a1.48,1.48,0,0,1,0-.24.75.75,0,0,1,0,.24c0,.19,0,.41,0,.69,0,.65,0,1.55,0,2.68,0,2.37,0,5.75-.07,9.94-.1,8.49-.24,20.29-.4,33.7v-.05l1.43,9.91c2,14.29,3.88,27.34,5.28,37.18l0,.19-.19,0L88,288l-3.82.91-1,.22A1.45,1.45,0,0,1,82.8,289.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '92.40000534057617px 239.6202850341797px',
          }}
          id="elcs6whznpbub"
          className="animable"
        />
        <path
          d="M107.88,141.25s-22,10.86-26.58,17.3c-5.58,7.8,9.86,32.75,11,38.94.57,3,4.25,25.31,2.52,42.93a301.93,301.93,0,0,0-1.32,35.26l71-5.72c0-12.38-3.2-21.93-5.33-37.65L153.85,181l-7.71-26.35-11-4.63Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '122.29420852661133px 208.4650115966797px',
          }}
          id="eluyh3sb627l8"
          className="animable"
        />
        <path
          d="M152.55,172.38a2,2,0,0,1,.12.54c.07.42.15.94.25,1.57.21,1.36.48,3.33.8,5.77.64,4.88,1.45,11.63,2.24,19.1s1.39,14.24,1.77,19.14c.2,2.46.34,4.44.42,5.82l.08,1.58a2.11,2.11,0,0,1,0,.55,2,2,0,0,1-.1-.54c-.05-.42-.11-.94-.19-1.57-.14-1.46-.34-3.42-.59-5.8-.5-5-1.18-11.69-1.94-19.13s-1.53-14.14-2.07-19.1c-.26-2.39-.47-4.35-.62-5.8l-.15-1.57A1.83,1.83,0,0,1,152.55,172.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '155.39264678955078px 199.41500091552734px',
          }}
          id="el4py28pips0c"
          className="animable"
        />
        <path
          d="M99.1,177.6c-.11,0,0-1.47-.49-3.77a18.52,18.52,0,0,0-11.07-13.51c-2.16-.91-3.62-1.13-3.6-1.23a3.6,3.6,0,0,1,1,.1,15.52,15.52,0,0,1,2.71.76A17.78,17.78,0,0,1,99,173.76a15.23,15.23,0,0,1,.21,2.81A3.69,3.69,0,0,1,99.1,177.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '91.57613229751587px 168.34354496002197px',
          }}
          id="elne6ea9rckvm"
          className="animable"
        />
        <path
          d="M146.85,237.24a6.41,6.41,0,0,1-1.39-.19,35.94,35.94,0,0,1-3.7-.93,44.06,44.06,0,0,1-5.31-2,49.18,49.18,0,0,1-6.08-3.35,47.94,47.94,0,0,1-5.49-4.25,41.83,41.83,0,0,1-3.95-4.07,31.56,31.56,0,0,1-2.32-3,6.88,6.88,0,0,1-.74-1.19c.09-.06,1.22,1.58,3.35,4a50.23,50.23,0,0,0,4,3.95,52.46,52.46,0,0,0,5.45,4.17,54.32,54.32,0,0,0,6,3.35,51.35,51.35,0,0,0,5.21,2.09C144.91,236.76,146.87,237.14,146.85,237.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '132.3600835800171px 227.7492094039917px',
          }}
          id="el648uenjhbah"
          className="animable"
        />
        <g id="els983h3vmrmf">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '98.08450412750244px 233.79499053955078px',
            }}
            className="animable"
            id="ele6uezfho37e"
          >
            <path
              d="M95.77,192.48c-4.57,27.21-2.25,56,4.77,82.63l1.82-.14C103.84,247.43,101.11,219.54,95.77,192.48Z"
              id="el1se7hpop7b6"
              style={{
                transformOrigin: '98.08450412750244px 233.79499053955078px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elcztqeesz6gc">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '139.17500686645508px 242.57143115997314px',
            }}
            className="animable"
            id="elwozguc0gn9i"
          >
            <path
              d="M127.46,238.94a63,63,0,0,0,23.43,4.76c-1.22,1.84-3.53,2.31-5.73,2.44a18.2,18.2,0,0,1-6.45-.62c-4-1.24-8.8-3.13-11.25-6.58"
              id="elv3yinq3bjcc"
              style={{
                transformOrigin: '139.17500686645508px 242.57143115997314px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M136.24,150.53a4.63,4.63,0,0,1-1.22.22,17.65,17.65,0,0,1-3.38,0A42.16,42.16,0,0,1,120.87,148c-4.07-1.47-7.82-2.68-10.4-3.94a16.69,16.69,0,0,1-2.92-1.71,5.25,5.25,0,0,1-.69-.62c-.14-.15-.21-.23-.2-.25s.35.28,1,.7a21.13,21.13,0,0,0,3,1.55c2.58,1.16,6.33,2.31,10.41,3.78a47.91,47.91,0,0,0,10.63,2.9A39.19,39.19,0,0,0,136.24,150.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '121.44953632354736px 146.1550703048706px',
          }}
          id="el1ykpxgm59dq"
          className="animable"
        />
        <path
          d="M110.72,135.53a23.28,23.28,0,0,1,0,4.19,23.71,23.71,0,0,1-.23,4.18,13.36,13.36,0,0,1-.29-4.2A13.77,13.77,0,0,1,110.72,135.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '110.48061439394951px 139.71499633789062px',
          }}
          id="el7jigckwx07i"
          className="animable"
        />
        <path
          d="M121.17,137.85a30.88,30.88,0,0,1,.31,4.94,31.81,31.81,0,0,1,0,5,19.2,19.2,0,0,1-.55-4.93A19.27,19.27,0,0,1,121.17,137.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '121.2213114798069px 142.82000732421875px',
          }}
          id="elttz4e912kxl"
          className="animable"
        />
        <path
          d="M133.77,141a16.12,16.12,0,0,1,.43,4.86,15.47,15.47,0,0,1-.57,4.84,42.73,42.73,0,0,1,.05-4.85A41,41,0,0,1,133.77,141Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '133.9082655608654px 145.84999084472656px',
          }}
          id="els77tvqkmsle"
          className="animable"
        />
        <g id="el9hww81jjmgh">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '121.33500289916992px 146.85730695724487px',
            }}
            className="animable"
            id="eluz3c5cmy1w"
          >
            <path
              d="M107.76,142.2c1.53,2.3,3.91,3.44,6.39,4.68a47.18,47.18,0,0,0,10.06,4,19,19,0,0,0,10.7-.26c-4.71-.09-9.29-1.49-13.7-3.14s-9.08-3.58-13.4-5.29"
              id="el0z3unnzrbpnh"
              style={{
                transformOrigin: '121.33500289916992px 146.85730695724487px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M206.15,144.75l-6.24.88-.72-8.45-1.12-7.44.48-13-6.34,7.58a5.78,5.78,0,0,0-.93,2.73l-.65,22.87-.11,9.79,11.09,7L201.38,155l2.57-2.76C206.53,149.49,206.15,144.75,206.15,144.75Z"
          style={{
            fill: 'rgb(189, 140, 131)',
            transformOrigin: '198.3448371887207px 141.72500610351562px',
          }}
          id="elyg0ydeh84b"
          className="animable"
        />
        <rect
          x="204.8"
          y="105.95"
          width="25.76"
          height="69.22"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '217.68px 140.56px',
          }}
          id="eluf8xtcw0uhe"
          className="animable"
        />
        <rect
          x="197.85"
          y="105.95"
          width="25.76"
          height="69.22"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '210.73px 140.56px',
          }}
          id="elaxlgy5qb5f5"
          className="animable"
        />
        <path
          d="M215.87,122.71a5.81,5.81,0,1,1-5.81-5.81A5.81,5.81,0,0,1,215.87,122.71Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '210.05998992919922px 122.70999145507812px',
          }}
          id="elsdzpfj0stlj"
          className="animable"
        />
        <path
          d="M230.52,116.36a34.5,34.5,0,0,1-3.26,5.14,35.37,35.37,0,0,1-3.68,4.85,35.53,35.53,0,0,1,3.26-5.14A35.37,35.37,0,0,1,230.52,116.36Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.0500259399414px 121.3550033569336px',
          }}
          id="elxou35o2p4jg"
          className="animable"
        />
        <path
          d="M230.52,124a35.09,35.09,0,0,1-3.26,5.14,35.37,35.37,0,0,1-3.68,4.85,35.91,35.91,0,0,1,3.26-5.15A35.62,35.62,0,0,1,230.52,124Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.05001831054688px 128.99500274658203px',
          }}
          id="elap0aaq2skt"
          className="animable"
        />
        <path
          d="M230.52,131.68a35.71,35.71,0,0,1-3.26,5.14,34.13,34.13,0,0,1-3.68,4.84,36.81,36.81,0,0,1,3.26-5.14A35.62,35.62,0,0,1,230.52,131.68Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.0500259399414px 136.6699981689453px',
          }}
          id="el14qtbrytuyt"
          className="animable"
        />
        <path
          d="M230.52,139.34a35.71,35.71,0,0,1-3.26,5.14,34.86,34.86,0,0,1-3.68,4.84,36.81,36.81,0,0,1,3.26-5.14A34.86,34.86,0,0,1,230.52,139.34Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.05001831054688px 144.32999420166016px',
          }}
          id="elbkqif87a6q"
          className="animable"
        />
        <path
          d="M230.52,147a35.71,35.71,0,0,1-3.26,5.14,35.62,35.62,0,0,1-3.68,4.84,36.81,36.81,0,0,1,3.26-5.14A34.13,34.13,0,0,1,230.52,147Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.05001068115234px 151.99000549316406px',
          }}
          id="el4xispmawros"
          className="animable"
        />
        <path
          d="M230.52,154.65a34.5,34.5,0,0,1-3.26,5.14,35.37,35.37,0,0,1-3.68,4.85,36.81,36.81,0,0,1,3.26-5.14A35.37,35.37,0,0,1,230.52,154.65Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.05001068115234px 159.6449966430664px',
          }}
          id="el8ftzg2xt7f7"
          className="animable"
        />
        <path
          d="M230.52,162.31a34.5,34.5,0,0,1-3.26,5.14,35.37,35.37,0,0,1-3.68,4.85,35.53,35.53,0,0,1,3.26-5.14A35.37,35.37,0,0,1,230.52,162.31Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '227.05001068115234px 167.30500030517578px',
          }}
          id="elendb5m0pbkg"
          className="animable"
        />
        <path
          d="M230.45,109.61a35.71,35.71,0,0,1-3.26,5.14,34.86,34.86,0,0,1-3.68,4.84,35.71,35.71,0,0,1,3.26-5.14A35.62,35.62,0,0,1,230.45,109.61Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '226.98001098632812px 114.59999465942383px',
          }}
          id="elfpxzmtkaxo"
          className="animable"
        />
        <path
          d="M227.82,106a12.39,12.39,0,0,1-1.84,3.1,12.47,12.47,0,0,1-2.26,2.81,12.39,12.39,0,0,1,1.84-3.1A12.47,12.47,0,0,1,227.82,106Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '225.77001190185547px 108.95500183105469px',
          }}
          id="el2ix49yzrc69"
          className="animable"
        />
        <path
          d="M192.59,134.6a47.51,47.51,0,0,1,5-7.18,6.68,6.68,0,0,1,2.13-1.87,2.53,2.53,0,0,1,2.7.2,2.66,2.66,0,0,1,.45,3,10.39,10.39,0,0,1-1.94,2.59,5.27,5.27,0,0,0-1.52,2.82,8.68,8.68,0,0,0,.55,3,9.82,9.82,0,0,1-2.56,9.18"
          style={{
            fill: 'rgb(189, 140, 131)',
            transformOrigin: '197.86702823638916px 135.7957649230957px',
          }}
          id="elr4pn8mq3km"
          className="animable"
        />
        <path
          d="M197.4,146.33s.33-.41.86-1.18a9.94,9.94,0,0,0,1.53-3.58,9.66,9.66,0,0,0,.19-2.68,13.39,13.39,0,0,0-.65-3,4.79,4.79,0,0,1-.18-1.79,4.19,4.19,0,0,1,.69-1.76c.68-1.07,1.68-1.89,2.36-2.91a3.56,3.56,0,0,0,.64-1.63,2,2,0,0,0-3.21-1.87,8.72,8.72,0,0,0-2.22,2.1c-.63.76-1.2,1.48-1.7,2.15-1,1.34-1.77,2.47-2.28,3.25a8.27,8.27,0,0,1-.84,1.21,6.81,6.81,0,0,1,.65-1.32,38.08,38.08,0,0,1,2.15-3.37c.49-.69,1-1.44,1.67-2.21a8.76,8.76,0,0,1,2.32-2.25,3.26,3.26,0,0,1,1.78-.45,2.26,2.26,0,0,1,1.74.87,3.35,3.35,0,0,1-.24,3.83c-.75,1.11-1.74,1.92-2.37,2.9a3.79,3.79,0,0,0-.61,1.53,4.09,4.09,0,0,0,.15,1.59,13.2,13.2,0,0,1,.61,3.14,9.52,9.52,0,0,1-.27,2.79,9.41,9.41,0,0,1-1.74,3.63,5.31,5.31,0,0,1-.73.81Q197.42,146.34,197.4,146.33Z"
          style={{
            fill: 'rgb(137, 99, 96)',
            transformOrigin: '197.98967599868774px 135.68408393859863px',
          }}
          id="elp7s2pifxbjf"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-3--inject-8"
        style={{ transformOrigin: '353.28009033203125px 271.8878936767578px' }}
        className="animable"
      >
        <path
          d="M361.64,237.78c-1.44.8-14.86.95-14.86.95l.54,10.77L374,252.1Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '360.3900146484375px 244.94000244140625px',
          }}
          id="elojovr9d90t"
          className="animable"
        />
        <path
          d="M289.94,229.38a4.51,4.51,0,0,0-.92,2.09c0,.84,23.34,17.95,28.12,21.45a3.27,3.27,0,0,0,1.91.62l32.05,0,.17-2.55S322,230.12,321.44,230.18,289.94,229.38,289.94,229.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '320.1449890136719px 241.4600067138672px',
          }}
          id="el56tqqpjhft5"
          className="animable"
        />
        <path
          d="M321.38,231.33c-.43,0-28.29-.39-28.29-.39s21.16,15.9,24.89,18.63a2.54,2.54,0,0,0,1.48.48l29.58.57Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '321.0649871826172px 240.7800064086914px',
          }}
          id="elgxmlzql3fam"
          className="animable"
        />
        <path
          d="M346.84,240.3H344.6s-8.13-6-9-6.16c-.36-.08-6.62-.93-6.62-.93l-7,2.7s-.37,1.58,2.43,1.87a13.89,13.89,0,0,0,6-1.21s6.25,6.19,8.91,7.67,7.81,3.8,7.81,3.8Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '334.54691791534424px 240.625px',
          }}
          id="el2853i23mowp"
          className="animable"
        />
        <g id="elfua3xy6zr57">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '360.3900146484375px 244.94000244140625px',
            }}
            className="animable"
            id="elqsgp8hw0zr"
          >
            <path
              d="M361.64,237.78c-1.44.8-14.86.95-14.86.95l.54,10.77L374,252.1Z"
              id="el876tu5una6a"
              style={{
                transformOrigin: '360.3900146484375px 244.94000244140625px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M387.87,376.86l12.8,31L362.18,424c-1.32-3.77,15.5-19.49,15.5-19.49l-9-19.53Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '381.38807487487793px 400.42999267578125px',
          }}
          id="elzo81yi8gxv"
          className="animable"
        />
        <g id="ele3trp6dv4e7">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '389.10315012931824px 399.4221248626709px',
            }}
            className="animable"
            id="eltptf4yocudj"
          >
            <path
              d="M388.89,397.84a1.69,1.69,0,0,1,1.83,1.34,1.63,1.63,0,0,1-1.31,1.83,1.8,1.8,0,0,1-1.94-1.43c0-.83.75-1.83,1.58-1.75"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '389.10315012931824px 399.4221248626709px',
              }}
              id="el9j25deospyo"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M400.67,407.86l-1.3-3.13-36.49,16.66s-1.4,1.46-.7,2.59Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '381.32703018188477px 414.35498046875px',
          }}
          id="elt3m9jdqx5za"
          className="animable"
        />
        <path
          d="M377,404.56c.08.18,1.06-.13,2.24.09s2,.8,2.14.65-.59-1.11-2-1.35S376.86,404.4,377,404.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '379.19253730773926px 404.61211174726486px',
          }}
          id="el889csp4x3fg"
          className="animable"
        />
        <path
          d="M373.64,407.92c0,.2,1,.17,1.95.7s1.51,1.29,1.69,1.21-.14-1.2-1.36-1.84S373.57,407.73,373.64,407.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.48172748088837px 408.73481345176697px',
          }}
          id="el3g7rwl56xyi"
          className="animable"
        />
        <path
          d="M373.37,413.71c.19,0,.06-1.08-.86-1.91s-2-.87-2-.68.77.51,1.51,1.2S373.18,413.77,373.37,413.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.9775813817978px 412.36977684497833px',
          }}
          id="elbswtg81js1r"
          className="animable"
        />
        <path
          d="M375.42,399.88c.15.14.9-.48,2-.86s2.06-.38,2.09-.58-1-.54-2.32-.09S375.26,399.77,375.42,399.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.45283937454224px 399.0139876008034px',
          }}
          id="els2jfdkawgno"
          className="animable"
        />
        <path
          d="M374.42,394.93a3.93,3.93,0,0,0,1.92-.82,9.3,9.3,0,0,0,2.62-2.52,2.46,2.46,0,0,0,.39-.69.88.88,0,0,0-.33-1,1.12,1.12,0,0,0-1-.08,2.71,2.71,0,0,0-.68.4,7,7,0,0,0-1,.91A7.93,7.93,0,0,0,375,393a3.67,3.67,0,0,0-.48,2c.12,0,.3-.74.93-1.8a8.15,8.15,0,0,1,1.31-1.69,8.54,8.54,0,0,1,1-.81c.37-.27.71-.42.89-.29s.09.08.05.24a2,2,0,0,1-.29.51c-.25.36-.51.7-.77,1a11.19,11.19,0,0,1-1.57,1.49A15.19,15.19,0,0,0,374.42,394.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '376.9077744483948px 392.36911249160767px',
          }}
          id="elx5vlfbeycn"
          className="animable"
        />
        <path
          d="M374.78,395.09a3.3,3.3,0,0,0-.27-2.07,6.71,6.71,0,0,0-1.15-2,6.92,6.92,0,0,0-1-1,1.72,1.72,0,0,0-1.64-.45,1,1,0,0,0-.58.87,2.71,2.71,0,0,0,.1.79,4.74,4.74,0,0,0,.54,1.3,4.91,4.91,0,0,0,1.66,1.65,2.68,2.68,0,0,0,2,.5,16.62,16.62,0,0,1-1.76-.92,4.82,4.82,0,0,1-1.37-1.56,4.14,4.14,0,0,1-.43-1.13c-.11-.43-.1-.83.07-.85a1.21,1.21,0,0,1,.94.35,6.82,6.82,0,0,1,.92.85,7.35,7.35,0,0,1,1.17,1.76C374.57,394.32,374.66,395.11,374.78,395.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '372.49002981185913px 392.30355763435364px',
          }}
          id="elzk063mgz9ba"
          className="animable"
        />
        <path
          d="M345.14,389.46l11.27,31.59-39.22,14.22c-1.13-3.83,16.43-18.71,16.43-18.71l-8.05-19.94Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '336.77387046813965px 412.364990234375px',
          }}
          id="el5xux4nagm07"
          className="animable"
        />
        <g id="elwzgk1lt3p6a">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '345.2779178619385px 412.05583238601685px',
            }}
            className="animable"
            id="elb49zhnmltwn"
          >
            <path
              d="M345.14,410.46a1.71,1.71,0,0,1,1.77,1.43,1.65,1.65,0,0,1-1.4,1.77,1.81,1.81,0,0,1-1.87-1.52c0-.84.83-1.8,1.66-1.68"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '345.2779178619385px 412.05583238601685px',
              }}
              id="el3enhqqmposx"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M356.41,421.05l-1.13-3.19L318,432.72s-1.47,1.4-.83,2.55Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '336.70930099487305px 426.5649871826172px',
          }}
          id="el9ulsi33i97e"
          className="animable"
        />
        <path
          d="M332.92,416.59c.07.19,1.06-.07,2.23.2s2,.9,2.1.76-.53-1.14-1.95-1.45S332.81,416.43,332.92,416.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '335.08625745773315px 416.79322350025177px',
          }}
          id="el1heq1fro67v"
          className="animable"
        />
        <path
          d="M329.42,419.79c0,.2,1,.22,1.91.8s1.45,1.36,1.63,1.28-.08-1.2-1.27-1.89S329.36,419.6,329.42,419.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '331.21470415592194px 420.71459090709686px',
          }}
          id="elkifqugxpzbq"
          className="animable"
        />
        <path
          d="M328.87,425.56c.19,0,.11-1.08-.77-1.95s-1.92-1-1.94-.77.74.55,1.44,1.27S328.67,425.61,328.87,425.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '327.55703258514404px 424.15104949474335px',
          }}
          id="elezo2dud13pi"
          className="animable"
        />
        <path
          d="M331.58,411.84c.15.15.93-.43,2-.75s2.08-.29,2.12-.49-1-.59-2.32-.19S331.44,411.73,331.58,411.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '333.63085675239563px 411.0504283308983px',
          }}
          id="ell32l4k7dzfn"
          className="animable"
        />
        <path
          d="M330.83,406.85a4,4,0,0,0,2-.72,9.33,9.33,0,0,0,1.83-1.38,10,10,0,0,0,.91-1,2.34,2.34,0,0,0,.42-.67.88.88,0,0,0-.28-1.05,1.14,1.14,0,0,0-1-.14,3,3,0,0,0-.7.37,8.44,8.44,0,0,0-1.06.86,7.38,7.38,0,0,0-1.38,1.85,3.44,3.44,0,0,0-.58,2c.11,0,.33-.73,1-1.76a8.19,8.19,0,0,1,1.39-1.62,8.75,8.75,0,0,1,1-.76c.38-.26.73-.39.91-.24s.07.08,0,.23a2.2,2.2,0,0,1-.31.5,11.6,11.6,0,0,1-.82,1,12.21,12.21,0,0,1-1.64,1.42A15.15,15.15,0,0,0,330.83,406.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '333.4455842971802px 404.40109395980835px',
          }}
          id="elxu02b935tk"
          className="animable"
        />
        <path
          d="M331.18,407A3.29,3.29,0,0,0,331,405a7,7,0,0,0-2-3.07,1.72,1.72,0,0,0-1.61-.53,1,1,0,0,0-.63.84,3.3,3.3,0,0,0,.06.8,4.92,4.92,0,0,0,.48,1.32,4.75,4.75,0,0,0,1.58,1.72,2.69,2.69,0,0,0,2,.61,17.7,17.7,0,0,1-1.72-1,4.91,4.91,0,0,1-1.29-1.62,4.3,4.3,0,0,1-.37-1.15c-.09-.44-.06-.83.11-.84s.64.12.92.39a7.38,7.38,0,0,1,.88.89,7.81,7.81,0,0,1,1.09,1.82C331,406.25,331.06,407,331.18,407Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '329.00797057151794px 404.18332624435425px',
          }}
          id="elftx0ytlyygi"
          className="animable"
        />
        <path
          d="M360.86,120.44c-1.51,1.3-1.89,3.5-1.73,5.49s.76,3.92.8,5.91c.08,3.85-1.94,7.52-1.86,11.38s2.24,7.43,2.6,11.29c.35,3.65,4.58,6.38,3.67,9.93s-6.92,8.34-5.14,11.55a3.07,3.07,0,0,0,1.44,1.45,3.6,3.6,0,0,0,2,0l9.21-1.74a6.07,6.07,0,0,0,3.16-1.27,5.49,5.49,0,0,0,1.28-3.53c.76-7.73-1-15.45-2-23.15a109.79,109.79,0,0,1-.07-27.11"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '367.27143383026123px 149.0108413696289px',
          }}
          id="el4myq88wk71g"
          className="animable"
        />
        <path
          d="M373.37,172.49Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '373.3699951171875px 172.49000549316406px',
          }}
          id="el34yoga7rm4c"
          className="animable"
        />
        <path
          d="M361.61,130.3a17.89,17.89,0,0,1,16.82-17.7,17.37,17.37,0,0,1,18.41,17l-.42,39.16a3.34,3.34,0,0,1-.74,2.08,16,16,0,0,1-10.6,5.76A16.66,16.66,0,0,1,375,173.7a3.33,3.33,0,0,1-1.49-3l.45-8.74s0-.06-.05-.06a12.39,12.39,0,0,1-2.44-.24c-2.27-.73-8-3.4-9.37-12.18C361.61,146.6,361.52,138.42,361.61,130.3Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '379.2095355987549px 144.59100723266602px',
          }}
          id="el4shx8gy26s8"
          className="animable"
        />
        <path
          d="M373.53,144a10.17,10.17,0,0,0-2.51-.45c-.39,0-.76-.12-.83-.38a2,2,0,0,1,.27-1.15c.38-.94.77-1.92,1.19-2.95,1.64-4.21,2.84-7.67,2.66-7.73s-1.64,3.29-3.29,7.5c-.4,1-.78,2-1.14,3a2.21,2.21,0,0,0-.21,1.52,1,1,0,0,0,.65.57,2.43,2.43,0,0,0,.67.09A10.38,10.38,0,0,0,373.53,144Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '371.9729778766632px 137.7137680053711px',
          }}
          id="elnh8bgy0b8fk"
          className="animable"
        />
        <path
          d="M364,137a1.41,1.41,0,0,0,1.37,1.43,1.37,1.37,0,0,0,1.49-1.27,1.41,1.41,0,0,0-1.37-1.43A1.38,1.38,0,0,0,364,137Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '365.42999255657196px 137.08041775226593px',
          }}
          id="ely0l1bpmkmzo"
          className="animable"
        />
        <path
          d="M364.37,133.5c.16.24,1.34-.65,2.89-.53s2.58,1.13,2.77.92,0-.52-.5-1a3.41,3.41,0,0,0-4.51-.31C364.5,133,364.3,133.39,364.37,133.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '367.2294228076935px 132.8954142332077px',
          }}
          id="eliccomphl6kj"
          className="animable"
        />
        <path
          d="M378.64,137.14a1.42,1.42,0,0,0,1.37,1.43,1.38,1.38,0,0,0,1.49-1.28,1.41,1.41,0,0,0-1.37-1.42A1.38,1.38,0,0,0,378.64,137.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '380.0700184106827px 137.21997773647308px',
          }}
          id="el2392wmsse1l"
          className="animable"
        />
        <path
          d="M379.21,134c.2.22,1.34-.83,3-.93s2.94.76,3.11.52-.13-.5-.69-.91a3.9,3.9,0,0,0-4.87.33C379.27,133.53,379.11,134,379.21,134Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.27450466156006px 133.00510942935944px',
          }}
          id="eld8b2frqdzu7"
          className="animable"
        />
        <path
          d="M373.93,161.93s6,.48,13.46-3.92c0,0-2.4,7.75-13.61,6.71Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '380.5849914550781px 161.4130141735077px',
          }}
          id="elxpxs8342mz"
          className="animable"
        />
        <path
          d="M374.16,147.61a2.83,2.83,0,0,1,2.51-1,2.55,2.55,0,0,1,1.75.92,1.56,1.56,0,0,1,.11,1.81,1.9,1.9,0,0,1-2,.51,6,6,0,0,1-2-1.16,2.08,2.08,0,0,1-.44-.45.51.51,0,0,1,0-.57"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '376.385409116745px 148.26965582370758px',
          }}
          id="elh47x99gmqgd"
          className="animable"
        />
        <path
          d="M378.08,145c-.25,0-.27,1.64-1.71,2.81s-3.23,1-3.24,1.22.39.32,1.15.34a4.24,4.24,0,0,0,2.7-.93,3.56,3.56,0,0,0,1.33-2.35C378.38,145.4,378.19,145,378.08,145Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.72745013237px 147.18514442443848px',
          }}
          id="elek0f2u5tuwl"
          className="animable"
        />
        <path
          d="M378.64,128.66c.15.41,1.7.24,3.5.48s3.27.75,3.52.39c.11-.18-.14-.57-.72-1a6.21,6.21,0,0,0-5.35-.66C378.92,128.14,378.58,128.46,378.64,128.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.159282207489px 128.59858894348145px',
          }}
          id="elf5ongska7bn"
          className="animable"
        />
        <path
          d="M364.53,128.62c.29.33,1.33-.09,2.61-.19s2.37.09,2.6-.29c.1-.18-.09-.51-.58-.81a3.61,3.61,0,0,0-2.15-.44,3.69,3.69,0,0,0-2.05.82C364.53,128.09,364.4,128.46,364.53,128.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '367.12381649017334px 127.80685877799988px',
          }}
          id="elfsya7b510se"
          className="animable"
        />
        <path
          d="M377.2,110.55a5.26,5.26,0,0,1,4.13-2c6.9-.55,14.24,4.1,17.66,10.12s3,14.61-.22,20.73l-2.59.26c-5.32-.69-13.25-16.19-20.15-24.93C375.17,113.68,376.41,111.69,377.2,110.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '388.55710792541504px 124.08289337158203px',
          }}
          id="elxvf35mmgt8n"
          className="animable"
        />
        <path
          d="M363.8,114.11c3.09-3,8-6.69,13.78-4,.76,1.72-1.15,3.75-2.71,4.91-2.28,1.69-4.25,2.81-5.75,4-3.05,2.46-6.89,6.63-7.52,11.51,0,.3-.27.33-.58.26s-1.17-2.15-1.46-4.84C359,120.23,360.72,117.16,363.8,114.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '368.60363483428955px 119.99964237213135px',
          }}
          id="elr5d4bxi8ql"
          className="animable"
        />
        <path
          d="M394.7,136.46c.16-.08,6.65-2.13,6.58,4.54s-6.74,5.22-6.75,5S394.7,136.46,394.7,136.46Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '397.9050843715668px 141.1926383972168px',
          }}
          id="eld62q9san5fn"
          className="animable"
        />
        <path
          d="M396.59,143.53s.11.08.31.17a1.19,1.19,0,0,0,.87,0,2.9,2.9,0,0,0,1.35-2.57,3.73,3.73,0,0,0-.31-1.66,1.33,1.33,0,0,0-.86-.9.58.58,0,0,0-.69.31c-.09.18-.05.32-.09.33s-.14-.12-.08-.39a.72.72,0,0,1,.27-.41.85.85,0,0,1,.64-.17,1.63,1.63,0,0,1,1.2,1,4,4,0,0,1,.39,1.86,3,3,0,0,1-1.73,2.86,1.23,1.23,0,0,1-1.06-.19C396.6,143.69,396.57,143.54,396.59,143.53Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '398.0890406370163px 141.11904430389404px',
          }}
          id="elymxms2oc758"
          className="animable"
        />
        <path
          d="M313.31,169.43l-9.8,5.06-3.93-6.6a31.11,31.11,0,0,1-5.16-3.71l-3.49-4a3.63,3.63,0,0,1-.88-3.17,1.06,1.06,0,0,1,.3-.62l1-1.7s-.53-2.43-.68-4,1.14-4.34,1.14-4.34l-3.66-7.84a2,2,0,0,1,.29-2.22.87.87,0,0,1,1.22-.17c1.24.84,4.89,7.18,4.89,7.18l1.35,1.31,1.72.28s-.51-2.44.55-3l5,3.6,4.12,5.77s.82,8.34,1.92,10.57S313.31,169.43,313.31,169.43Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '300.6242046356201px 155.2167797088623px',
          }}
          id="el2qluj3gnx5n"
          className="animable"
        />
        <path
          d="M294.48,152.61a9.85,9.85,0,0,1-1.76-2.93,10.14,10.14,0,0,1-1-3.28c.1,0,.5,1.44,1.25,3.15S294.56,152.56,294.48,152.61Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '293.10265696048737px 149.5050048828125px',
          }}
          id="eln45kafdre9"
          className="animable"
        />
        <path
          d="M292.11,156.59a3.86,3.86,0,0,1-.78-1.72A5.18,5.18,0,0,1,291,153a6.08,6.08,0,0,1,.65,1.76A11.53,11.53,0,0,1,292.11,156.59Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '291.55486929416656px 154.79500579833984px',
          }}
          id="ellop8bvb98s"
          className="animable"
        />
        <path
          d="M293.67,142a16.94,16.94,0,0,1,1.16,1.58c.7,1,1.69,2.32,2.82,3.76.57.72,1.12,1.4,1.63,2a6.52,6.52,0,0,0,1.5,1.42,3.12,3.12,0,0,0,1.82.48,1,1,0,0,1-.53.11,3,3,0,0,1-1.4-.39,6.16,6.16,0,0,1-1.61-1.43c-.52-.6-1.09-1.28-1.66-2-1.14-1.44-2.1-2.81-2.76-3.83A9.29,9.29,0,0,1,293.67,142Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '298.13502502441406px 146.67619037628174px',
          }}
          id="elrwzvepq1l1a"
          className="animable"
        />
        <path
          d="M301.44,150.58c-.05,0-.15-.48-.45-1.19a7,7,0,0,0-1.75-2.44,8.34,8.34,0,0,1-1.27-1.16,2.45,2.45,0,0,1-.54-1.33,2.77,2.77,0,0,1,.07-1.3c.06,0,0,.5.15,1.26a2.46,2.46,0,0,0,.54,1.18,9.47,9.47,0,0,0,1.26,1.11,6.41,6.41,0,0,1,1.75,2.59A3.11,3.11,0,0,1,301.44,150.58Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '299.41226863861084px 146.8699951171875px',
          }}
          id="elw48wjjp8pro"
          className="animable"
        />
        <path
          d="M409.25,246.55V229.22s1.86-27,1.86-35.3-9.8-26.75-9.8-26.75l-16.06.49-11.82.26c-.12,0-19.52,18.8-19.52,18.8a55.28,55.28,0,0,0-3.3,24.32,44.41,44.41,0,0,0,1.37,6.77l4.17,16.32s2.33,10.89,3.14,14.66c.63,3,33.63,1.55,48,1.28C410.7,250,409.25,246.55,409.25,246.55Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '380.7506446838379px 208.91353607177734px',
          }}
          id="eleerzdrfhbk"
          className="animable"
        />
        <path
          d="M310.77,162s20.59,29.44,21.3,29.44,24.78-16.95,24.78-16.95,10.53-7.82,16.92-6.4S372,197.64,372,197.64s-33,18.77-44.08,19.71-25.45-43.5-25.45-43.5l-1.89-2.54Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '338.3969841003418px 189.6823558807373px',
          }}
          id="elznfynvp9uqd"
          className="animable"
        />
        <path
          d="M368.27,199.55a2.86,2.86,0,0,1-.53.33l-1.56.88-5.8,3.14-4,2.14c-.73.38-1.45.8-2.27,1.17a13.6,13.6,0,0,0-2.33,1.22,2.52,2.52,0,0,0-1.1,2.23,15.4,15.4,0,0,0,.41,2.86c.41,1.95,1,3.92,1.49,6,1.73,8.31,3.85,15.7,5.17,21.12.67,2.7,1.17,4.89,1.49,6.42.14.72.26,1.3.35,1.76a4.38,4.38,0,0,1,.09.62,2.29,2.29,0,0,1-.19-.6q-.18-.67-.45-1.74c-.4-1.57-1-3.73-1.65-6.37-1.4-5.38-3.58-12.77-5.32-21.1-.45-2-1.08-4-1.48-6a14.84,14.84,0,0,1-.4-3,3,3,0,0,1,.31-1.5,3.25,3.25,0,0,1,1-1.11l8.72-4.48,5.88-3,1.6-.79A2.13,2.13,0,0,1,368.27,199.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '359.2277660369873px 224.4949951171875px',
          }}
          id="el7y3bwda6gph"
          className="animable"
        />
        <path
          d="M331.31,202.28a16.22,16.22,0,0,1,.73-10.95c.15,0-.61,2.42-.8,5.45S331.47,202.25,331.31,202.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '331.3721646666527px 196.80499267578125px',
          }}
          id="elkaau2ko27l"
          className="animable"
        />
        <path
          d="M326.75,200.59a10.22,10.22,0,0,1,1.66-5.17,11.06,11.06,0,0,1,3.66-4,46.83,46.83,0,0,0-3.21,4.28A34.07,34.07,0,0,0,326.75,200.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '329.4100036621094px 196.00499725341797px',
          }}
          id="elg44cpb8um9i"
          className="animable"
        />
        <path
          d="M374.42,191.84c-.09,0,.22-1.23.38-3.2a23.85,23.85,0,0,0-.61-7.65,24.16,24.16,0,0,0-3-7.05c-1.07-1.67-1.9-2.58-1.83-2.65a3.26,3.26,0,0,1,.64.6,14.91,14.91,0,0,1,1.49,1.84,21.59,21.59,0,0,1,3.7,15,14.16,14.16,0,0,1-.46,2.33A3.12,3.12,0,0,1,374.42,191.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '372.35598707199097px 181.56500244140625px',
          }}
          id="el0yo2k4p6ytj"
          className="animable"
        />
        <g id="ely3nlsviaah">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '395.7790775299072px 181.55633354187012px',
            }}
            className="animable"
            id="el9htp3ohxt5"
          >
            <path
              d="M406.28,178.57c-.94-1.66-2-3.38-1.93-5.28l-20.11,4.52c-.89,2.15,0,4.71,1.62,6.4a17.72,17.72,0,0,0,5.89,3.66c2.61,1.18,5.44,2.37,8.25,1.81a12.07,12.07,0,0,0,5.12-2.81,6.74,6.74,0,0,0,2.35-2.9C408.07,182.17,407.22,180.22,406.28,178.57Z"
              id="elch7qxdli8zr"
              style={{
                transformOrigin: '395.7790775299072px 181.55633354187012px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="eld6ypw1yqlyj">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '361.33998107910156px 202.80956506729126px',
            }}
            className="animable"
            id="eluw0aj7928wi"
          >
            <path
              d="M351.8,208l-.73.86a17.39,17.39,0,0,0,20.54-12.51C364.91,201.21,359.51,205,351.8,208Z"
              id="eljjoenphq9c"
              style={{
                transformOrigin: '361.33998107910156px 202.80956506729126px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el8ez44ip50uw">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '327.6897473335266px 197.55500173568726px',
            }}
            className="animable"
            id="elailmxaa7nth"
          >
            <path
              d="M332.07,191.41c-4.15,1.58-8.27,6-8.72,10.4a2.4,2.4,0,0,0,.09,1.22,1,1,0,0,0,.95.67c.62-.06.9-.8,1.06-1.4a27.11,27.11,0,0,1,6.62-10.89Z"
              id="eliiynzv7p7ro"
              style={{
                transformOrigin: '327.6897473335266px 197.55500173568726px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M417.42,171.47a10.34,10.34,0,0,1-5-10.56c.43-2.43,1.73-4.62,2.49-7s.88-5.19-.78-7c-1-1.11-2.5-1.64-3.69-2.54a9.43,9.43,0,0,1-3.16-5c-.1-1.92,0-3.89,0-5.81a24.27,24.27,0,0,0-20.13-23l-10.5,3.79a26.81,26.81,0,0,0,6,13,57.89,57.89,0,0,1,4.67,5.49c1.31,2,2.07,4.59,1.25,6.85-.72,2-2.55,3.45-3.24,5.46-1.38,4,2.11,8.16,1.46,12.3a8.69,8.69,0,0,1-1.44,3.4,19.66,19.66,0,0,1-2.7.85,19.23,19.23,0,0,0-5.39,1.8,5.34,5.34,0,0,0-2.86,4.62,85.12,85.12,0,0,1,13.36.06c-3,4-5.3,11.28-4.41,12.17,1.17,1.17,9.58,3.18,11.24,3.31,7,.53,5.52-4.09,12.44-5A3.64,3.64,0,0,0,409,178a3.42,3.42,0,0,0,.66-3c-.24-2-.77-4-1.16-6A10.64,10.64,0,0,0,417.42,171.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '395.91001892089844px 147.1311149597168px',
          }}
          id="eliavhjkzfzxp"
          className="animable"
        />
        <path
          d="M386.1,177.69s0-.05-.05-.17a3,3,0,0,1-.1-.52,5.77,5.77,0,0,1,.11-2,10.19,10.19,0,0,1,1.24-3,35.31,35.31,0,0,1,2.44-3.48,15.62,15.62,0,0,0,2.46-4.41,6.25,6.25,0,0,0,.25-2.73,7.23,7.23,0,0,0-1.11-2.7c-.54-.87-1.19-1.72-1.75-2.68a6,6,0,0,1-.9-3.3,7.86,7.86,0,0,1,1-3.37c.55-1.05,1.2-2.05,1.77-3.09a9.06,9.06,0,0,0,1.13-6.57,16.2,16.2,0,0,0-2.48-5.88c-1.13-1.72-2.4-3.24-3.55-4.68a40.28,40.28,0,0,1-3.06-4.16,14.82,14.82,0,0,1-2.43-7,9.05,9.05,0,0,1,.14-2,4.43,4.43,0,0,1,.18-.69,14.91,14.91,0,0,0-.12,2.71,15.14,15.14,0,0,0,2.54,6.85,44.15,44.15,0,0,0,3.08,4.08,57.49,57.49,0,0,1,3.62,4.69,16.34,16.34,0,0,1,2.58,6,10.38,10.38,0,0,1,.08,3.52,10.1,10.1,0,0,1-1.25,3.4c-1.15,2.11-2.66,4-2.76,6.23a5.5,5.5,0,0,0,.83,3c.52.93,1.16,1.78,1.72,2.68a7.55,7.55,0,0,1,1.15,2.88,6.65,6.65,0,0,1-.29,2.93,15.84,15.84,0,0,1-2.57,4.5,38.36,38.36,0,0,0-2.49,3.41,10.62,10.62,0,0,0-1.29,2.88A7.53,7.53,0,0,0,386.1,177.69Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '387.1726908683777px 146.4749984741211px',
          }}
          id="elhgha35yl8dn"
          className="animable"
        />
        <path
          d="M359.64,258.35l-4.34-.28c-1.75,2.11-2.83,4.72-4.62,6.8a17,17,0,0,1-7.35,4.73,50.48,50.48,0,0,1-8.61,2,9.93,9.93,0,0,0,.38,2.72,3.34,3.34,0,0,0,1.7,2.06,4.68,4.68,0,0,0,2.52.16,47.25,47.25,0,0,0,13.14-3.67c2.27-1,4.56-2.27,5.93-4.35C360.31,265.6,360,261.81,359.64,258.35Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '347.3145999908447px 267.35628032684326px',
          }}
          id="elql2i5n391x"
          className="animable"
        />
        <path
          d="M333.29,314.18c.76.9,36.81,83.19,36.81,83.19s24.41-10.24,23.81-11.14S364.79,312,364.79,312Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '363.60544776916504px 354.68499755859375px',
          }}
          id="elmaco6k7g80o"
          className="animable"
        />
        <path
          d="M408.46,249.93l-48.62-.3-.65,10.73c-2.7,6.15-5.31,9.29-8.92,10.46-14.76,4.8-52.47,17.19-57.92,20.4-6.81,4-5.82,14.53-6.62,21.73s39.5,96.43,39.5,96.43l27.89-11.9-22.77-72.65-1.6-9.21,77.16-1.11s14.7-3.68,14.3-24.09S408.46,249.93,408.46,249.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '352.96812438964844px 329.5049819946289px',
          }}
          id="el2qihkg963rp"
          className="animable"
        />
        <path
          d="M396.21,285.38a7.09,7.09,0,0,1,.33,1.42,21.56,21.56,0,0,1,.31,4,24.47,24.47,0,0,1-13,21.48,21.93,21.93,0,0,1-3.64,1.57,6.35,6.35,0,0,1-1.41.37,47.79,47.79,0,0,0,4.87-2.26,25.1,25.1,0,0,0,12.76-21.17A48.84,48.84,0,0,0,396.21,285.38Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '387.8263168334961px 299.8000183105469px',
          }}
          id="el4yb58lcjbg"
          className="animable"
        />
        <path
          d="M360,251.17c-1-.91-4-.55-5.05.3a3.92,3.92,0,0,0-1.29,3.71,5.48,5.48,0,0,0,2.21,3.35c1.21.89,2.95,1.33,4.17.47a3.29,3.29,0,0,0,1.23-2.26,9.38,9.38,0,0,0-.11-2.64,6,6,0,0,0-.68-2.39,2,2,0,0,0-2.12-1"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '357.4529411792755px 255.0506558418274px',
          }}
          id="elgweu0b38scg"
          className="animable"
        />
        <path
          d="M410.41,249.2c3.13,7.69,6.27,15.4,8.29,23.45s2.88,16.5,1.39,24.67c-1,5.67-2.43,12.29-7.31,15.36,0,0-1.82,1.87-6,2.09-9.09.48-25.41.19-34.5-.13-4.39-.16-10,.41-14.4.25,13.25-11.57,21.05-31,18.12-48.33-.45-2.67-1.25-5.53-3.43-7.12-1.95-1.43-4.53-1.52-6.94-1.65s-3,.46-5.22.46c-3.33,0-2.86-8-.52-8.62Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '389.36099433898926px 282.112117767334px',
          }}
          id="elc2qu2xy09lw"
          className="animable"
        />
        <path
          d="M400.64,285a8.32,8.32,0,0,1-.39,1.37c-.28.87-.74,2.12-1.37,3.64a67.42,67.42,0,0,1-6.08,11.29,66.54,66.54,0,0,1-8.14,9.91c-1.17,1.16-2.15,2.06-2.85,2.65a6.88,6.88,0,0,1-1.12.88,9,9,0,0,1,1-1c.66-.63,1.6-1.57,2.72-2.75a74.85,74.85,0,0,0,14.15-21.1c.67-1.49,1.18-2.71,1.52-3.56A7.26,7.26,0,0,1,400.64,285Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '390.6650085449219px 299.87001037597656px',
          }}
          id="el8f942oeyycs"
          className="animable"
        />
        <path
          d="M405,298.27a3.87,3.87,0,0,1-.53.86c-.37.53-1,1.28-1.69,2.17a49.89,49.89,0,0,1-6.41,6.41,50.83,50.83,0,0,1-7.45,5.17c-1,.57-1.84,1-2.43,1.27a3.76,3.76,0,0,1-.94.37c0-.07,1.22-.75,3.19-2a64.79,64.79,0,0,0,7.3-5.25,64,64,0,0,0,6.47-6.25C404.05,299.34,404.93,298.22,405,298.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '395.2749786376953px 306.39417552948px',
          }}
          id="elva1nn856s1m"
          className="animable"
        />
        <path
          d="M415.06,314.65c0,.14-12.22.26-27.29.26s-27.31-.12-27.31-.26,12.23-.26,27.31-.26S415.06,314.5,415.06,314.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '387.75999450683594px 314.6499938964844px',
          }}
          id="elmpiqdvs42n"
          className="animable"
        />
        <path
          d="M388.59,265.76c-.07.07-1.24-1-3.34-2.39a35.65,35.65,0,0,0-3.85-2.19,37.73,37.73,0,0,0-5-2,36.93,36.93,0,0,0-5.29-1.12,33.36,33.36,0,0,0-4.42-.27c-2.53,0-4.09.26-4.1.17a4.15,4.15,0,0,1,1.08-.24,21.83,21.83,0,0,1,3-.3,29.77,29.77,0,0,1,4.48.17,34.12,34.12,0,0,1,5.39,1.09,34.65,34.65,0,0,1,5.11,2,30.94,30.94,0,0,1,3.85,2.32,22.7,22.7,0,0,1,2.35,1.89A4.94,4.94,0,0,1,388.59,265.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.58998107910156px 261.58120822906494px',
          }}
          id="el42l6zjii7eh"
          className="animable"
        />
        <path
          d="M395.75,262.56a10.28,10.28,0,0,1-2.35-.32c-1.44-.27-3.42-.71-5.58-1.31s-4.08-1.23-5.46-1.74a9.6,9.6,0,0,1-2.18-.94,12,12,0,0,1,2.3.59c1.4.42,3.33,1,5.48,1.59s4.1,1.09,5.52,1.45A11.17,11.17,0,0,1,395.75,262.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '387.9650115966797px 260.40501403808594px',
          }}
          id="elp3wu0q8iea8"
          className="animable"
        />
        <path
          d="M360.62,258.51a2.68,2.68,0,0,1-1.55-.68,5.11,5.11,0,0,1-2-3.52,5.17,5.17,0,0,1,1.25-3.88c.71-.8,1.35-1,1.38-1s-.5.41-1.09,1.21a5,5,0,0,0,.73,6.89C360.05,258.21,360.66,258.42,360.62,258.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '358.8346220254898px 253.97000885009766px',
          }}
          id="elfjisd094hnm"
          className="animable"
        />
        <path
          d="M357.76,255.1c0,.15-.85.12-1.74.52s-1.44,1-1.57.91.3-.94,1.36-1.39S357.8,255,357.76,255.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '356.0943742990494px 255.72089052200317px',
          }}
          id="elht3avblwa0w"
          className="animable"
        />
        <path
          d="M360.65,258.76s0,.27-.39.56a2.76,2.76,0,0,1-1.78.51,5.34,5.34,0,0,1-2.61-.85,5,5,0,0,1-2.09-2.63,4.71,4.71,0,0,1,.16-3.36,4,4,0,0,1,1.94-1.94,3.55,3.55,0,0,1,1.81-.35c.44,0,.66.14.65.17a5,5,0,0,0-2.29.51,3.76,3.76,0,0,0-1.67,1.81,4.27,4.27,0,0,0-.1,3,4.59,4.59,0,0,0,1.86,2.39,5.3,5.3,0,0,0,2.36.88,2.77,2.77,0,0,0,1.64-.31C360.49,258.94,360.61,258.73,360.65,258.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '357.0972466468811px 255.26319026947021px',
          }}
          id="elypfrg42oe89"
          className="animable"
        />
        <g id="elzlsjnuf86tg">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '379.41149616241455px 264.7926392555237px',
            }}
            className="animable"
            id="el1wcgi9oa2ux"
          >
            <path
              d="M392.27,269.72v0a8,8,0,0,0-2.44-3.29c-6.1-5.57-15.73-9.56-23.35-8.54,4.57.18,11.77,2.7,15.34,5.55a54.23,54.23,0,0,1,7.58,7.79A1.65,1.65,0,0,0,392.27,269.72Z"
              id="elaiucyquxs19"
              style={{
                transformOrigin: '379.41149616241455px 264.7926392555237px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="el1psaivcrmzkj">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '395.17433166503906px 306.7100067138672px',
            }}
            className="animable"
            id="el6xe268w424x"
          >
            <path
              d="M404.53,299c-4.68,6.32-11.82,11.75-18.76,15.42,4.09-.76,9.24-1.76,12.63-4.16C402,307.72,405,303.35,404.53,299Z"
              id="elr8f331axvqd"
              style={{
                transformOrigin: '395.17433166503906px 306.7100067138672px',
              }}
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        id="freepik--character-2--inject-8"
        style={{ transformOrigin: '268.3991928100586px 319.388671875px' }}
        className="animable"
      >
        <polygon
          points="178.76 476.64 184.7 476.55 197.82 361.33 191.97 360.65 178.76 476.64"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '188.29000091552734px 418.64500427246094px',
          }}
          id="elmjljgi7hsuh"
          className="animable"
        />
        <polygon
          points="213.58 476.64 219.52 476.55 232.64 361.33 226.79 360.65 213.58 476.64"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '223.11000061035156px 418.64500427246094px',
          }}
          id="elq9cwxkksn7"
          className="animable"
        />
        <polygon
          points="318.53 476.85 312.59 476.76 299.47 362.6 305.32 361.93 318.53 476.85"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '309px 419.38999938964844px',
          }}
          id="elmpl23j6ueb"
          className="animable"
        />
        <polygon
          points="280.24 476.85 274.3 476.76 261.18 362.6 267.03 361.93 280.24 476.85"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '270.7099914550781px 419.38999938964844px',
          }}
          id="elj0gi57arlnq"
          className="animable"
        />
        <g id="eliqimtckb3w">
          <rect
            x="188.01"
            y={368}
            width="119.84"
            height="12.42"
            style={{
              fill: 'rgb(69, 90, 100)',
              transformOrigin: '247.93px 374.21px',
              transform: 'rotate(180deg)',
            }}
            className="animable"
            id="elyk8cc6tdm"
          />
        </g>
        <polygon
          points="264.89 229.57 188.97 230.51 188.01 368 275.19 369.19 264.89 229.57"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '231.5999984741211px 299.3800048828125px',
          }}
          id="elqiropqybkfq"
          className="animable"
        />
        <path
          d="M298.89,283.37c-.39-2.65-8.34-11.44-8.34-11.44s-4-16-5.16-20.65a15.75,15.75,0,0,0-1.73-3.85,31.07,31.07,0,0,0-11.6-11.19l-11-6.18-2.63-5.85-28.26-5-5.69,6.55s-21.34,8.09-24.14,10.55c-3.43,3,6,53.34,6,53.34s-7.28,30.54-8.81,36.86.67,15.19.67,15.19l14.46-13.82c4-5,11.18-11.15,17.53-11.06l54.25.24-2.16-15.2,43.86,8.53s7.55-14.71,8.15-15S298.89,283.37,298.89,283.37Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '265.64310455322266px 280.4550018310547px',
          }}
          id="ele8kgmydsb2"
          className="animable"
        />
        <path
          d="M230.58,227c-.38-.39,3.38,12.53,7.7,24.38a58.33,58.33,0,0,1,3.5,20v42.92l26-1.76L263.9,284.2s-3.17-18.23-4-25.17c-.82-6.35-3.62-25.68-3.62-25.68S241.47,238.05,230.58,227Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '249.16673851013184px 270.64567947387695px',
          }}
          id="el4dfadh74xr6"
          className="animable"
        />
        <path
          d="M288.61,294a1.64,1.64,0,0,1,0-.66,8.85,8.85,0,0,1,.34-1.75,11.77,11.77,0,0,1,8-8,10.62,10.62,0,0,1,1.75-.34,1.64,1.64,0,0,1,.66,0c0,.08-.91.18-2.3.66a12.9,12.9,0,0,0-4.81,3,12.76,12.76,0,0,0-3,4.82C288.79,293.13,288.69,294.05,288.61,294Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '293.96821212768555px 288.60919713974px',
          }}
          id="eljdu2ph4mxip"
          className="animable"
        />
        <path
          d="M290,283.74a10.39,10.39,0,0,1,8.08-.66c0,.14-1.84-.21-4.07,0S290,283.87,290,283.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '294.0399932861328px 283.1568565964699px',
          }}
          id="el809xyx3rcp3"
          className="animable"
        />
        <g id="elu1dbkn4sqr">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '219.81500244140625px 311.97939825057983px',
            }}
            className="animable"
            id="ellxbgcjf2vqd"
          >
            <path
              d="M203.68,307.16l-2.26,2.56a18.26,18.26,0,0,0,9.17,6.06,46.46,46.46,0,0,0,11,1,15.9,15.9,0,0,0,4.47-.43c1.48-.42,2.85-1.26,4.38-1.35a11.21,11.21,0,0,1,3,.44,6,6,0,0,0,3,.05,2.41,2.41,0,0,0,1.77-2.25A160.41,160.41,0,0,0,203.68,307.16Z"
              id="elx70g8k6p74f"
              style={{
                transformOrigin: '219.81500244140625px 311.97939825057983px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M277.93,310.44l-6.38-6.78-13.13-3.32s-12,3.61-12.32,3.59-10.47-2.78-10.47-2.78l-3.55,13.06,18.33,1.25,20.94-.84s1.09-1,.45-1.71,3.5,1.18,4,1.2,1.43.4,2.08-.39C278.31,313.19,278.91,311.48,277.93,310.44Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '255.26979064941406px 307.8999938964844px',
          }}
          id="el99pmcmabick"
          className="animable"
        />
        <path
          d="M271.8,312.91a10.82,10.82,0,0,1-2.09-.59c-1.27-.41-3-.95-5-1.45s-3.78-.88-5.09-1.14a12.21,12.21,0,0,1-2.11-.49,8.79,8.79,0,0,1,2.17.16,48.63,48.63,0,0,1,5.15,1,46.92,46.92,0,0,1,5,1.59A9,9,0,0,1,271.8,312.91Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '264.6549987792969px 311.06941843032837px',
          }}
          id="elmqbyy5iref"
          className="animable"
        />
        <path
          d="M277.93,310.44a26.2,26.2,0,0,1-2.91-.94c-1.79-.6-4.28-1.34-7.06-2.11a37,37,0,0,0-7.12-1.76,16.82,16.82,0,0,0-3,.12,2.23,2.23,0,0,1,.78-.27,9.06,9.06,0,0,1,2.26-.19,31.43,31.43,0,0,1,7.23,1.64c2.77.78,5.27,1.57,7,2.26.89.34,1.59.64,2.07.86A2.6,2.6,0,0,1,277.93,310.44Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '267.88499450683594px 307.8610863685608px',
          }}
          id="el59a726dfgi2"
          className="animable"
        />
        <path
          d="M200.35,236.27s-4.65,3.06-7,12.54-12.27,48.17-10.23,54S225,314.24,225,314.24l4.72-19.89-20.21-5.53s.25-18.43.51-26.06S200.35,236.27,200.35,236.27Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '206.2827205657959px 275.25499725341797px',
          }}
          id="el8p3zg9esw7b"
          className="animable"
        />
        <polygon
          points="229.45 297.32 235.96 298.92 232.05 313.94 225.65 312.91 229.45 297.32"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '230.80500030517578px 305.6300048828125px',
          }}
          id="els3wbxd6qnu"
          className="animable"
        />
        <path
          d="M183,300.72s0,.34.1.94a4.35,4.35,0,0,0,1.39,2.26c1.73,1.61,5,2.95,9.22,3.71h0c1.91.63,4.09,1.13,6.42,1.66s4.84,1.06,7.49,1.6c5.3,1.08,11.15,2.22,17.36,3.38l-.27.17c.45-1.84.93-3.79,1.41-5.77,1.11-4.57,2.2-9,3.22-13.18l.16.27-18-5.13h0a17.51,17.51,0,0,0-7.83-1.37,17.26,17.26,0,0,0-5.92,1.38,21.26,21.26,0,0,0-3.39,1.88l-.82.6a2,2,0,0,1-.3.2l.26-.24c.18-.14.44-.37.79-.64a18.64,18.64,0,0,1,3.38-2,17.25,17.25,0,0,1,6-1.49,17.86,17.86,0,0,1,8,1.33h0l18,5,.22.06-.06.22c-1,4.19-2.09,8.61-3.2,13.18-.49,2-1,3.93-1.41,5.77l-.06.22-.21,0c-6.21-1.17-12.07-2.33-17.36-3.43-2.65-.56-5.16-1.11-7.49-1.64s-4.51-1.06-6.45-1.73h0c-4.24-.8-7.55-2.2-9.29-3.89a4.39,4.39,0,0,1-1.36-2.37A2.81,2.81,0,0,1,183,300.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '206.42477989196777px 301.82161045074463px',
          }}
          id="eldnsauuyuvu"
          className="animable"
        />
        <path
          d="M210.6,290.14c-.06.06-.73-.56-1.94-1.37a19,19,0,0,0-5.14-2.4,19.25,19.25,0,0,0-5.63-.74c-1.46,0-2.36.2-2.37.12a7.18,7.18,0,0,1,2.36-.45,16.5,16.5,0,0,1,11,3.2A7.33,7.33,0,0,1,210.6,290.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '203.06000518798828px 287.70097732543945px',
          }}
          id="ele2kgcn3xyz"
          className="animable"
        />
        <path
          d="M213.25,257.72a5.83,5.83,0,0,1,0,1.22c0,.78-.08,1.91-.19,3.3-.22,2.78-.64,6.61-1.36,10.81a76.62,76.62,0,0,1-2.51,10.61c-.22.67-.45,1.26-.65,1.78l-.58,1.3a5.59,5.59,0,0,1-.62,1.05,6.8,6.8,0,0,1,.46-1.12l.5-1.32c.17-.53.37-1.12.57-1.79A92.4,92.4,0,0,0,211.24,273c.73-4.18,1.19-8,1.5-10.76.14-1.32.25-2.42.34-3.28A6.52,6.52,0,0,1,213.25,257.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '210.31101036071777px 272.7549743652344px',
          }}
          id="eltcnhw3grvos"
          className="animable"
        />
        <path
          d="M236.33,247.53s-.1-.23-.32-.62a3.77,3.77,0,0,0-1.36-1.37,3.62,3.62,0,0,0-5.43,2.2l-.12.59-.28-.55a56.5,56.5,0,0,1-2.77-6.45,31.38,31.38,0,0,1-2-11.39,18.23,18.23,0,0,1,.16-2c.11-.59.19-1.09.29-1.49a6.14,6.14,0,0,1,.4-1.24,25.84,25.84,0,0,0-.52,4.73,33.56,33.56,0,0,0,2.16,11.26,62.7,62.7,0,0,0,2.71,6.42l-.4,0a3.95,3.95,0,0,1,6-2.32,3.63,3.63,0,0,1,1.34,1.52,2.4,2.4,0,0,1,.17.49C236.33,247.47,236.34,247.53,236.33,247.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '230.20397186279297px 236.7699966430664px',
          }}
          id="ely4841qc4vkc"
          className="animable"
        />
        <path
          d="M258.4,249.5a6.36,6.36,0,0,1-.2-1.08,11.21,11.21,0,0,1-.2-3,6.34,6.34,0,0,1,2.19-4,4.18,4.18,0,0,1,2.63-.95,3.57,3.57,0,0,1,2.77,1.24l-.4.23c-.27-.7-.56-1.42-.86-2.16-1.69-4.27-3.19-8.14-4.26-11l-1.24-3.34a7,7,0,0,1-.39-1.24,6.94,6.94,0,0,1,.56,1.18c.36.86.83,2,1.38,3.28,1.15,2.78,2.7,6.63,4.39,10.9.3.74.58,1.47.86,2.17l.55,1.39-.95-1.17a3.18,3.18,0,0,0-2.41-1.08,3.79,3.79,0,0,0-2.38.82,6.18,6.18,0,0,0-2.13,3.73,13.22,13.22,0,0,0,.05,3A4.18,4.18,0,0,1,258.4,249.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '262.07702255249023px 236.85000610351562px',
          }}
          id="elwlexluvr44b"
          className="animable"
        />
        <path
          d="M275.2,251.75c.13,0,2.17,13.74,4.57,30.74s4.23,30.79,4.1,30.81-2.17-13.74-4.57-30.74S275.07,251.76,275.2,251.75Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.5350069999695px 282.5250053405762px',
          }}
          id="elr210txv2m3o"
          className="animable"
        />
        <g id="elt9u1l7oh5xm">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '231.80500030517578px 246.00499725341797px',
            }}
            className="animable"
            id="eloxgtpky24cn"
          >
            <path
              d="M226.33,240.89a28.28,28.28,0,0,0,2.26,10.23c1-1.22,2.08-2.51,3.58-2.87,1.87-.45,3.76.71,5.11,2.11a9.33,9.33,0,0,0-1.63-3.9,4.6,4.6,0,0,0-3.59-1.88,3.19,3.19,0,0,0-3,2.47l-2.59-6.1"
              id="elrraon8l8zt"
              style={{
                transformOrigin: '231.80500030517578px 246.00499725341797px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M211,250.84c-.09,0-.06-1-.33-2.43a14.83,14.83,0,0,0-2.2-5.38,16.17,16.17,0,0,0-2.07-2.46,14.49,14.49,0,0,0-2.08-1.62c-1.27-.8-2.17-1.11-2.14-1.19s.24,0,.65.16a4.63,4.63,0,0,1,.73.28,7.39,7.39,0,0,1,.93.47,12.25,12.25,0,0,1,2.2,1.58,14.35,14.35,0,0,1,2.17,2.52,13.47,13.47,0,0,1,2.14,5.59,10.5,10.5,0,0,1,.09,1.82A2,2,0,0,1,211,250.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '206.63830089569092px 244.28430080413818px',
          }}
          id="el8naz830qy8c"
          className="animable"
        />
        <path
          d="M258,181.4a19.4,19.4,0,0,0-21.69-14.9l-1,.15c-10.64,2.17-14.73,12.41-12.27,23L230.58,227l1.45,3.88a19.67,19.67,0,0,0,24.2,2.51l.23-2.19-2.25-12s10.08-3.09,8.72-13.42C262.27,200.74,260.09,190.57,258,181.4Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '242.70164108276367px 201.36473083496094px',
          }}
          id="el2wy3szvcoeo"
          className="animable"
        />
        <path
          d="M254.29,219.11a25.25,25.25,0,0,1-14.08-2s4.25,7,14.4,4.55Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '247.40998077392578px 219.6450777053833px',
          }}
          id="elmn26iq7upzo"
          className="animable"
        />
        <path
          d="M256.34,189.26a1.49,1.49,0,0,1-1.21,1.69,1.42,1.42,0,0,1-1.7-1.11,1.49,1.49,0,0,1,1.2-1.69A1.42,1.42,0,0,1,256.34,189.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '254.8848581314087px 189.54891085624695px',
          }}
          id="elbrt5jj7nb0h"
          className="animable"
        />
        <path
          d="M240.84,191.21a1.49,1.49,0,0,1-1.2,1.69,1.42,1.42,0,0,1-1.71-1.11,1.49,1.49,0,0,1,1.2-1.69A1.42,1.42,0,0,1,240.84,191.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '239.38497734069824px 191.49998342990875px',
          }}
          id="elgy6q2glx1js"
          className="animable"
        />
        <path
          d="M240.36,188.67c-.16.22-1.43-.43-3.06-.18s-2.71,1.21-2.92,1,0-.44.51-.89a4.41,4.41,0,0,1,2.31-1.07,4.14,4.14,0,0,1,2.47.39C240.22,188.25,240.44,188.57,240.36,188.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '237.33759832382202px 188.50159287452698px',
          }}
          id="eldjllb6slzb8"
          className="animable"
        />
        <path
          d="M255.62,186.65c-.17.22-1.44-.42-3.08-.18s-2.73,1.22-2.93,1.05,0-.45.51-.89a4.41,4.41,0,0,1,2.32-1.07,4.18,4.18,0,0,1,2.48.38C255.47,186.24,255.7,186.56,255.62,186.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '252.58450174331665px 186.52551186084747px',
          }}
          id="elm26bhtxjvxs"
          className="animable"
        />
        <path
          d="M247.87,200.29a10.48,10.48,0,0,1,2.51-.83c.39-.1.77-.24.79-.52a2,2,0,0,0-.44-1.16l-1.64-2.91c-2.29-4.15-4-7.58-3.85-7.67s2.17,3.19,4.46,7.34c.56,1,1.09,2,1.59,2.93a2.38,2.38,0,0,1,.44,1.56,1,1,0,0,1-.58.69,3,3,0,0,1-.67.19A10.3,10.3,0,0,1,247.87,200.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '248.48352646827698px 193.74407577514648px',
          }}
          id="el9cfe24eaky"
          className="animable"
        />
        <path
          d="M239.48,182.54c-.13.44-1.74.35-3.59.7s-3.34,1-3.62.6c-.12-.18.12-.61.7-1.07a6.35,6.35,0,0,1,5.49-1C239.16,182,239.53,182.33,239.48,182.54Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '235.86219763755798px 182.74883711338043px',
          }}
          id="elcr0wo0ib447"
          className="animable"
        />
        <path
          d="M255.27,181c-.3.41-1.72.21-3.36.4s-3,.63-3.36.3c-.16-.17,0-.56.57-1a5.65,5.65,0,0,1,2.65-.94,5.42,5.42,0,0,1,2.76.39C255.16,180.49,255.4,180.84,255.27,181Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '251.89773845672607px 180.7701905965805px',
          }}
          id="el9ckudtly27e"
          className="animable"
        />
        <path
          d="M259.94,171.9a2,2,0,0,0-2.26-1.35,4.36,4.36,0,0,0,1.34-.89,1.43,1.43,0,0,0,.32-1.5c-.36-.77-1.4-.81-2.24-.95a5.32,5.32,0,0,1-2.91-1.48c-1.13-1.12-1.7-2.7-2.71-3.93a6.91,6.91,0,0,0-10.79.08,7.21,7.21,0,0,0-11.3,3.11A8.41,8.41,0,0,0,219,175.47l6.91,3.18a3.5,3.5,0,0,1,3.89-3.51c2,.33,3.51,2.43,5.55,2.35,1.59-.07,2.78-1.44,4.25-2,1.79-.71,3.83-.2,5.6.54a22,22,0,0,0,5.41,2,10.78,10.78,0,0,0,6.47-1.55,7,7,0,0,0,2.25-1.79A3,3,0,0,0,259.94,171.9Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '239.35397338867188px 168.94867324829102px',
          }}
          id="eldylipux1nbe"
          className="animable"
        />
        <path
          d="M226.71,175.49l29.47-3.65a13.55,13.55,0,0,0-5-4.36,23.15,23.15,0,0,0-14-2.84c-4.81.61-13.71,7.87-16.7,11.68-2.39,3.05-2,5.34-2,5.34.11,3.87,2.88,7.89,4.27,11.51.72,1.86,2.42,7.57,2.42,7.57h0c1.61-.24,2-1.61,1.55-3.18l-1.22-6.23a9.6,9.6,0,0,0,1.28-11.5C226.2,179.32,224.93,176.84,226.71,175.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '237.31819534301758px 182.6155014038086px',
          }}
          id="el4910o3u4t8j"
          className="animable"
        />
        <path
          d="M224.92,191c-2.12-5-4.16-10.48-3.17-15.86l-.88.07-.34.31a4.15,4.15,0,0,0-3.88,6.9,3.6,3.6,0,0,0-3.22,3.55,6.62,6.62,0,0,0,1.36,3.33,8.13,8.13,0,0,1,1.52,3.28,2.6,2.6,0,0,1-1.65,2.89,3,3,0,0,0,3.53,1.23,5.85,5.85,0,0,1-1.72,2.79c2.07,1.08,4.66.33,6.63-.94a5.7,5.7,0,0,0,2.64-3.09C226.13,193.93,225.51,192.38,224.92,191Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '219.64592504501343px 187.57426261901855px',
          }}
          id="elyiq2rsgax3"
          className="animable"
        />
        <path
          d="M225.15,197.1c-.18,0-7.38-1.07-6.14,5.94s8,4.33,8,4.12S225.15,197.1,225.15,197.1Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '222.93825721740723px 202.4388222694397px',
          }}
          id="elte9lvilu6pj"
          className="animable"
        />
        <path
          d="M225,204.79s-.11.11-.3.24a1.23,1.23,0,0,1-.91.18,3.05,3.05,0,0,1-1.87-2.46,3.93,3.93,0,0,1,0-1.81,1.42,1.42,0,0,1,.75-1.1.63.63,0,0,1,.78.2c.13.18.11.33.15.34s.13-.15,0-.43a.79.79,0,0,0-.35-.39,1,1,0,0,0-.71-.06,1.76,1.76,0,0,0-1.08,1.32,4.17,4.17,0,0,0-.08,2c.29,1.4,1.25,2.6,2.32,2.71a1.34,1.34,0,0,0,1.08-.38C225,205,225.05,204.8,225,204.79Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '223.15631008148193px 202.49907779693604px',
          }}
          id="ell2nwlxkx67"
          className="animable"
        />
        <path
          d="M217.13,192.11s-.23-.24-.23-.8a2.69,2.69,0,0,1,1.11-2,8.12,8.12,0,0,1,3.14-1.16,4,4,0,0,0,3-2,5.89,5.89,0,0,0,.12-3.77c-.31-1.17-.75-2.21-1-3.12a5.43,5.43,0,0,1-.31-3,13.55,13.55,0,0,0,.69,2.92c.3.88.78,1.88,1.13,3.11a6.19,6.19,0,0,1-.11,4.13,3.45,3.45,0,0,1-1.51,1.62,7.06,7.06,0,0,1-1.9.66,8.49,8.49,0,0,0-3,1,2.56,2.56,0,0,0-1.12,1.69A6.23,6.23,0,0,0,217.13,192.11Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '220.9909815788269px 184.18498992919922px',
          }}
          id="elvuwvcrexsa"
          className="animable"
        />
        <path
          d="M215.06,189.23s-.18-.18-.29-.61a3,3,0,0,1,.14-1.86,3.14,3.14,0,0,1,.72-1.11,3.63,3.63,0,0,1,1.28-.79,3.91,3.91,0,0,0,1.27-.71,1.58,1.58,0,0,0,.38-1.35c0-.54-.19-1.1-.24-1.67a8.17,8.17,0,0,1,.7-4.27,2,2,0,0,1,1.45-1.18c.47-.05.69.14.67.16s-.24-.05-.63,0a1.82,1.82,0,0,0-1.13,1.14,8,8,0,0,0-.56,2.52,8.68,8.68,0,0,0,0,1.52c0,.52.2,1.07.26,1.68a2.2,2.2,0,0,1-.55,1.79,4.17,4.17,0,0,1-1.47.79,3,3,0,0,0-1.83,1.58A4.05,4.05,0,0,0,215.06,189.23Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '217.91229438781738px 182.4508237838745px',
          }}
          id="ele3ar2gme8w7"
          className="animable"
        />
        <path
          d="M254.2,165.74a1.47,1.47,0,0,1-1.47.12,4.23,4.23,0,0,1-1.47-1,5.72,5.72,0,0,0-1.81-1.26,4.94,4.94,0,0,0-5.28,1c-.8.74-1.47,1.71-2.4,2.57a4.52,4.52,0,0,1-1.67,1,3.78,3.78,0,0,1-2,0c-1.33-.3-2.43-1-3.57-1.23a8.92,8.92,0,0,0-3.39-.21,8.79,8.79,0,0,0-5.13,2.47,9.82,9.82,0,0,0-2.18,3.26c-.34.87-.44,1.39-.49,1.38s0-.14,0-.39a7.17,7.17,0,0,1,.26-1.07,9.19,9.19,0,0,1,2.1-3.45,9.07,9.07,0,0,1,5.34-2.71,9.35,9.35,0,0,1,3.59.19c1.24.29,2.35,1,3.56,1.22a3.21,3.21,0,0,0,1.74,0,4,4,0,0,0,1.48-.9c.87-.79,1.55-1.77,2.41-2.55a5.19,5.19,0,0,1,3-1.38,5.43,5.43,0,0,1,2.82.42,6,6,0,0,1,1.87,1.39,4.18,4.18,0,0,0,1.33,1A2.09,2.09,0,0,0,254.2,165.74Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '238.75889205932617px 168.30126476287842px',
          }}
          id="elie0a9shei4i"
          className="animable"
        />
        <path
          d="M244.16,202.61c.22-.08.66,1.4,2.23,2.08s3.1.06,3.17.26-.26.39-.93.6a3.82,3.82,0,0,1-2.62-.13,3.34,3.34,0,0,1-1.77-1.78C244,203,244.06,202.63,244.16,202.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '246.8208076953888px 204.16426944732666px',
          }}
          id="elti22l5zufjo"
          className="animable"
        />
        <path
          d="M336.37,356.25a13.94,13.94,0,0,0-10-3.3l-6.12,19.45c4.49.2,9,2.51,13.29,1.32a9.46,9.46,0,0,0,6.59-7.78A11.25,11.25,0,0,0,336.37,356.25Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '330.22407150268555px 363.48809337615967px',
          }}
          id="elmzyxukv1uza"
          className="animable"
        />
        <path
          d="M326.48,352.5c0-.16.66-.28,1.85-.27a15.15,15.15,0,0,1,5,.94,13.57,13.57,0,0,1,6.1,4.74,12.44,12.44,0,0,1,2,4.22,11.08,11.08,0,0,1,.15,5.1,10.24,10.24,0,0,1-2.22,4.64,9.76,9.76,0,0,1-3.95,2.74,14,14,0,0,1-7.69.49,23,23,0,0,1-4.8-1.49c-1.08-.46-1.64-.8-1.6-1s.71-.11,1.86.08,2.78.54,4.77.72a13.68,13.68,0,0,0,6.65-.86,7.76,7.76,0,0,0,3-2.2,8.42,8.42,0,0,0,1.68-3.64,10,10,0,0,0-1.65-7.6,13.16,13.16,0,0,0-5-4.45,22.7,22.7,0,0,0-4.46-1.56C327.1,352.85,326.46,352.66,326.48,352.5Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '331.56266689300537px 363.82614517211914px',
          }}
          id="ela61r8v86ggf"
          className="animable"
        />
        <path
          d="M269.77,425.44l-13.31,37.29,46.32,16.8c1.33-4.52-19.41-22.1-19.41-22.1l9.51-23.54Z"
          style={{
            fill: '#95BD51',
            transformOrigin: '279.6506633758545px 452.48500061035156px',
          }}
          id="elzl17eii96zc"
          className="animable"
        />
        <g id="el598y23t8758">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '269.6112232208252px 452.1021100282669px',
            }}
            className="animable"
            id="elhkztomukp6"
          >
            <path
              d="M269.78,450.23a2,2,0,0,0-2.09,1.69,1.93,1.93,0,0,0,1.65,2.08,2.11,2.11,0,0,0,2.2-1.79c0-1-1-2.12-2-2"
              style={{
                fill: 'rgb(255, 255, 255)',
                transformOrigin: '269.6112232208252px 452.1021100282669px',
              }}
              id="el927wc5er4v"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M256.46,462.73l1.35-3.76,44,17.55s1.74,1.64,1,3Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '279.7266254425049px 469.2449951171875px',
          }}
          id="elrjbmdltx3r"
          className="animable"
        />
        <path
          d="M284.21,457.47c-.09.22-1.26-.08-2.63.24s-2.32,1.06-2.49.89.63-1.34,2.3-1.71S284.33,457.28,284.21,457.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '281.64272379875183px 457.70742666721344px',
          }}
          id="el0mmk330curwl"
          className="animable"
        />
        <path
          d="M288.34,461.24c0,.24-1.15.27-2.26.95s-1.71,1.61-1.93,1.52.1-1.43,1.5-2.24S288.41,461,288.34,461.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '286.2146782875061px 462.3381396532059px',
          }}
          id="ely3lfgg2xx2s"
          className="animable"
        />
        <path
          d="M289,468.06c-.22,0-.13-1.27.9-2.3s2.27-1.14,2.29-.92-.86.65-1.7,1.51S289.22,468.12,289,468.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '290.5461220741272px 466.4041907787323px',
          }}
          id="elvnpyvg64syk"
          className="animable"
        />
        <path
          d="M285.78,451.86c-.17.18-1.09-.51-2.4-.89s-2.46-.33-2.5-.57,1.2-.7,2.74-.23S286,451.73,285.78,451.86Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '283.3468556404114px 450.9280205965042px',
          }}
          id="elwpogrlsvmj"
          className="animable"
        />
        <path
          d="M286.67,446a4.69,4.69,0,0,1-2.31-.85,11,11,0,0,1-2.16-1.63,11.44,11.44,0,0,1-1.08-1.19,3.07,3.07,0,0,1-.5-.8,1.06,1.06,0,0,1,.33-1.24,1.34,1.34,0,0,1,1.18-.16,3.22,3.22,0,0,1,.83.44,8.62,8.62,0,0,1,1.26,1,8.4,8.4,0,0,1,1.63,2.18c.72,1.38.78,2.36.68,2.37s-.39-.86-1.19-2.07a9.88,9.88,0,0,0-1.64-1.92,9.22,9.22,0,0,0-1.19-.89c-.44-.31-.86-.47-1.06-.29s-.1.09-.05.28a2.5,2.5,0,0,0,.37.58,14.36,14.36,0,0,0,1,1.15,13.77,13.77,0,0,0,1.93,1.67C285.87,445.47,286.72,445.85,286.67,446Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '283.60624742507935px 443.08984661102295px',
          }}
          id="elw82zpsr32z"
          className="animable"
        />
        <path
          d="M286.26,446.19a4,4,0,0,1,.2-2.47,8,8,0,0,1,2.34-3.61,2,2,0,0,1,1.9-.64,1.16,1.16,0,0,1,.74,1,3.46,3.46,0,0,1-.07.94,5.57,5.57,0,0,1-.57,1.56,5.64,5.64,0,0,1-1.86,2c-1.34.87-2.38.8-2.37.71a19.47,19.47,0,0,0,2-1.19,5.78,5.78,0,0,0,1.53-1.91,5,5,0,0,0,.44-1.36c.11-.52.07-1-.14-1s-.75.14-1.08.47a7.21,7.21,0,0,0-1,1,8.53,8.53,0,0,0-1.29,2.16C286.46,445.26,286.39,446.2,286.26,446.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '288.79879689216614px 442.81007075309753px',
          }}
          id="elo1hdbwm9x6"
          className="animable"
        />
        <path
          d="M224.9,325.83c-7,.16-13.69,1.15-18.53,6.25-6.42,6.76-14.35,16.38-14.81,23.06-.67,10,5.35,12.95,9.75,15.38a12.21,12.21,0,0,0,6.38,1.48l81.2-.62,2.55-13.75-52.52-12.95,2.18-19.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '241.4742889404297px 348.4607963562012px',
          }}
          id="eltwyn6ohp58"
          className="animable"
        />
        <path
          d="M241.1,324.91l25.55-1.17s44.13,2.45,53.54,11.08,8.24,18.43,5.1,27.85-30.79,69.61-30.79,69.61,2.24,3.83,1,7.65a10.11,10.11,0,0,1-7.21,6.87l-24.56-9s-3.33-1.17-1-4.31,3.93-3.73,3.93-3.73v-6.27s8.62-15.69,9.41-17.85,9.05-34.08,9.05-34.08l5.5-9.45s-13.29-6.24-24.8-10.77l-26.9-6.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '283.2430725097656px 385.26995849609375px',
          }}
          id="elja7x5boti"
          className="animable"
        />
        <path
          d="M282.54,436.64c-.05.06-.83-.56-2.16-1.42a29.91,29.91,0,0,0-5.5-2.79,30.53,30.53,0,0,0-6-1.57,25.42,25.42,0,0,1-2.55-.37,9.53,9.53,0,0,1,2.59,0,24.74,24.74,0,0,1,6.09,1.46,24.33,24.33,0,0,1,5.52,3A9.72,9.72,0,0,1,282.54,436.64Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '274.4350128173828px 433.5227963924408px',
          }}
          id="el2439bdysqt2"
          className="animable"
        />
        <path
          d="M294.81,432.32a8.57,8.57,0,0,1-1.43-1.5c-.82-1-1.93-2.35-3.08-3.92s-2.15-3-2.83-4.11a9,9,0,0,1-1-1.81,8.94,8.94,0,0,1,1.29,1.62l2.93,4,3,4A10.32,10.32,0,0,1,294.81,432.32Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '290.6400146484375px 426.6500244140625px',
          }}
          id="elprujxaljii"
          className="animable"
        />
        <path
          d="M303.81,353.46a22.61,22.61,0,0,1-2.33.75,25.11,25.11,0,0,0-5.28,2.48,24.81,24.81,0,0,0-4.55,3.66c-1,1.07-1.63,1.81-1.69,1.76a8.18,8.18,0,0,1,1.44-2,20.86,20.86,0,0,1,4.55-3.83,20.5,20.5,0,0,1,5.44-2.4A8.49,8.49,0,0,1,303.81,353.46Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '296.885009765625px 357.78619718551636px',
          }}
          id="el49xif9dt90c"
          className="animable"
        />
        <path
          d="M278.69,396.1a2.13,2.13,0,0,1,.1-.54c.1-.39.22-.88.38-1.49.36-1.36.86-3.21,1.47-5.48,1.3-4.67,3.07-11,5-18,1-3.52,1.89-6.87,2.87-9.91a20.62,20.62,0,0,1,4.63-7.06,25.51,25.51,0,0,1,4.39-3.61c.56-.36,1-.64,1.32-.8a3.23,3.23,0,0,1,.48-.24s-.61.42-1.7,1.19a28.67,28.67,0,0,0-4.25,3.7,20.64,20.64,0,0,0-4.46,7c-.94,3-1.82,6.39-2.83,9.89-2,7-3.82,13.33-5.16,18l-1.62,5.44c-.18.6-.34,1.08-.46,1.47A2.22,2.22,0,0,1,278.69,396.1Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '289.01002502441406px 372.5350341796875px',
          }}
          id="el7n3vb57br7r"
          className="animable"
        />
        <path
          d="M256.09,350.1c-.13,0-.66-4.76-1.19-10.66s-.86-10.7-.73-10.71.66,4.76,1.19,10.67S256.22,350.09,256.09,350.1Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '255.1299991607666px 339.4149856567383px',
          }}
          id="elr12o8vq5tq"
          className="animable"
        />
        <path
          d="M213.58,362.86c-.07,0-.47-.74-1.27-1.87a18.49,18.49,0,0,0-3.71-3.9,18.75,18.75,0,0,0-4.68-2.66c-1.29-.5-2.14-.7-2.12-.77a6.86,6.86,0,0,1,2.23.46,15.75,15.75,0,0,1,4.86,2.6,16.14,16.14,0,0,1,3.7,4.08A7.35,7.35,0,0,1,213.58,362.86Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '207.6898317337036px 358.25999450683594px',
          }}
          id="elx7kuyo4q77e"
          className="animable"
        />
        <path
          d="M229.23,345.52c0,.07-1.13-.62-3-1.48a29.49,29.49,0,0,0-7.68-2.25,28.82,28.82,0,0,0-8,0c-2,.29-3.27.65-3.29.57a3.51,3.51,0,0,1,.84-.32,18.48,18.48,0,0,1,2.4-.58,25.78,25.78,0,0,1,15.9,2.28,19.38,19.38,0,0,1,2.14,1.23A3.25,3.25,0,0,1,229.23,345.52Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '218.24501037597656px 343.2969448566437px',
          }}
          id="elq1omaoxng8j"
          className="animable"
        />
        <path
          d="M290.39,357.61a3,3,0,0,1-.63-.1l-1.8-.39-6.62-1.49c-5.59-1.25-13.33-2.93-21.9-4.63s-16.36-3.09-22-4.06l-6.68-1.15-1.82-.33a2.68,2.68,0,0,1-.63-.14,2.87,2.87,0,0,1,.65.05l1.83.24c1.58.21,3.88.55,6.71,1,5.66.89,13.46,2.23,22.05,3.93s16.3,3.43,21.87,4.76c2.79.67,5,1.23,6.59,1.64l1.78.47A3.89,3.89,0,0,1,290.39,357.61Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '259.3500213623047px 351.463990688324px',
          }}
          id="eljobctgjjpig"
          className="animable"
        />
        <path
          d="M238.92,347c-.09,0-.28-1.07-1.12-2.59a11.69,11.69,0,0,0-1.86-2.41,30.1,30.1,0,0,0-2.84-2.45,42.61,42.61,0,0,0-5.82-3.62,18.32,18.32,0,0,1-2.48-1.41,15.8,15.8,0,0,1,2.63,1.12,33.36,33.36,0,0,1,5.95,3.53,26.1,26.1,0,0,1,2.87,2.53,10.79,10.79,0,0,1,1.84,2.55,8.91,8.91,0,0,1,.73,2A2,2,0,0,1,238.92,347Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '231.8616762161255px 340.75999450683594px',
          }}
          id="eldlpqps3s8uc"
          className="animable"
        />
        <path
          d="M329.37,359.29a42.35,42.35,0,0,0-2.31,3.56c-1.08,2.08-1.41,4-1.55,4a8.17,8.17,0,0,1,1.13-4.17A8.34,8.34,0,0,1,329.37,359.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '327.43998980522156px 363.0699920654297px',
          }}
          id="el2lr0pef4j31"
          className="animable"
        />
        <g id="elng3lw3hm1n">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '279.25179624557495px 278.17999267578125px',
            }}
            className="animable"
            id="el2h5u26y4vmm"
          >
            <path
              d="M276,257.38l5.81,40.95.29.65A87.92,87.92,0,0,0,276,257.38Z"
              id="eli5ocsgoyac"
              style={{
                transformOrigin: '279.25179624557495px 278.17999267578125px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M307.25,280.91,288.35,314l-46.57,1-.11,2.11,45.09-.33,1.43-.05,47.62.09,9.62-16.59,12.29-17.62a1.73,1.73,0,0,0-1.43-2.73l-47.53.18A1.74,1.74,0,0,0,307.25,280.91Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '299.8541946411133px 298.4949531555176px',
          }}
          id="el39g4h8nadi8"
          className="animable"
        />
        <path
          d="M345.43,300.21s2.45,2.24,2.06,4.14-.26,3.33-2.06,3.46a2.74,2.74,0,0,1-2.45,2.83s.55,3-2.92,3.5c0,0-1.07,3.2-3.26,2.42a19.42,19.42,0,0,1-3.61-1.67l-.64-1.16s-3.23-1.21-2.43-3c.48-1.11,2.15-1.4,2.15-1.4a3.13,3.13,0,0,1,.21-2.83c.77-1,3.29-.18,3.29-.18a3.52,3.52,0,0,1,.8-2.46c.85-1,4.86,1.74,4.86,1.74l2.19-2.61Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '338.7623224258423px 308.44624423980713px',
          }}
          id="el1psty8b1utq"
          className="animable"
        />
        <path
          d="M340.06,314.14a44.7,44.7,0,0,1-7.79-4.84,44.7,44.7,0,0,1,7.79,4.84Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '336.1649932861328px 311.7200164794922px',
          }}
          id="elq6h2ev6qxr"
          className="animable"
        />
        <path
          d="M343,310.64a37,37,0,0,1-7.21-4.35,19.22,19.22,0,0,1,3.73,2A18.76,18.76,0,0,1,343,310.64Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '339.39503479003906px 308.4650115966797px',
          }}
          id="elj1kkj53ugim"
          className="animable"
        />
        <path
          d="M339,304.08a13,13,0,0,1,3.3,1.76,29.09,29.09,0,0,1,3.11,2.06c-.06.16-1.62-.55-3.36-1.66A18,18,0,0,1,339,304.08Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '342.2049865722656px 306.0012152194977px',
          }}
          id="eludjqig3ildg"
          className="animable"
        />
        <path
          d="M357.73,281.11a.6.6,0,0,1-.23,0l-.67,0-2.57,0-9.46.08-31.19.07h-2.27a1.89,1.89,0,0,0-1.74.82L307.49,286c-1.4,2.51-2.74,4.93-4,7.24l-6.82,12.26L292,313.72,290.74,316l-.35.57c-.08.13-.12.2-.13.19l.09-.21.3-.6c.3-.55.7-1.31,1.21-2.27,1.08-2,2.61-4.83,4.5-8.31L303.09,293c1.28-2.31,2.61-4.74,4-7.26l2.13-3.85a2.38,2.38,0,0,1,2.13-1h2.27l31.19.07,9.46.08,2.57,0,.67,0A.6.6,0,0,1,357.73,281.11Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '323.9949951171875px 298.8218173980713px',
          }}
          id="el0rxhnlgbedc"
          className="animable"
        />
        <path
          d="M324.22,297.73a2,2,0,1,0,3-.36A2.15,2.15,0,0,0,324.22,297.73Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '325.87605929374695px 298.8850373029709px',
          }}
          id="el018akv17un5z"
          className="animable"
        />
        <path
          d="M308.71,401s0-.07.07-.21l.23-.6.95-2.3c.87-2,2.1-4.94,3.62-8.53,3.13-7.27,7.47-17.36,12.41-28.82v0a40.62,40.62,0,0,0,1.17-8.86,22.73,22.73,0,0,0-2-10.27,18.19,18.19,0,0,0-2.84-4.12,19,19,0,0,0-3.45-3.33,19.77,19.77,0,0,0-4.1-2c-1.39-.56-2.75-1.06-4.09-1.49-2.67-.88-5.21-1.56-7.54-2.11-4.66-1.1-8.5-1.69-11.15-2.07l-3.06-.4-.8-.11a1,1,0,0,1-.27-.06h.28l.8.06c.7.06,1.74.15,3.07.31A111.31,111.31,0,0,1,303.18,328c2.34.53,4.89,1.19,7.58,2.06,1.35.43,2.73.92,4.13,1.47a20.67,20.67,0,0,1,4.21,2.05,19.38,19.38,0,0,1,3.55,3.41,19.14,19.14,0,0,1,2.92,4.21,23.18,23.18,0,0,1,2.1,10.5,40.78,40.78,0,0,1-1.19,9v0l-12.57,28.75c-1.59,3.57-2.86,6.45-3.76,8.47l-1,2.27-.28.58C308.75,401,308.72,401,308.71,401Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '307.7723789215088px 363.36004638671875px',
          }}
          id="elyvt8f8xsz8n"
          className="animable"
        />
      </g>
      <g
        id="freepik--Floor--inject-8"
        style={{ transformOrigin: '255px 476.3900146484375px' }}
        className="animable"
      >
        <path
          d="M479.22,476.39c0,.14-100.39.26-224.21.26s-224.23-.12-224.23-.26,100.37-.26,224.23-.26S479.22,476.24,479.22,476.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '255px 476.3900146484375px',
          }}
          id="elpb3x1wduwb"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-8"
        style={{ transformOrigin: '182.86321258544922px 78.90929794311523px' }}
        className="animable"
      >
        <path
          d="M159.3,106.1l9.82-5.57a26.3,26.3,0,1,0-7-6.3h0Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '182.92958641052246px 78.9736213684082px',
          }}
          id="elwx0g1gwjq08"
          className="animable"
        />
        <path
          d="M159.3,106.1c.16-.69,1-4.38,2.7-11.9a.1.1,0,0,1,.12-.08l0,0h0l-.14.14a26.24,26.24,0,0,1-5.32-12.62,23.66,23.66,0,0,1-.22-4.16c0-.72.06-1.45.12-2.18s.22-1.47.34-2.22A26.51,26.51,0,0,1,167.5,56.67a26,26,0,0,1,10.16-4.45,26.78,26.78,0,0,1,11.7.31,25.79,25.79,0,0,1,10.82,5.64,26.31,26.31,0,0,1,7.24,10.13,26.73,26.73,0,0,1,1.81,11.8A26,26,0,0,1,206,90.92a26.62,26.62,0,0,1-15.37,12.48,28.31,28.31,0,0,1-8.55,1.14,26.13,26.13,0,0,1-13-3.93h.1l-9.87,5.49,9.77-5.65a.09.09,0,0,1,.1,0,26.19,26.19,0,0,0,13,3.82,28.65,28.65,0,0,0,8.45-1.16A26.44,26.44,0,0,0,199,98.65a26.13,26.13,0,0,0,6.73-7.91,25.54,25.54,0,0,0,3.14-10.67,26.63,26.63,0,0,0-1.79-11.62,26.05,26.05,0,0,0-7.14-10,25.47,25.47,0,0,0-10.65-5.56,26.52,26.52,0,0,0-11.54-.32,26,26,0,0,0-10,4.37,26.24,26.24,0,0,0-10.45,16.21c-.12.74-.23,1.47-.34,2.19s-.08,1.45-.13,2.16a24.33,24.33,0,0,0,.19,4.12,26.2,26.2,0,0,0,5.21,12.53.1.1,0,0,1,0,.14.13.13,0,0,1-.12,0h0l.16-.06C160.37,101.74,159.47,105.41,159.3,106.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '182.86321449279785px 78.90929794311523px',
          }}
          id="elrd6sll2v5a"
          className="animable"
        />
        <polygon
          points="168.07 79.46 171.85 75.69 179.12 82.16 193.41 68.41 196.91 72.18 178.59 89.43 168.07 79.46"
          style={{
            fill: '#95BD51',
            transformOrigin: '182.49000549316406px 78.92000198364258px',
          }}
          id="el7rosmp2gq3l"
          className="animable"
        />
      </g>
      <g
        id="freepik--Desk--inject-8"
        style={{ transformOrigin: '260.5450134277344px 395.3900146484375px' }}
        className="animable"
      >
        <polygon
          points="113.75 476.39 109.38 476.39 106.89 326.1 116.24 326.1 113.75 476.39"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '111.56499862670898px 401.24501037597656px',
          }}
          id="elvox8dhib09"
          className="animable"
        />
        <path
          d="M113.75,476.39s0-.27,0-.79,0-1.28,0-2.27c0-2,.06-4.94.11-8.72.11-7.58.26-18.52.45-32.09.42-27.1,1-64.63,1.66-106.43l.26.26h-9.35l.26-.26c1.21,73.49,2.14,134.67,2.28,150.3l-.05-.06,3.28,0,1.09,0-1.06,0-3.31,0h-.06v-.06c-.38-15.63-1.47-76.81-2.69-150.29v-.27h9.88v.27c-.74,41.87-1.4,79.47-1.88,106.62-.25,13.53-.46,24.46-.6,32-.08,3.75-.14,6.67-.19,8.66,0,1,0,1.72,0,2.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '111.56000137329102px 401.05003356933594px',
          }}
          id="elxwvx57fucwk"
          className="animable"
        />
        <polygon
          points="399.22 476.39 394.84 476.39 393.45 326.52 402.8 326.52 399.22 476.39"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '398.125px 401.4550018310547px',
          }}
          id="elilk4iyoiik"
          className="animable"
        />
        <path
          d="M399.22,476.39s0-.27,0-.79,0-1.28,0-2.26c0-2,.1-4.93.17-8.7.16-7.55.4-18.47.69-32,.62-27,1.47-64.45,2.43-106.13l.26.26h-9.35l.26-.26c.68,73.27,1.16,134.27,1.19,149.87l-.06-.06,3.29,0,1.09,0-1.06,0-3.32,0h0v-.06c-.26-15.6-.92-76.6-1.6-149.86v-.27h9.89v.27c-1,41.75-2,79.24-2.65,106.32-.36,13.49-.64,24.38-.84,31.92-.11,3.74-.19,6.65-.25,8.64,0,1-.05,1.71-.07,2.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '398.155029296875px 401.25999450683594px',
          }}
          id="elfvwyltnsqcm"
          className="animable"
        />
        <rect
          x="85.85"
          y="314.65"
          width="349.11"
          height="12.4"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '260.405px 320.84999999999997px',
          }}
          id="elz4twri5meu"
          className="animable"
        />
        <path
          d="M85.85,314.65l1.78,0,5.23,0,20.19,0,74.49-.08L435,314.39h.26v12.92H435l-349.11-.2h-.06v-.06c0-4.26,0-7.37,0-9.41s0-3,0-3c0,.44,0,4,.07,12.4l-.07-.07L435,326.79l-.26.26v-12.4l.26.26-247.22-.11-74.56-.08-20.25,0-5.27,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '260.5450134277344px 320.8500213623047px',
          }}
          id="elgi3ck8lrth"
          className="animable"
        />
        <path
          d="M159.81,314.83s0,.05-.11.14l-.37.37a7.5,7.5,0,0,1-1.75,1.14,11.3,11.3,0,0,1-3.37.92,29.24,29.24,0,0,1-4.71.17c-1.75-.05-3.64-.27-5.66-.53a62.4,62.4,0,0,0-6.45-.63,48.14,48.14,0,0,0-14.51,2.29c-5,1.44-9.64,3.09-14.09,4.09a47.31,47.31,0,0,1-6.43,1,32.83,32.83,0,0,1-5.7,0,22.51,22.51,0,0,1-7.83-2,11.86,11.86,0,0,1-2.42-1.47l.17.09.46.28a17.18,17.18,0,0,0,1.87,1,23,23,0,0,0,7.78,1.91,33.31,33.31,0,0,0,5.64,0,46.72,46.72,0,0,0,6.35-1.06c4.41-1,9-2.66,14-4.11a48.35,48.35,0,0,1,14.67-2.28,62,62,0,0,1,6.5.66,55.85,55.85,0,0,0,5.61.57,30.29,30.29,0,0,0,4.66-.11,11.56,11.56,0,0,0,3.33-.85A8.22,8.22,0,0,0,159.81,314.83Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '123.11000061035156px 319.3719882965088px',
          }}
          id="el8lyezlsyvz7"
          className="animable"
        />
        <path
          d="M121.62,315a7.78,7.78,0,0,1-1.06.73,24.66,24.66,0,0,1-3.18,1.67,32.42,32.42,0,0,1-5.21,1.72,34.32,34.32,0,0,1-6.81.86,31.19,31.19,0,0,1-12.16-2A7.63,7.63,0,0,1,90.26,316a3.16,3.16,0,0,1-.48-.75,1,1,0,0,1-.09-.29,7.5,7.5,0,0,0,.71,1,8,8,0,0,0,2.93,1.8,32.24,32.24,0,0,0,12,1.91,35,35,0,0,0,6.71-.82,33.24,33.24,0,0,0,5.18-1.63,32.52,32.52,0,0,0,3.23-1.56A9.58,9.58,0,0,1,121.62,315Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '105.65500259399414px 317.4800124168396px',
          }}
          id="el2vjbrjc4jn"
          className="animable"
        />
        <path
          d="M203.54,322.88l.54.16a11.84,11.84,0,0,0,1.61.34,11.44,11.44,0,0,0,6.11-.77l0,.16a16.54,16.54,0,0,0-7.57-2.4,17.4,17.4,0,0,0-9.86,2.08c-.37.22-.72.48-.76.8s.25.62.65.8a5.66,5.66,0,0,0,1.36.39l1.48.27c2,.36,4.06.72,6.2,1a46,46,0,0,0,6.59.36,29.75,29.75,0,0,0,3.39-.26c.56-.08,1.12-.17,1.68-.29a9.51,9.51,0,0,0,1.63-.43,5.37,5.37,0,0,0,2.11-1.24,1.66,1.66,0,0,0,.41-1.9,3.57,3.57,0,0,0-1.66-1.51,14.75,14.75,0,0,0-2.32-.92,38,38,0,0,0-9.69-1.63A48.62,48.62,0,0,0,188.87,320a44.7,44.7,0,0,0-10,4.42c-1.06.67-1.88,1.2-2.41,1.59l-.61.42a1.86,1.86,0,0,1-.22.14s.06-.06.19-.16l.59-.46c.5-.4,1.31-.95,2.36-1.64a42.88,42.88,0,0,1,10-4.54,48.35,48.35,0,0,1,16.68-2.17,38.42,38.42,0,0,1,9.83,1.63,15.86,15.86,0,0,1,2.39.95,3.94,3.94,0,0,1,1.83,1.68A2,2,0,0,1,219,324a6,6,0,0,1-2.29,1.35,9.9,9.9,0,0,1-1.7.45c-.56.12-1.14.21-1.71.29a30.83,30.83,0,0,1-3.44.27,45.49,45.49,0,0,1-6.67-.38c-2.15-.26-4.22-.63-6.22-1l-1.49-.28a6.11,6.11,0,0,1-1.46-.42,2,2,0,0,1-.62-.44.89.89,0,0,1-.22-.67c.07-.49.54-.79.92-1a17.7,17.7,0,0,1,10.11-2.08,16.65,16.65,0,0,1,7.69,2.5l.14.09-.16.07a11.49,11.49,0,0,1-6.24.7A8.12,8.12,0,0,1,203.54,322.88Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '197.62638473510742px 322.0600657463074px',
          }}
          id="el8j5akxgbiiq"
          className="animable"
        />
        <path
          d="M248.46,315.15a1.79,1.79,0,0,1,.34.63,3.94,3.94,0,0,1,.24,1.86c-.12,1.6-1.33,3.69-3.4,5.41a16.89,16.89,0,0,1-3.18,2.19,15.17,15.17,0,0,1-3.07,1.21,16.35,16.35,0,0,1-2.22.45,4.28,4.28,0,0,1-.83.06c0-.07,1.17-.2,2.95-.74a16.39,16.39,0,0,0,3-1.25,17.24,17.24,0,0,0,3.08-2.16,8.92,8.92,0,0,0,3.41-5.2A5.44,5.44,0,0,0,248.46,315.15Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '242.70234155654907px 321.05566930770874px',
          }}
          id="elgikm5i5654t"
          className="animable"
        />
        <path
          d="M311.15,326.4a15.3,15.3,0,0,0-1.6-1.27,12.8,12.8,0,0,0-5.46-2,14.68,14.68,0,0,0-4.16.1,22.18,22.18,0,0,1-4.87.36,10.73,10.73,0,0,1-4.85-1.93,17.89,17.89,0,0,0-4.87-2.35,21.75,21.75,0,0,0-10.83-.13,28.17,28.17,0,0,0-8,3.29,43.47,43.47,0,0,0-4.64,3.22l-1.19.95a2.78,2.78,0,0,1-.42.32s.11-.14.36-.37.63-.57,1.13-1a38.14,38.14,0,0,1,4.58-3.32,27.89,27.89,0,0,1,8.08-3.4,22,22,0,0,1,11.08.11,18.21,18.21,0,0,1,5,2.41,10.36,10.36,0,0,0,4.64,1.88,21.86,21.86,0,0,0,4.77-.33,15.27,15.27,0,0,1,4.26-.05,12.28,12.28,0,0,1,5.52,2.14A6.37,6.37,0,0,1,311.15,326.4Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '285.7050018310547px 322.5875096321106px',
          }}
          id="el9q5dj5ouwy"
          className="animable"
        />
        <path
          d="M367.12,314.77s-.12.15-.38.42a15.44,15.44,0,0,1-1.19,1.15,30.85,30.85,0,0,1-5.1,3.68,44,44,0,0,1-8.84,4,43.06,43.06,0,0,1-5.7,1.48,35.44,35.44,0,0,1-6.38.66,37.74,37.74,0,0,1-12.1-2,43.67,43.67,0,0,1-8.8-4.05,33.27,33.27,0,0,1-5.06-3.71c-.56-.47-.92-.89-1.19-1.15a2.92,2.92,0,0,1-.39-.42,2.77,2.77,0,0,1,.45.38c.3.24.68.64,1.25,1.1a36.32,36.32,0,0,0,5.12,3.6,44.33,44.33,0,0,0,8.77,3.95,37.89,37.89,0,0,0,11.95,2,36.4,36.4,0,0,0,6.28-.65,43.92,43.92,0,0,0,5.65-1.45,45.33,45.33,0,0,0,8.82-3.88,34.49,34.49,0,0,0,5.15-3.57c.58-.45.95-.85,1.25-1.1A3.08,3.08,0,0,1,367.12,314.77Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '339.5549774169922px 320.46495056152344px',
          }}
          id="el9g383pvw4tl"
          className="animable"
        />
        <path
          d="M359.13,314.65a1.33,1.33,0,0,1-.3.2c-.2.11-.5.29-.9.49-.8.42-2,1-3.5,1.61a42.59,42.59,0,0,1-5.53,1.83,29.86,29.86,0,0,1-7.2,1,35.13,35.13,0,0,1-12.8-2.63,31.06,31.06,0,0,1-3.47-1.65c-.4-.21-.68-.41-.88-.53s-.3-.19-.29-.2a10.72,10.72,0,0,1,1.26.61,38.12,38.12,0,0,0,3.51,1.55,36.46,36.46,0,0,0,12.67,2.5,29.92,29.92,0,0,0,7.09-1,46.59,46.59,0,0,0,5.51-1.74c1.52-.59,2.72-1.12,3.54-1.5A14.08,14.08,0,0,1,359.13,314.65Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '341.69467544555664px 317.2149658203125px',
          }}
          id="elki6ljlgpaf9"
          className="animable"
        />
        <path
          d="M394.62,315.92h-.4l-1.14-.06-.83-.05h-1c-.71,0-1.51,0-2.39,0l-1.39.06L386,316c-1,.07-2.13.27-3.28.43a57.91,57.91,0,0,0-7.3,1.77,55.65,55.65,0,0,0-6.84,2.73c-1,.52-1.95,1-2.78,1.48l-1.22.72-1.09.71c-.7.44-1.28.89-1.8,1.27l-.73.54-.58.48-.8.66a2.1,2.1,0,0,1-.31.22s.07-.1.24-.27l.75-.7c.17-.16.36-.32.55-.51l.71-.56c.51-.4,1.08-.86,1.78-1.32l1.07-.73,1.22-.74c.83-.53,1.8-1,2.79-1.53a54,54,0,0,1,6.88-2.78,57.16,57.16,0,0,1,7.38-1.76c1.17-.15,2.27-.34,3.32-.4l1.51-.12,1.41,0c.89,0,1.7,0,2.41,0l1,0,.82.08,1.14.12A1.39,1.39,0,0,1,394.62,315.92Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '376.94505310058594px 321.3000030517578px',
          }}
          id="el39ifob8knv4"
          className="animable"
        />
        <path
          d="M317.42,326.15a13.45,13.45,0,0,0-1.92-1.86,19.16,19.16,0,0,0-7-3.19,46.82,46.82,0,0,0-5.49-1c-2-.25-4.16-.46-6.42-.77a64.35,64.35,0,0,1-7-1.42,53.82,53.82,0,0,0-7.44-1.46,37.61,37.61,0,0,0-14.48,1.62c-2.14.64-4.09,1.41-5.9,2.15s-3.46,1.5-5,2.19c-3,1.38-5.4,2.55-7.05,3.37l-1.89.94-.5.24a.74.74,0,0,1-.18.08l.16-.11.47-.27,1.85-1c1.63-.85,4-2.06,7-3.47,1.49-.7,3.15-1.46,4.95-2.22a55.87,55.87,0,0,1,5.92-2.2,37.89,37.89,0,0,1,14.68-1.67,55,55,0,0,1,7.5,1.48,64.61,64.61,0,0,0,6.92,1.43c2.24.32,4.4.54,6.4.81a47.21,47.21,0,0,1,5.53,1,18.61,18.61,0,0,1,7.06,3.33A7.54,7.54,0,0,1,317.42,326.15Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '282.2850036621094px 321.5048522949219px',
          }}
          id="eldhff6cfz9gg"
          className="animable"
        />
        <path
          d="M238.79,314.83a2.44,2.44,0,0,1,0,.8,7.81,7.81,0,0,1-.68,2.09,12.7,12.7,0,0,1-5.37,5.57,40.24,40.24,0,0,1-7.95,3c-1.06.28-1.93.49-2.54.62a6.44,6.44,0,0,1-.95.16,3.8,3.8,0,0,1,.9-.29l2.49-.73a46.45,46.45,0,0,0,7.82-3,13.28,13.28,0,0,0,5.32-5.37A14.79,14.79,0,0,0,238.79,314.83Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '230.06150817871094px 320.9499969482422px',
          }}
          id="elrcywzoyppob"
          className="animable"
        />
        <path
          d="M157.75,327.05a5.06,5.06,0,0,1,.85-.67c.56-.41,1.41-1,2.48-1.65a76.17,76.17,0,0,1,8.91-4.66c3.62-1.62,7-2.91,9.47-3.83,1.23-.46,2.23-.82,2.93-1.06a8.9,8.9,0,0,1,1.1-.35,5.56,5.56,0,0,1-1,.47l-2.87,1.16c-2.42,1-5.78,2.31-9.4,3.92a92.16,92.16,0,0,0-8.93,4.55c-1.09.64-2,1.18-2.56,1.56A8.39,8.39,0,0,1,157.75,327.05Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '170.62000274658203px 320.9399871826172px',
          }}
          id="elpnf4gexf2xb"
          className="animable"
        />
        <path
          d="M174.19,315.34s-.8-.08-2.25,0a18.58,18.58,0,0,0-5.82,1.43,55.73,55.73,0,0,0-7.57,4.13A40.26,40.26,0,0,1,154,323.3a29.17,29.17,0,0,1-5.45,1.71,62.23,62.23,0,0,1-11.15,1.09c-3.46.08-6.56,0-9.15.11a55.73,55.73,0,0,0-6.12.48l-1.65.27a4,4,0,0,1-.57.09,2.11,2.11,0,0,1,.55-.16c.37-.09.92-.2,1.63-.33a49,49,0,0,1,6.14-.6c2.61-.12,5.72-.09,9.15-.19a62.74,62.74,0,0,0,11.06-1.1A28.94,28.94,0,0,0,153.8,323a40.64,40.64,0,0,0,4.52-2.35,53.48,53.48,0,0,1,7.66-4.09,18.36,18.36,0,0,1,6-1.35,13.31,13.31,0,0,1,1.69.05A3.35,3.35,0,0,1,174.19,315.34Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '147.0500144958496px 321.1261134147644px',
          }}
          id="el8ms9abjg3da"
          className="animable"
        />
        <path
          d="M402.83,327.05a5.06,5.06,0,0,1,.85-.67c.56-.41,1.41-1,2.48-1.65a76.75,76.75,0,0,1,8.9-4.66c3.63-1.62,7-2.91,9.48-3.83,1.23-.46,2.23-.82,2.93-1.06a7.81,7.81,0,0,1,1.1-.35,6,6,0,0,1-1,.47l-2.87,1.16c-2.42,1-5.78,2.31-9.4,3.92a92.16,92.16,0,0,0-8.93,4.55c-1.09.64-2,1.18-2.56,1.56A9.62,9.62,0,0,1,402.83,327.05Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '415.6999969482422px 320.9399871826172px',
          }}
          id="elovlg3jkdj8"
          className="animable"
        />
        <path
          d="M419.27,315.34s-.8-.08-2.25,0a18.58,18.58,0,0,0-5.82,1.43,55.73,55.73,0,0,0-7.57,4.13,40.43,40.43,0,0,1-4.56,2.39,28.83,28.83,0,0,1-5.44,1.71,62.25,62.25,0,0,1-11.16,1.09c-3.45.08-6.55,0-9.15.11a55.73,55.73,0,0,0-6.12.48l-1.64.27a4,4,0,0,1-.57.09,2.11,2.11,0,0,1,.55-.16c.37-.09.92-.2,1.63-.33a49,49,0,0,1,6.14-.6c2.61-.12,5.71-.09,9.15-.19a62.74,62.74,0,0,0,11.06-1.1,28.94,28.94,0,0,0,5.36-1.67,41.55,41.55,0,0,0,4.52-2.35,53.48,53.48,0,0,1,7.66-4.09,18.36,18.36,0,0,1,5.95-1.35,13.07,13.07,0,0,1,1.68.05A3.64,3.64,0,0,1,419.27,315.34Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '392.1299743652344px 321.1160569190979px',
          }}
          id="elv64tzdiva6"
          className="animable"
        />
        <path
          d="M391.92,314.6c0,.1-14.59.18-32.58.18s-32.59-.08-32.59-.18,14.59-.17,32.59-.17S391.92,314.5,391.92,314.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '359.33502197265625px 314.60499572753906px',
          }}
          id="ela5vfhgcqxfn"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AboutUsFour;

AboutUsFour.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
